//////// theme.js /////////
///////////////////////////

if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 ) {
!function(p) {
    "use strict";
    var f = null
      , h = null;
    !function() {
        var t, o, a, s, r, e = ["webkit", "moz", "o", "ms"], i = p.document.createElement("div"), n = -1;
        for (n = 0; n < e.length && !p.requestAnimationFrame; n++)
            p.requestAnimationFrame = p[e[n] + "RequestAnimationFrame"];
        function l() {}
        void 0 === i.nextElementSibling && Object.defineProperty(p.Element.prototype, "nextElementSibling", {
            get: function() {
                for (var t = this.nextSibling; t; ) {
                    if (1 === t.nodeType)
                        return t;
                    t = t.nextSibling
                }
                return null
            }
        }),
        (t = p.Element.prototype).matches = t.matches || t.machesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector || t.webkitMatchesSelector || function(t) {
            return -1 < Array.prototype.indexOf.call(this.parentElement.querySelectorAll(t), this)
        }
        ,
        Object.keys || (Object.keys = (r = Object.prototype.hasOwnProperty,
        o = !{
            toString: null
        }.propertyIsEnumerable("toString"),
        s = (a = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"]).length,
        function(t) {
            var e = []
              , i = ""
              , n = -1;
            if ("object" != typeof t && ("function" != typeof t || null === t))
                throw new TypeError("Object.keys called on non-object");
            for (i in t)
                r.call(t, i) && e.push(i);
            if (o)
                for (n = 0; n < s; n++)
                    r.call(t, a[n]) && e.push(a[n]);
            return e
        }
        )),
        Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t)
        }
        ),
        "function" != typeof Object.create && (Object.create = function(t, e) {
            if (t !== Object(t) && null !== t)
                throw TypeError("Argument must be an object, or null");
            l.prototype = t || {};
            var i = new l;
            return l.prototype = null,
            void 0 !== e && Object.defineProperties(i, e),
            null === t && (i.__proto__ = null),
            i
        }
        ),
        String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "")
        }
        ),
        Array.prototype.indexOf || (Array.prototype.indexOf = function(t) {
            var e, i, n, o;
            if (null === this)
                throw new TypeError;
            if (0 == (o = (n = Object(this)).length >>> 0))
                return -1;
            if (e = 0,
            1 < arguments.length && ((e = Number(arguments[1])) != e ? e = 0 : 0 !== e && e !== 1 / 0 && e !== -1 / 0 && (e = (0 < e || -1) * Math.floor(Math.abs(e)))),
            o <= e)
                return -1;
            for (i = 0 <= e ? e : Math.max(o - Math.abs(e), 0); i < o; i++)
                if (i in n && n[i] === t)
                    return i;
            return -1
        }
        ),
        Function.prototype.bind || (Function.prototype.bind = function(t) {
            var e, i, n, o;
            if ("function" != typeof this)
                throw new TypeError;
            return e = Array.prototype.slice.call(arguments, 1),
            n = function() {}
            ,
            o = function() {
                return i.apply(this instanceof n ? this : t, e.concat(Array.prototype.slice.call(arguments)))
            }
            ,
            (i = this).prototype && (n.prototype = this.prototype),
            o.prototype = new n,
            o
        }
        ),
        p.Element.prototype.dispatchEvent || (p.Element.prototype.dispatchEvent = function(t) {
            try {
                return this.fireEvent("on" + t.type, t)
            } catch (t) {}
        }
        )
    }(),
    (f = function(t, e, i) {
        var n = null
          , o = !1
          , a = null
          , s = null
          , r = null
          , l = []
          , c = ""
          , u = []
          , d = -1;
        if (r = i || p.document,
        (o = arguments[3]) && (o = "boolean" == typeof o),
        "string" == typeof t)
            u = r.querySelectorAll(t);
        else if (t && "object" == typeof t && h.isElement(t, r))
            u = [t];
        else {
            if (!t || "object" != typeof t || !t.length)
                throw new Error(f.messages.errorFactoryInvalidContainer());
            u = t
        }
        if (u.length < 1)
            throw new Error(f.messages.errorFactoryContainerNotFound());
        for (d = 0; (n = u[d]) && (!(0 < d) || o); d++)
            n.id ? c = n.id : (c = "MixItUp" + h.randomHex(),
            n.id = c),
            f.instances[c]instanceof f.Mixer ? (a = f.instances[c],
            (!e || e && e.debug && !1 !== e.debug.showWarnings) && console.warn(f.messages.warningFactoryPreexistingInstance())) : ((a = new f.Mixer).attach(n, r, c, e),
            f.instances[c] = a),
            s = new f.Facade(a),
            e && e.debug && e.debug.enable ? l.push(a) : l.push(s);
        return o ? new f.Collection(l) : l[0]
    }
    ).use = function(t) {
        f.Base.prototype.callActions.call(f, "beforeUse", arguments),
        "function" == typeof t && "mixitup-extension" === t.TYPE ? void 0 === f.extensions[t.NAME] && (t(f),
        f.extensions[t.NAME] = t) : t.fn && t.fn.jquery && (f.libraries.$ = t),
        f.Base.prototype.callActions.call(f, "afterUse", arguments)
    }
    ,
    f.instances = {},
    f.extensions = {},
    f.libraries = {},
    h = {
        hasClass: function(t, e) {
            return !!t.className.match(new RegExp("(\\s|^)" + e + "(\\s|$)"))
        },
        addClass: function(t, e) {
            this.hasClass(t, e) || (t.className += t.className ? " " + e : e)
        },
        removeClass: function(t, e) {
            if (this.hasClass(t, e)) {
                var i = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className.replace(i, " ").trim()
            }
        },
        extend: function(e, t, i, n) {
            var o = []
              , a = ""
              , s = -1;
            i = i || !1,
            n = n || !1;
            try {
                if (Array.isArray(t))
                    for (s = 0; s < t.length; s++)
                        o.push(s);
                else
                    t && (o = Object.keys(t));
                for (s = 0; s < o.length; s++)
                    a = o[s],
                    !i || "object" != typeof t[a] || this.isElement(t[a]) ? e[a] = t[a] : (Array.isArray(t[a]) ? e[a] || (e[a] = []) : e[a] || (e[a] = {}),
                    this.extend(e[a], t[a], i, n))
            } catch (t) {
                if (!n)
                    throw t;
                this.handleExtendError(t, e)
            }
            return e
        },
        handleExtendError: function(t, e) {
            var i = null
              , n = ""
              , o = ""
              , a = ""
              , s = ""
              , r = ""
              , l = -1
              , c = -1;
            if (t instanceof TypeError && (i = /property "?(\w*)"?[,:] object/i.exec(t.message))) {
                for (r in n = i[1],
                e) {
                    for (c = 0; c < n.length && n.charAt(c) === r.charAt(c); )
                        c++;
                    l < c && (l = c,
                    s = r)
                }
                throw 1 < l && (a = f.messages.errorConfigInvalidPropertySuggestion({
                    probableMatch: s
                })),
                o = f.messages.errorConfigInvalidProperty({
                    erroneous: n,
                    suggestion: a
                }),
                new TypeError(o)
            }
            throw t
        },
        template: function(n) {
            for (var t = /\${([\w]*)}/g, o = {}, e = null; e = t.exec(n); )
                o[e[1]] = new RegExp("\\${" + e[1] + "}","g");
            return function(t) {
                var e = ""
                  , i = n;
                for (e in t = t || {},
                o)
                    i = i.replace(o[e], void 0 !== t[e] ? t[e] : "");
                return i
            }
        },
        on: function(t, e, i, n) {
            t && (t.addEventListener ? t.addEventListener(e, i, n) : t.attachEvent && (t["e" + e + i] = i,
            t[e + i] = function() {
                t["e" + e + i](p.event)
            }
            ,
            t.attachEvent("on" + e, t[e + i])))
        },
        off: function(t, e, i) {
            t && (t.removeEventListener ? t.removeEventListener(e, i, !1) : t.detachEvent && (t.detachEvent("on" + e, t[e + i]),
            t[e + i] = null))
        },
        getCustomEvent: function(t, e, i) {
            var n = null;
            return i = i || p.document,
            "function" == typeof p.CustomEvent ? n = new p.CustomEvent(t,{
                detail: e,
                bubbles: !0,
                cancelable: !0
            }) : "function" == typeof i.createEvent ? (n = i.createEvent("CustomEvent")).initCustomEvent(t, !0, !0, e) : ((n = i.createEventObject()).type = t,
            n.returnValue = !1,
            n.cancelBubble = !1,
            n.detail = e),
            n
        },
        getOriginalEvent: function(t) {
            return t.touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t
        },
        index: function(t, e) {
            for (var i = 0; null !== (t = t.previousElementSibling); )
                e && !t.matches(e) || ++i;
            return i
        },
        camelCase: function(t) {
            return t.toLowerCase().replace(/([_-][a-z])/g, function(t) {
                return t.toUpperCase().replace(/[_-]/, "")
            })
        },
        pascalCase: function(t) {
            return (t = this.camelCase(t)).charAt(0).toUpperCase() + t.slice(1)
        },
        dashCase: function(t) {
            return t.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase()
        },
        isElement: function(t, e) {
            return e = e || p.document,
            !!(p.HTMLElement && t instanceof p.HTMLElement) || (!!(e.defaultView && e.defaultView.HTMLElement && t instanceof e.defaultView.HTMLElement) || null !== t && 1 === t.nodeType && "string" == typeof t.nodeName)
        },
        createElement: function(t, e) {
            var i = null
              , n = null;
            for (i = (e = e || p.document).createDocumentFragment(),
            (n = e.createElement("div")).innerHTML = t.trim(); n.firstChild; )
                i.appendChild(n.firstChild);
            return i
        },
        removeWhitespace: function(t) {
            for (var e; t && "#text" === t.nodeName; )
                t = (e = t).previousSibling,
                e.parentElement && e.parentElement.removeChild(e)
        },
        isEqualArray: function(t, e) {
            var i = t.length;
            if (i !== e.length)
                return !1;
            for (; i--; )
                if (t[i] !== e[i])
                    return !1;
            return !0
        },
        deepEquals: function(t, e) {
            var i;
            if ("object" == typeof t && t && "object" == typeof e && e) {
                if (Object.keys(t).length !== Object.keys(e).length)
                    return !1;
                for (i in t)
                    if (!e.hasOwnProperty(i) || !this.deepEquals(t[i], e[i]))
                        return !1
            } else if (t !== e)
                return !1;
            return !0
        },
        arrayShuffle: function(t) {
            for (var e = t.slice(), i = e.length, n = i, o = -1, a = []; n--; )
                o = ~~(Math.random() * i),
                a = e[n],
                e[n] = e[o],
                e[o] = a;
            return e
        },
        arrayFromList: function(e) {
            var i, n;
            try {
                return Array.prototype.slice.call(e)
            } catch (t) {
                for (i = [],
                n = 0; n < e.length; n++)
                    i.push(e[n]);
                return i
            }
        },
        debounce: function(o, a, s) {
            var r;
            return function() {
                var t, e = this, i = arguments, n = s && !r;
                t = function() {
                    r = null,
                    s || o.apply(e, i)
                }
                ,
                clearTimeout(r),
                r = setTimeout(t, a),
                n && o.apply(e, i)
            }
        },
        position: function(t) {
            for (var e = 0, i = 0, n = t; t; )
                e -= t.scrollLeft,
                i -= t.scrollTop,
                t === n && (e += t.offsetLeft,
                i += t.offsetTop,
                n = t.offsetParent),
                t = t.parentElement;
            return {
                x: e,
                y: i
            }
        },
        getHypotenuse: function(t, e) {
            var i = t.x - e.x
              , n = t.y - e.y;
            return i = i < 0 ? -1 * i : i,
            n = n < 0 ? -1 * n : n,
            Math.sqrt(Math.pow(i, 2) + Math.pow(n, 2))
        },
        getIntersectionRatio: function(t, e) {
            var i, n = t.width * t.height;
            return i = Math.max(0, Math.min(t.left + t.width, e.left + e.width) - Math.max(t.left, e.left)),
            Math.max(0, Math.min(t.top + t.height, e.top + e.height) - Math.max(t.top, e.top)) * i / n
        },
        closestParent: function(t, e, i, n) {
            var o = t.parentNode;
            if (n = n || p.document,
            i && t.matches(e))
                return t;
            for (; o && o != n.body; ) {
                if (o.matches && o.matches(e))
                    return o;
                if (!o.parentNode)
                    return null;
                o = o.parentNode
            }
            return null
        },
        children: function(t, e, i) {
            var n = []
              , o = "";
            return i = i || p.doc,
            t && (t.id || (o = "Temp" + this.randomHexKey(),
            t.id = o),
            n = i.querySelectorAll("#" + t.id + " > " + e),
            o && t.removeAttribute("id")),
            n
        },
        clean: function(t) {
            var e = []
              , i = -1;
            for (i = 0; i < t.length; i++)
                "" !== t[i] && e.push(t[i]);
            return e
        },
        defer: function(t) {
            var e = null
              , i = null
              , n = null;
            return i = new this.Deferred,
            f.features.has.promises ? i.promise = new Promise(function(t, e) {
                i.resolve = t,
                i.reject = e
            }
            ) : (n = p.jQuery || t.$) && "function" == typeof n.Deferred ? (e = n.Deferred(),
            i.promise = e.promise(),
            i.resolve = e.resolve,
            i.reject = e.reject) : p.console && console.warn(f.messages.warningNoPromiseImplementation()),
            i
        },
        all: function(t, e) {
            var i = null;
            return f.features.has.promises ? Promise.all(t) : (i = p.jQuery || e.$) && "function" == typeof i.when ? i.when.apply(i, t).done(function() {
                return arguments
            }) : (p.console && console.warn(f.messages.warningNoPromiseImplementation()),
            [])
        },
        getPrefix: function(t, e, i) {
            var n = -1
              , o = "";
            if (h.dashCase(e)in t.style)
                return "";
            for (n = 0; o = i[n]; n++)
                if (o + e in t.style)
                    return o.toLowerCase();
            return "unsupported"
        },
        randomHex: function() {
            return ("00000" + (16777216 * Math.random() << 0).toString(16)).substr(-6).toUpperCase()
        },
        getDocumentState: function(t) {
            return t = "object" == typeof t.body ? t : p.document,
            {
                scrollTop: p.pageYOffset,
                scrollLeft: p.pageXOffset,
                docHeight: t.documentElement.scrollHeight,
                docWidth: t.documentElement.scrollWidth,
                viewportHeight: t.documentElement.clientHeight,
                viewportWidth: t.documentElement.clientWidth
            }
        },
        bind: function(t, e) {
            return function() {
                return e.apply(t, arguments)
            }
        },
        isVisible: function(t) {
            var e;
            return !!t.offsetParent || "fixed" === (e = p.getComputedStyle(t)).position && "hidden" !== e.visibility && "0" !== e.opacity
        },
        seal: function(t) {
            "function" == typeof Object.seal && Object.seal(t)
        },
        freeze: function(t) {
            "function" == typeof Object.freeze && Object.freeze(t)
        },
        compareVersions: function(t, e) {
            var i = t.split(".")
              , n = e.split(".")
              , o = -1
              , a = -1
              , s = -1;
            for (s = 0; s < i.length; s++) {
                if (o = parseInt(i[s].replace(/[^\d.]/g, "")),
                (a = parseInt(n[s].replace(/[^\d.]/g, "") || 0)) < o)
                    return !1;
                if (o < a)
                    return !0
            }
            return !0
        },
        Deferred: function() {
            this.promise = null,
            this.resolve = null,
            this.reject = null,
            this.id = h.randomHex()
        },
        isEmptyObject: function(t) {
            var e = "";
            if ("function" == typeof Object.keys)
                return 0 === Object.keys(t).length;
            for (e in t)
                if (t.hasOwnProperty(e))
                    return !1;
            return !0
        },
        getClassname: function(t, e, i) {
            var n = "";
            return (n += t.block).length && (n += t.delineatorElement),
            n += t["element" + this.pascalCase(e)],
            i ? (n.length && (n += t.delineatorModifier),
            n += i) : n
        },
        getProperty: function(t, e) {
            var i, n = e.split("."), o = "", a = 0;
            if (!e)
                return t;
            for (i = function(t) {
                return t ? t[o] : null
            }
            ; a < n.length; )
                o = n[a],
                t = i(t),
                a++;
            return void 0 !== t ? t : null
        }
    },
    f.h = h,
    f.Base = function() {}
    ,
    f.Base.prototype = {
        constructor: f.Base,
        callActions: function(t, e) {
            var i = this.constructor.actions[t]
              , n = "";
            if (i && !h.isEmptyObject(i))
                for (n in i)
                    i[n].apply(this, e)
        },
        callFilters: function(t, e, i) {
            var n = this.constructor.filters[t]
              , o = e
              , a = "";
            if (!n || h.isEmptyObject(n))
                return o;
            for (a in i = i || [],
            n)
                (i = h.arrayFromList(i)).unshift(o),
                o = n[a].apply(this, i);
            return o
        }
    },
    f.BaseStatic = function() {
        this.actions = {},
        this.filters = {},
        this.extend = function(t) {
            h.extend(this.prototype, t)
        }
        ,
        this.registerAction = function(t, e, i) {
            (this.actions[t] = this.actions[t] || {})[e] = i
        }
        ,
        this.registerFilter = function(t, e, i) {
            (this.filters[t] = this.filters[t] || {})[e] = i
        }
    }
    ,
    f.Features = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.boxSizingPrefix = "",
        this.transformPrefix = "",
        this.transitionPrefix = "",
        this.boxSizingPrefix = "",
        this.transformProp = "",
        this.transformRule = "",
        this.transitionProp = "",
        this.perspectiveProp = "",
        this.perspectiveOriginProp = "",
        this.has = new f.Has,
        this.canary = null,
        this.BOX_SIZING_PROP = "boxSizing",
        this.TRANSITION_PROP = "transition",
        this.TRANSFORM_PROP = "transform",
        this.PERSPECTIVE_PROP = "perspective",
        this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin",
        this.VENDORS = ["Webkit", "moz", "O", "ms"],
        this.TWEENABLE = ["opacity", "width", "height", "marginRight", "marginBottom", "x", "y", "scale", "translateX", "translateY", "translateZ", "rotateX", "rotateY", "rotateZ"],
        this.callActions("afterConstruct")
    }
    ,
    f.BaseStatic.call(f.Features),
    f.Features.prototype = Object.create(f.Base.prototype),
    h.extend(f.Features.prototype, {
        constructor: f.Features,
        init: function() {
            var t = this;
            t.callActions("beforeInit", arguments),
            t.canary = document.createElement("div"),
            t.setPrefixes(),
            t.runTests(),
            t.callActions("beforeInit", arguments)
        },
        runTests: function() {
            var t = this;
            t.callActions("beforeRunTests", arguments),
            t.has.promises = "function" == typeof p.Promise,
            t.has.transitions = "unsupported" !== t.transitionPrefix,
            t.callActions("afterRunTests", arguments),
            h.freeze(t.has)
        },
        setPrefixes: function() {
            var t = this;
            t.callActions("beforeSetPrefixes", arguments),
            t.transitionPrefix = h.getPrefix(t.canary, "Transition", t.VENDORS),
            t.transformPrefix = h.getPrefix(t.canary, "Transform", t.VENDORS),
            t.boxSizingPrefix = h.getPrefix(t.canary, "BoxSizing", t.VENDORS),
            t.boxSizingProp = t.boxSizingPrefix ? t.boxSizingPrefix + h.pascalCase(t.BOX_SIZING_PROP) : t.BOX_SIZING_PROP,
            t.transitionProp = t.transitionPrefix ? t.transitionPrefix + h.pascalCase(t.TRANSITION_PROP) : t.TRANSITION_PROP,
            t.transformProp = t.transformPrefix ? t.transformPrefix + h.pascalCase(t.TRANSFORM_PROP) : t.TRANSFORM_PROP,
            t.transformRule = t.transformPrefix ? "-" + t.transformPrefix + "-" + t.TRANSFORM_PROP : t.TRANSFORM_PROP,
            t.perspectiveProp = t.transformPrefix ? t.transformPrefix + h.pascalCase(t.PERSPECTIVE_PROP) : t.PERSPECTIVE_PROP,
            t.perspectiveOriginProp = t.transformPrefix ? t.transformPrefix + h.pascalCase(t.PERSPECTIVE_ORIGIN_PROP) : t.PERSPECTIVE_ORIGIN_PROP,
            t.callActions("afterSetPrefixes", arguments)
        }
    }),
    f.Has = function() {
        this.transitions = !1,
        this.promises = !1,
        h.seal(this)
    }
    ,
    f.features = new f.Features,
    f.features.init(),
    f.ConfigAnimation = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.enable = !0,
        this.effects = "fade scale",
        this.effectsIn = "",
        this.effectsOut = "",
        this.duration = 600,
        this.easing = "ease",
        this.applyPerspective = !0,
        this.perspectiveDistance = "3000px",
        this.perspectiveOrigin = "50% 50%",
        this.queue = !0,
        this.queueLimit = 3,
        this.animateResizeContainer = !0,
        this.animateResizeTargets = !1,
        this.staggerSequence = null,
        this.reverseOut = !1,
        this.nudge = !0,
        this.clampHeight = !0,
        this.clampWidth = !0,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigAnimation),
    f.ConfigAnimation.prototype = Object.create(f.Base.prototype),
    f.ConfigAnimation.prototype.constructor = f.ConfigAnimation,
    f.ConfigBehavior = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.liveSort = !1,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigBehavior),
    f.ConfigBehavior.prototype = Object.create(f.Base.prototype),
    f.ConfigBehavior.prototype.constructor = f.ConfigBehavior,
    f.ConfigCallbacks = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.onMixStart = null,
        this.onMixBusy = null,
        this.onMixEnd = null,
        this.onMixFail = null,
        this.onMixClick = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigCallbacks),
    f.ConfigCallbacks.prototype = Object.create(f.Base.prototype),
    f.ConfigCallbacks.prototype.constructor = f.ConfigCallbacks,
    f.ConfigControls = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.enable = !0,
        this.live = !1,
        this.scope = "global",
        this.toggleLogic = "or",
        this.toggleDefault = "all",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigControls),
    f.ConfigControls.prototype = Object.create(f.Base.prototype),
    f.ConfigControls.prototype.constructor = f.ConfigControls,
    f.ConfigClassNames = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.block = "mixitup",
        this.elementContainer = "container",
        this.elementFilter = "control",
        this.elementSort = "control",
        this.elementMultimix = "control",
        this.elementToggle = "control",
        this.modifierActive = "active",
        this.modifierDisabled = "disabled",
        this.modifierFailed = "failed",
        this.delineatorElement = "-",
        this.delineatorModifier = "-",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigClassNames),
    f.ConfigClassNames.prototype = Object.create(f.Base.prototype),
    f.ConfigClassNames.prototype.constructor = f.ConfigClassNames,
    f.ConfigData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.uidKey = "",
        this.dirtyCheck = !1,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigData),
    f.ConfigData.prototype = Object.create(f.Base.prototype),
    f.ConfigData.prototype.constructor = f.ConfigData,
    f.ConfigDebug = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.enable = !1,
        this.showWarnings = !0,
        this.fauxAsync = !1,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigDebug),
    f.ConfigDebug.prototype = Object.create(f.Base.prototype),
    f.ConfigDebug.prototype.constructor = f.ConfigDebug,
    f.ConfigLayout = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.allowNestedTargets = !0,
        this.containerClassName = "",
        this.siblingBefore = null,
        this.siblingAfter = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigLayout),
    f.ConfigLayout.prototype = Object.create(f.Base.prototype),
    f.ConfigLayout.prototype.constructor = f.ConfigLayout,
    f.ConfigLoad = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.filter = "all",
        this.sort = "default:asc",
        this.dataset = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigLoad),
    f.ConfigLoad.prototype = Object.create(f.Base.prototype),
    f.ConfigLoad.prototype.constructor = f.ConfigLoad,
    f.ConfigSelectors = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.target = ".mix",
        this.control = "",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigSelectors),
    f.ConfigSelectors.prototype = Object.create(f.Base.prototype),
    f.ConfigSelectors.prototype.constructor = f.ConfigSelectors,
    f.ConfigRender = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.target = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigRender),
    f.ConfigRender.prototype = Object.create(f.Base.prototype),
    f.ConfigRender.prototype.constructor = f.ConfigRender,
    f.ConfigTemplates = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigTemplates),
    f.ConfigTemplates.prototype = Object.create(f.Base.prototype),
    f.ConfigTemplates.prototype.constructor = f.ConfigTemplates,
    f.Config = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.animation = new f.ConfigAnimation,
        this.behavior = new f.ConfigBehavior,
        this.callbacks = new f.ConfigCallbacks,
        this.controls = new f.ConfigControls,
        this.classNames = new f.ConfigClassNames,
        this.data = new f.ConfigData,
        this.debug = new f.ConfigDebug,
        this.layout = new f.ConfigLayout,
        this.load = new f.ConfigLoad,
        this.selectors = new f.ConfigSelectors,
        this.render = new f.ConfigRender,
        this.templates = new f.ConfigTemplates,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Config),
    f.Config.prototype = Object.create(f.Base.prototype),
    f.Config.prototype.constructor = f.Config,
    f.MixerDom = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.document = null,
        this.body = null,
        this.container = null,
        this.parent = null,
        this.targets = [],
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.MixerDom),
    f.MixerDom.prototype = Object.create(f.Base.prototype),
    f.MixerDom.prototype.constructor = f.MixerDom,
    f.UiClassNames = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.base = "",
        this.active = "",
        this.disabled = "",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.UiClassNames),
    f.UiClassNames.prototype = Object.create(f.Base.prototype),
    f.UiClassNames.prototype.constructor = f.UiClassNames,
    f.CommandDataset = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.dataset = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandDataset),
    f.CommandDataset.prototype = Object.create(f.Base.prototype),
    f.CommandDataset.prototype.constructor = f.CommandDataset,
    f.CommandMultimix = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.filter = null,
        this.sort = null,
        this.insert = null,
        this.remove = null,
        this.changeLayout = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandMultimix),
    f.CommandMultimix.prototype = Object.create(f.Base.prototype),
    f.CommandMultimix.prototype.constructor = f.CommandMultimix,
    f.CommandFilter = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.selector = "",
        this.collection = null,
        this.action = "show",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandFilter),
    f.CommandFilter.prototype = Object.create(f.Base.prototype),
    f.CommandFilter.prototype.constructor = f.CommandFilter,
    f.CommandSort = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.sortString = "",
        this.attribute = "",
        this.order = "asc",
        this.collection = null,
        this.next = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandSort),
    f.CommandSort.prototype = Object.create(f.Base.prototype),
    f.CommandSort.prototype.constructor = f.CommandSort,
    f.CommandInsert = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.index = 0,
        this.collection = [],
        this.position = "before",
        this.sibling = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandInsert),
    f.CommandInsert.prototype = Object.create(f.Base.prototype),
    f.CommandInsert.prototype.constructor = f.CommandInsert,
    f.CommandRemove = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.targets = [],
        this.collection = [],
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandRemove),
    f.CommandRemove.prototype = Object.create(f.Base.prototype),
    f.CommandRemove.prototype.constructor = f.CommandRemove,
    f.CommandChangeLayout = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.containerClassName = "",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandChangeLayout),
    f.CommandChangeLayout.prototype = Object.create(f.Base.prototype),
    f.CommandChangeLayout.prototype.constructor = f.CommandChangeLayout,
    f.ControlDefinition = function(t, e, i, n) {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.type = t,
        this.selector = e,
        this.live = i || !1,
        this.parent = n || "",
        this.callActions("afterConstruct"),
        h.freeze(this),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.ControlDefinition),
    f.ControlDefinition.prototype = Object.create(f.Base.prototype),
    f.ControlDefinition.prototype.constructor = f.ControlDefinition,
    f.controlDefinitions = [],
    f.controlDefinitions.push(new f.ControlDefinition("multimix","[data-filter][data-sort]")),
    f.controlDefinitions.push(new f.ControlDefinition("filter","[data-filter]")),
    f.controlDefinitions.push(new f.ControlDefinition("sort","[data-sort]")),
    f.controlDefinitions.push(new f.ControlDefinition("toggle","[data-toggle]")),
    f.Control = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.el = null,
        this.selector = "",
        this.bound = [],
        this.pending = -1,
        this.type = "",
        this.status = "inactive",
        this.filter = "",
        this.sort = "",
        this.canDisable = !1,
        this.handler = null,
        this.classNames = new f.UiClassNames,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Control),
    f.Control.prototype = Object.create(f.Base.prototype),
    h.extend(f.Control.prototype, {
        constructor: f.Control,
        init: function(t, e, i) {
            var n = this;
            if (this.callActions("beforeInit", arguments),
            n.el = t,
            n.type = e,
            n.selector = i,
            n.selector)
                n.status = "live";
            else
                switch (n.canDisable = "boolean" == typeof n.el.disable,
                n.type) {
                case "filter":
                    n.filter = n.el.getAttribute("data-filter");
                    break;
                case "toggle":
                    n.filter = n.el.getAttribute("data-toggle");
                    break;
                case "sort":
                    n.sort = n.el.getAttribute("data-sort");
                    break;
                case "multimix":
                    n.filter = n.el.getAttribute("data-filter"),
                    n.sort = n.el.getAttribute("data-sort")
                }
            n.bindClick(),
            f.controls.push(n),
            this.callActions("afterInit", arguments)
        },
        isBound: function(t) {
            var e;
            return this.callActions("beforeIsBound", arguments),
            e = -1 < this.bound.indexOf(t),
            this.callFilters("afterIsBound", e, arguments)
        },
        addBinding: function(t) {
            this.callActions("beforeAddBinding", arguments),
            this.isBound() || this.bound.push(t),
            this.callActions("afterAddBinding", arguments)
        },
        removeBinding: function(t) {
            var e = this
              , i = -1;
            this.callActions("beforeRemoveBinding", arguments),
            -1 < (i = e.bound.indexOf(t)) && e.bound.splice(i, 1),
            e.bound.length < 1 && (e.unbindClick(),
            i = f.controls.indexOf(e),
            f.controls.splice(i, 1),
            "active" === e.status && e.renderStatus(e.el, "inactive")),
            this.callActions("afterRemoveBinding", arguments)
        },
        bindClick: function() {
            var e = this;
            this.callActions("beforeBindClick", arguments),
            e.handler = function(t) {
                e.handleClick(t)
            }
            ,
            h.on(e.el, "click", e.handler),
            this.callActions("afterBindClick", arguments)
        },
        unbindClick: function() {
            this.callActions("beforeUnbindClick", arguments),
            h.off(this.el, "click", this.handler),
            this.handler = null,
            this.callActions("afterUnbindClick", arguments)
        },
        handleClick: function(t) {
            var e = this
              , i = null
              , n = null
              , o = !1
              , a = {}
              , s = null
              , r = []
              , l = -1;
            if (this.callActions("beforeHandleClick", arguments),
            this.pending = 0,
            n = e.bound[0],
            i = e.selector ? h.closestParent(t.target, n.config.selectors.control + e.selector, !0, n.dom.document) : e.el) {
                switch (e.type) {
                case "filter":
                    a.filter = e.filter || i.getAttribute("data-filter");
                    break;
                case "sort":
                    a.sort = e.sort || i.getAttribute("data-sort");
                    break;
                case "multimix":
                    a.filter = e.filter || i.getAttribute("data-filter"),
                    a.sort = e.sort || i.getAttribute("data-sort");
                    break;
                case "toggle":
                    a.filter = e.filter || i.getAttribute("data-toggle"),
                    o = "live" === e.status ? h.hasClass(i, e.classNames.active) : "active" === e.status
                }
                for (l = 0; l < e.bound.length; l++)
                    s = new f.CommandMultimix,
                    h.extend(s, a),
                    r.push(s);
                for (r = e.callFilters("commandsHandleClick", r, arguments),
                e.pending = e.bound.length,
                l = 0; n = e.bound[l]; l++)
                    (a = r[l]) && (n.lastClicked || (n.lastClicked = i),
                    f.events.fire("mixClick", n.dom.container, {
                        state: n.state,
                        instance: n,
                        originalEvent: t,
                        control: n.lastClicked
                    }, n.dom.document),
                    "function" == typeof n.config.callbacks.onMixClick && !1 === n.config.callbacks.onMixClick.call(n.lastClicked, n.state, t, n) || ("toggle" === e.type ? o ? n.toggleOff(a.filter) : n.toggleOn(a.filter) : n.multimix(a)));
                this.callActions("afterHandleClick", arguments)
            } else
                e.callActions("afterHandleClick", arguments)
        },
        update: function(t, e) {
            var i = this
              , n = new f.CommandMultimix;
            i.callActions("beforeUpdate", arguments),
            i.pending--,
            i.pending = Math.max(0, i.pending),
            0 < i.pending || ("live" === i.status ? i.updateLive(t, e) : (n.sort = i.sort,
            n.filter = i.filter,
            i.callFilters("actionsUpdate", n, arguments),
            i.parseStatusChange(i.el, t, n, e)),
            i.callActions("afterUpdate", arguments))
        },
        updateLive: function(t, e) {
            var i, n = this, o = null, a = null, s = -1;
            if (n.callActions("beforeUpdateLive", arguments),
            n.el) {
                for (i = n.el.querySelectorAll(n.selector),
                s = 0; a = i[s]; s++) {
                    switch (o = new f.CommandMultimix,
                    n.type) {
                    case "filter":
                        o.filter = a.getAttribute("data-filter");
                        break;
                    case "sort":
                        o.sort = a.getAttribute("data-sort");
                        break;
                    case "multimix":
                        o.filter = a.getAttribute("data-filter"),
                        o.sort = a.getAttribute("data-sort");
                        break;
                    case "toggle":
                        o.filter = a.getAttribute("data-toggle")
                    }
                    o = n.callFilters("actionsUpdateLive", o, arguments),
                    n.parseStatusChange(a, t, o, e)
                }
                n.callActions("afterUpdateLive", arguments)
            }
        },
        parseStatusChange: function(t, e, i, n) {
            var o = this
              , a = ""
              , s = -1;
            switch (o.callActions("beforeParseStatusChange", arguments),
            o.type) {
            case "filter":
                e.filter === i.filter ? o.renderStatus(t, "active") : o.renderStatus(t, "inactive");
                break;
            case "multimix":
                e.sort === i.sort && e.filter === i.filter ? o.renderStatus(t, "active") : o.renderStatus(t, "inactive");
                break;
            case "sort":
                e.sort.match(/:asc/g) && (a = e.sort.replace(/:asc/g, "")),
                e.sort === i.sort || a === i.sort ? o.renderStatus(t, "active") : o.renderStatus(t, "inactive");
                break;
            case "toggle":
                for (n.length < 1 && o.renderStatus(t, "inactive"),
                e.filter === i.filter && o.renderStatus(t, "active"),
                s = 0; s < n.length; s++) {
                    if (n[s] === i.filter) {
                        o.renderStatus(t, "active");
                        break
                    }
                    o.renderStatus(t, "inactive")
                }
            }
            o.callActions("afterParseStatusChange", arguments)
        },
        renderStatus: function(t, e) {
            var i = this;
            switch (i.callActions("beforeRenderStatus", arguments),
            e) {
            case "active":
                h.addClass(t, i.classNames.active),
                h.removeClass(t, i.classNames.disabled),
                i.canDisable && (i.el.disabled = !1);
                break;
            case "inactive":
                h.removeClass(t, i.classNames.active),
                h.removeClass(t, i.classNames.disabled),
                i.canDisable && (i.el.disabled = !1);
                break;
            case "disabled":
                i.canDisable && (i.el.disabled = !0),
                h.addClass(t, i.classNames.disabled),
                h.removeClass(t, i.classNames.active)
            }
            "live" !== i.status && (i.status = e),
            i.callActions("afterRenderStatus", arguments)
        }
    }),
    f.controls = [],
    f.StyleData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.x = 0,
        this.y = 0,
        this.top = 0,
        this.right = 0,
        this.bottom = 0,
        this.left = 0,
        this.width = 0,
        this.height = 0,
        this.marginRight = 0,
        this.marginBottom = 0,
        this.opacity = 0,
        this.scale = new f.TransformData,
        this.translateX = new f.TransformData,
        this.translateY = new f.TransformData,
        this.translateZ = new f.TransformData,
        this.rotateX = new f.TransformData,
        this.rotateY = new f.TransformData,
        this.rotateZ = new f.TransformData,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.StyleData),
    f.StyleData.prototype = Object.create(f.Base.prototype),
    f.StyleData.prototype.constructor = f.StyleData,
    f.TransformData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.value = 0,
        this.unit = "",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.TransformData),
    f.TransformData.prototype = Object.create(f.Base.prototype),
    f.TransformData.prototype.constructor = f.TransformData,
    f.TransformDefaults = function() {
        f.StyleData.apply(this),
        this.callActions("beforeConstruct"),
        this.scale.value = .01,
        this.scale.unit = "",
        this.translateX.value = 20,
        this.translateX.unit = "px",
        this.translateY.value = 20,
        this.translateY.unit = "px",
        this.translateZ.value = 20,
        this.translateZ.unit = "px",
        this.rotateX.value = 90,
        this.rotateX.unit = "deg",
        this.rotateY.value = 90,
        this.rotateY.unit = "deg",
        this.rotateX.value = 90,
        this.rotateX.unit = "deg",
        this.rotateZ.value = 180,
        this.rotateZ.unit = "deg",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.TransformDefaults),
    f.TransformDefaults.prototype = Object.create(f.StyleData.prototype),
    f.TransformDefaults.prototype.constructor = f.TransformDefaults,
    f.transformDefaults = new f.TransformDefaults,
    f.EventDetail = function() {
        this.state = null,
        this.futureState = null,
        this.instance = null,
        this.originalEvent = null
    }
    ,
    f.Events = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.mixStart = null,
        this.mixBusy = null,
        this.mixEnd = null,
        this.mixFail = null,
        this.mixClick = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Events),
    f.Events.prototype = Object.create(f.Base.prototype),
    f.Events.prototype.constructor = f.Events,
    f.Events.prototype.fire = function(t, e, i, n) {
        var o, a = new f.EventDetail;
        if (this.callActions("beforeFire", arguments),
        void 0 === this[t])
            throw new Error('Event type "' + t + '" not found.');
        a.state = new f.State,
        h.extend(a.state, i.state),
        i.futureState && (a.futureState = new f.State,
        h.extend(a.futureState, i.futureState)),
        a.instance = i.instance,
        i.originalEvent && (a.originalEvent = i.originalEvent),
        o = h.getCustomEvent(t, a, n),
        this.callFilters("eventFire", o, arguments),
        e.dispatchEvent(o)
    }
    ,
    f.events = new f.Events,
    f.QueueItem = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.args = [],
        this.instruction = null,
        this.triggerElement = null,
        this.deferred = null,
        this.isToggling = !1,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.QueueItem),
    f.QueueItem.prototype = Object.create(f.Base.prototype),
    f.QueueItem.prototype.constructor = f.QueueItem,
    f.Mixer = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.config = new f.Config,
        this.id = "",
        this.isBusy = !1,
        this.isToggling = !1,
        this.incPadding = !0,
        this.controls = [],
        this.targets = [],
        this.origOrder = [],
        this.cache = {},
        this.toggleArray = [],
        this.targetsMoved = 0,
        this.targetsImmovable = 0,
        this.targetsBound = 0,
        this.targetsDone = 0,
        this.staggerDuration = 0,
        this.effectsIn = null,
        this.effectsOut = null,
        this.transformIn = [],
        this.transformOut = [],
        this.queue = [],
        this.state = null,
        this.lastOperation = null,
        this.lastClicked = null,
        this.userCallback = null,
        this.userDeferred = null,
        this.dom = new f.MixerDom,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Mixer),
    f.Mixer.prototype = Object.create(f.Base.prototype),
    h.extend(f.Mixer.prototype, {
        constructor: f.Mixer,
        attach: function(t, e, i, n) {
            var o = this
              , a = null
              , s = -1;
            for (o.callActions("beforeAttach", arguments),
            o.id = i,
            n && h.extend(o.config, n, !0, !0),
            o.sanitizeConfig(),
            o.cacheDom(t, e),
            o.config.layout.containerClassName && h.addClass(o.dom.container, o.config.layout.containerClassName),
            f.features.has.transitions || (o.config.animation.enable = !1),
            void 0 === p.console && (o.config.debug.showWarnings = !1),
            o.config.data.uidKey && (o.config.controls.enable = !1),
            o.indexTargets(),
            o.state = o.getInitialState(),
            s = 0; a = o.lastOperation.toHide[s]; s++)
                a.hide();
            o.config.controls.enable && (o.initControls(),
            o.buildToggleArray(null, o.state),
            o.updateControls({
                filter: o.state.activeFilter,
                sort: o.state.activeSort
            })),
            o.parseEffects(),
            o.callActions("afterAttach", arguments)
        },
        sanitizeConfig: function() {
            var t = this;
            t.callActions("beforeSanitizeConfig", arguments),
            t.config.controls.scope = t.config.controls.scope.toLowerCase().trim(),
            t.config.controls.toggleLogic = t.config.controls.toggleLogic.toLowerCase().trim(),
            t.config.controls.toggleDefault = t.config.controls.toggleDefault.toLowerCase().trim(),
            t.config.animation.effects = t.config.animation.effects.trim(),
            t.callActions("afterSanitizeConfig", arguments)
        },
        getInitialState: function() {
            var t = this
              , e = new f.State
              , i = new f.Operation;
            if (t.callActions("beforeGetInitialState", arguments),
            e.activeContainerClassName = t.config.layout.containerClassName,
            t.config.load.dataset) {
                if (!t.config.data.uidKey || "string" != typeof t.config.data.uidKey)
                    throw new TypeError(f.messages.errorConfigDataUidKeyNotSet());
                i.startDataset = i.newDataset = e.activeDataset = t.config.load.dataset.slice(),
                i.startContainerClassName = i.newContainerClassName = e.activeContainerClassName,
                i.show = t.targets.slice(),
                e = t.callFilters("stateGetInitialState", e, arguments)
            } else
                e.activeFilter = t.parseFilterArgs([t.config.load.filter]).command,
                e.activeSort = t.parseSortArgs([t.config.load.sort]).command,
                e.totalTargets = t.targets.length,
                (e = t.callFilters("stateGetInitialState", e, arguments)).activeSort.collection || e.activeSort.attribute || "random" === e.activeSort.order || "desc" === e.activeSort.order ? (i.newSort = e.activeSort,
                t.sortOperation(i),
                t.printSort(!1, i),
                t.targets = i.newOrder) : i.startOrder = i.newOrder = t.targets,
                i.startFilter = i.newFilter = e.activeFilter,
                i.startSort = i.newSort = e.activeSort,
                i.startContainerClassName = i.newContainerClassName = e.activeContainerClassName,
                "all" === i.newFilter.selector ? i.newFilter.selector = t.config.selectors.target : "none" === i.newFilter.selector && (i.newFilter.selector = "");
            return i = t.callFilters("operationGetInitialState", i, [e]),
            (t.lastOperation = i).newFilter && t.filterOperation(i),
            e = t.buildState(i)
        },
        cacheDom: function(t, e) {
            var i = this;
            i.callActions("beforeCacheDom", arguments),
            i.dom.document = e,
            i.dom.body = i.dom.document.querySelector("body"),
            i.dom.container = t,
            i.dom.parent = t,
            i.callActions("afterCacheDom", arguments)
        },
        indexTargets: function() {
            var t, e = this, i = null, n = null, o = -1;
            if (e.callActions("beforeIndexTargets", arguments),
            e.dom.targets = e.config.layout.allowNestedTargets ? e.dom.container.querySelectorAll(e.config.selectors.target) : h.children(e.dom.container, e.config.selectors.target, e.dom.document),
            e.dom.targets = h.arrayFromList(e.dom.targets),
            e.targets = [],
            (t = e.config.load.dataset) && t.length !== e.dom.targets.length)
                throw new Error(f.messages.errorDatasetPrerenderedMismatch());
            if (e.dom.targets.length) {
                for (o = 0; n = e.dom.targets[o]; o++)
                    (i = new f.Target).init(n, e, t ? t[o] : void 0),
                    i.isInDom = !0,
                    e.targets.push(i);
                e.dom.parent = e.dom.targets[0].parentElement === e.dom.container ? e.dom.container : e.dom.targets[0].parentElement
            }
            e.origOrder = e.targets,
            e.callActions("afterIndexTargets", arguments)
        },
        initControls: function() {
            var t = this
              , e = ""
              , i = null
              , n = null
              , o = null
              , a = null
              , s = null
              , r = -1
              , l = -1;
            switch (t.callActions("beforeInitControls", arguments),
            t.config.controls.scope) {
            case "local":
                o = t.dom.container;
                break;
            case "global":
                o = t.dom.document;
                break;
            default:
                throw new Error(f.messages.errorConfigInvalidControlsScope())
            }
            for (r = 0; e = f.controlDefinitions[r]; r++)
                if (t.config.controls.live || e.live) {
                    if (e.parent) {
                        if (!(a = t.dom[e.parent]) || a.length < 0)
                            continue;
                        "number" != typeof a.length && (a = [a])
                    } else
                        a = [o];
                    for (l = 0; n = a[l]; l++)
                        s = t.getControl(n, e.type, e.selector),
                        t.controls.push(s)
                } else
                    for (i = o.querySelectorAll(t.config.selectors.control + e.selector),
                    l = 0; n = i[l]; l++)
                        (s = t.getControl(n, e.type, "")) && t.controls.push(s);
            t.callActions("afterInitControls", arguments)
        },
        getControl: function(t, e, i) {
            var n = this
              , o = null
              , a = -1;
            if (n.callActions("beforeGetControl", arguments),
            !i)
                for (a = 0; o = f.controls[a]; a++) {
                    if (o.el === t && o.isBound(n))
                        return n.callFilters("controlGetControl", null, arguments);
                    if (o.el === t && o.type === e && o.selector === i)
                        return o.addBinding(n),
                        n.callFilters("controlGetControl", o, arguments)
                }
            return (o = new f.Control).init(t, e, i),
            o.classNames.base = h.getClassname(n.config.classNames, e),
            o.classNames.active = h.getClassname(n.config.classNames, e, n.config.classNames.modifierActive),
            o.classNames.disabled = h.getClassname(n.config.classNames, e, n.config.classNames.modifierDisabled),
            o.addBinding(n),
            n.callFilters("controlGetControl", o, arguments)
        },
        getToggleSelector: function() {
            var t = this
              , e = "or" === t.config.controls.toggleLogic ? ", " : ""
              , i = "";
            return t.callActions("beforeGetToggleSelector", arguments),
            t.toggleArray = h.clean(t.toggleArray),
            "" === (i = t.toggleArray.join(e)) && (i = t.config.controls.toggleDefault),
            t.callFilters("selectorGetToggleSelector", i, arguments)
        },
        buildToggleArray: function(t, e) {
            var i = this
              , n = "";
            if (i.callActions("beforeBuildToggleArray", arguments),
            t && t.filter)
                n = t.filter.selector.replace(/\s/g, "");
            else {
                if (!e)
                    return;
                n = e.activeFilter.selector.replace(/\s/g, "")
            }
            n !== i.config.selectors.target && "all" !== n || (n = ""),
            "or" === i.config.controls.toggleLogic ? i.toggleArray = n.split(",") : i.toggleArray = i.splitCompoundSelector(n),
            i.toggleArray = h.clean(i.toggleArray),
            i.callActions("afterBuildToggleArray", arguments)
        },
        splitCompoundSelector: function(t) {
            var e = t.split(/([\.\[])/g)
              , i = []
              , n = ""
              , o = -1;
            for ("" === e[0] && e.shift(),
            o = 0; o < e.length; o++)
                o % 2 == 0 && (n = ""),
                n += e[o],
                o % 2 != 0 && i.push(n);
            return i
        },
        updateControls: function(t) {
            var e = this
              , i = null
              , n = new f.CommandMultimix
              , o = -1;
            for (e.callActions("beforeUpdateControls", arguments),
            t.filter ? n.filter = t.filter.selector : n.filter = e.state.activeFilter.selector,
            t.sort ? n.sort = e.buildSortString(t.sort) : n.sort = e.buildSortString(e.state.activeSort),
            n.filter === e.config.selectors.target && (n.filter = "all"),
            "" === n.filter && (n.filter = "none"),
            h.freeze(n),
            o = 0; i = e.controls[o]; o++)
                i.update(n, e.toggleArray);
            e.callActions("afterUpdateControls", arguments)
        },
        buildSortString: function(t) {
            var e = "";
            return e += t.sortString,
            t.next && (e += " " + this.buildSortString(t.next)),
            e
        },
        insertTargets: function(t, e) {
            var i, n = this, o = -1, a = null, s = null, r = null, l = -1;
            if (n.callActions("beforeInsertTargets", arguments),
            void 0 === t.index && (t.index = 0),
            i = n.getNextSibling(t.index, t.sibling, t.position),
            a = n.dom.document.createDocumentFragment(),
            o = i ? h.index(i, n.config.selectors.target) : n.targets.length,
            t.collection) {
                for (l = 0; r = t.collection[l]; l++) {
                    if (-1 < n.dom.targets.indexOf(r))
                        throw new Error(f.messages.errorInsertPreexistingElement());
                    r.style.display = "none",
                    a.appendChild(r),
                    a.appendChild(n.dom.document.createTextNode(" ")),
                    h.isElement(r, n.dom.document) && r.matches(n.config.selectors.target) && ((s = new f.Target).init(r, n),
                    s.isInDom = !0,
                    n.targets.splice(o, 0, s),
                    o++)
                }
                n.dom.parent.insertBefore(a, i)
            }
            e.startOrder = n.origOrder = n.targets,
            n.callActions("afterInsertTargets", arguments)
        },
        getNextSibling: function(t, e, i) {
            var n = this
              , o = null;
            return t = Math.max(t, 0),
            e && "before" === i ? o = e : e && "after" === i ? o = e.nextElementSibling || null : 0 < n.targets.length && void 0 !== t ? o = t < n.targets.length || !n.targets.length ? n.targets[t].dom.el : n.targets[n.targets.length - 1].dom.el.nextElementSibling : 0 === n.targets.length && 0 < n.dom.parent.children.length && (n.config.layout.siblingAfter ? o = n.config.layout.siblingAfter : n.config.layout.siblingBefore ? o = n.config.layout.siblingBefore.nextElementSibling : n.dom.parent.children[0]),
            n.callFilters("elementGetNextSibling", o, arguments)
        },
        filterOperation: function(t) {
            var e, i = !1, n = -1, o = null, a = -1;
            for (this.callActions("beforeFilterOperation", arguments),
            e = t.newFilter.action,
            a = 0; o = t.newOrder[a]; a++)
                i = t.newFilter.collection ? -1 < t.newFilter.collection.indexOf(o.dom.el) : "" !== t.newFilter.selector && o.dom.el.matches(t.newFilter.selector),
                this.evaluateHideShow(i, o, e, t);
            if (t.toRemove.length)
                for (a = 0; o = t.show[a]; a++)
                    -1 < t.toRemove.indexOf(o) && (t.show.splice(a, 1),
                    -1 < (n = t.toShow.indexOf(o)) && t.toShow.splice(n, 1),
                    t.toHide.push(o),
                    t.hide.push(o),
                    a--);
            t.matching = t.show.slice(),
            0 === t.show.length && "" !== t.newFilter.selector && 0 !== this.targets.length && (t.hasFailed = !0),
            this.callActions("afterFilterOperation", arguments)
        },
        evaluateHideShow: function(t, e, i, n) {
            var o, a = Array.prototype.slice.call(arguments, 1);
            o = this.callFilters("testResultEvaluateHideShow", t, a),
            this.callActions("beforeEvaluateHideShow", arguments),
            !0 === o && "show" === i || !1 === o && "hide" === i ? (n.show.push(e),
            e.isShown || n.toShow.push(e)) : (n.hide.push(e),
            e.isShown && n.toHide.push(e)),
            this.callActions("afterEvaluateHideShow", arguments)
        },
        sortOperation: function(i) {
            var n = this
              , t = []
              , e = null
              , o = null
              , a = -1;
            if (n.callActions("beforeSortOperation", arguments),
            i.startOrder = n.targets,
            i.newSort.collection) {
                for (t = [],
                a = 0; o = i.newSort.collection[a]; a++) {
                    if (n.dom.targets.indexOf(o) < 0)
                        throw new Error(f.messages.errorSortNonExistentElement());
                    (e = new f.Target).init(o, n),
                    e.isInDom = !0,
                    t.push(e)
                }
                i.newOrder = t
            } else
                "random" === i.newSort.order ? i.newOrder = h.arrayShuffle(i.startOrder) : "" === i.newSort.attribute ? (i.newOrder = n.origOrder.slice(),
                "desc" === i.newSort.order && i.newOrder.reverse()) : (i.newOrder = i.startOrder.slice(),
                i.newOrder.sort(function(t, e) {
                    return n.compare(t, e, i.newSort)
                }));
            h.isEqualArray(i.newOrder, i.startOrder) && (i.willSort = !1),
            n.callActions("afterSortOperation", arguments)
        },
        compare: function(t, e, i) {
            var n = i.order
              , o = this.getAttributeValue(t, i.attribute)
              , a = this.getAttributeValue(e, i.attribute);
            return isNaN(1 * o) || isNaN(1 * a) ? (o = o.toLowerCase(),
            a = a.toLowerCase()) : (o *= 1,
            a *= 1),
            o < a ? "asc" === n ? -1 : 1 : a < o ? "asc" === n ? 1 : -1 : o === a && i.next ? this.compare(t, e, i.next) : 0
        },
        getAttributeValue: function(t, e) {
            var i;
            return null === (i = t.dom.el.getAttribute("data-" + e)) && this.config.debug.showWarnings && console.warn(f.messages.warningInconsistentSortingAttributes({
                attribute: "data-" + e
            })),
            this.callFilters("valueGetAttributeValue", i || 0, arguments)
        },
        printSort: function(t, e) {
            var i, n = this, o = t ? e.newOrder : e.startOrder, a = t ? e.startOrder : e.newOrder, s = o.length ? o[o.length - 1].dom.el.nextElementSibling : null, r = p.document.createDocumentFragment(), l = null, c = null, u = -1;
            for (n.callActions("beforePrintSort", arguments),
            u = 0; l = o[u]; u++)
                "absolute" !== (c = l.dom.el).style.position && (h.removeWhitespace(c.previousSibling),
                c.parentElement.removeChild(c));
            for ((i = s ? s.previousSibling : n.dom.parent.lastChild) && "#text" === i.nodeName && h.removeWhitespace(i),
            u = 0; l = a[u]; u++)
                c = l.dom.el,
                h.isElement(r.lastChild) && r.appendChild(p.document.createTextNode(" ")),
                r.appendChild(c);
            n.dom.parent.firstChild && n.dom.parent.firstChild !== s && r.insertBefore(p.document.createTextNode(" "), r.childNodes[0]),
            s ? (r.appendChild(p.document.createTextNode(" ")),
            n.dom.parent.insertBefore(r, s)) : n.dom.parent.appendChild(r),
            n.callActions("afterPrintSort", arguments)
        },
        parseSortString: function(t, e) {
            var i = t.split(" ")
              , n = e
              , o = []
              , a = -1;
            for (a = 0; a < i.length; a++) {
                switch (o = i[a].split(":"),
                n.sortString = i[a],
                n.attribute = h.dashCase(o[0]),
                n.order = o[1] || "asc",
                n.attribute) {
                case "default":
                    n.attribute = "";
                    break;
                case "random":
                    n.attribute = "",
                    n.order = "random"
                }
                if (!n.attribute || "random" === n.order)
                    break;
                a < i.length - 1 && (n.next = new f.CommandSort,
                h.freeze(n),
                n = n.next)
            }
            return this.callFilters("commandsParseSort", e, arguments)
        },
        parseEffects: function() {
            var t = this
              , e = ""
              , i = t.config.animation.effectsIn || t.config.animation.effects
              , n = t.config.animation.effectsOut || t.config.animation.effects;
            for (e in t.callActions("beforeParseEffects", arguments),
            t.effectsIn = new f.StyleData,
            t.effectsOut = new f.StyleData,
            t.transformIn = [],
            t.transformOut = [],
            t.effectsIn.opacity = t.effectsOut.opacity = 1,
            t.parseEffect("fade", i, t.effectsIn, t.transformIn),
            t.parseEffect("fade", n, t.effectsOut, t.transformOut, !0),
            f.transformDefaults)
                f.transformDefaults[e]instanceof f.TransformData && (t.parseEffect(e, i, t.effectsIn, t.transformIn),
                t.parseEffect(e, n, t.effectsOut, t.transformOut, !0));
            t.parseEffect("stagger", i, t.effectsIn, t.transformIn),
            t.parseEffect("stagger", n, t.effectsOut, t.transformOut, !0),
            t.callActions("afterParseEffects", arguments)
        },
        parseEffect: function(t, e, i, n, o) {
            var a, s = this, r = "", l = "", c = ["%", "px", "em", "rem", "vh", "vw", "deg"], u = "", d = -1;
            if (s.callActions("beforeParseEffect", arguments),
            "string" != typeof e)
                throw new TypeError(f.messages.errorConfigInvalidAnimationEffects());
            if (e.indexOf(t) < 0)
                "stagger" === t && (s.staggerDuration = 0);
            else {
                switch (-1 < (a = e.indexOf(t + "(")) && (r = e.substring(a),
                l = /\(([^)]+)\)/.exec(r)[1]),
                t) {
                case "fade":
                    i.opacity = l ? parseFloat(l) : 0;
                    break;
                case "stagger":
                    s.staggerDuration = l ? parseFloat(l) : 100;
                    break;
                default:
                    if (o && s.config.animation.reverseOut && "scale" !== t ? i[t].value = -1 * (l ? parseFloat(l) : f.transformDefaults[t].value) : i[t].value = l ? parseFloat(l) : f.transformDefaults[t].value,
                    l) {
                        for (d = 0; u = c[d]; d++)
                            if (-1 < l.indexOf(u)) {
                                i[t].unit = u;
                                break
                            }
                    } else
                        i[t].unit = f.transformDefaults[t].unit;
                    n.push(t + "(" + i[t].value + i[t].unit + ")")
                }
                s.callActions("afterParseEffect", arguments)
            }
        },
        buildState: function(t) {
            var e = this
              , i = new f.State
              , n = null
              , o = -1;
            for (e.callActions("beforeBuildState", arguments),
            o = 0; n = e.targets[o]; o++)
                (!t.toRemove.length || t.toRemove.indexOf(n) < 0) && i.targets.push(n.dom.el);
            for (o = 0; n = t.matching[o]; o++)
                i.matching.push(n.dom.el);
            for (o = 0; n = t.show[o]; o++)
                i.show.push(n.dom.el);
            for (o = 0; n = t.hide[o]; o++)
                (!t.toRemove.length || t.toRemove.indexOf(n) < 0) && i.hide.push(n.dom.el);
            return i.id = e.id,
            i.container = e.dom.container,
            i.activeFilter = t.newFilter,
            i.activeSort = t.newSort,
            i.activeDataset = t.newDataset,
            i.activeContainerClassName = t.newContainerClassName,
            i.hasFailed = t.hasFailed,
            i.totalTargets = e.targets.length,
            i.totalShow = t.show.length,
            i.totalHide = t.hide.length,
            i.totalMatching = t.matching.length,
            i.triggerElement = t.triggerElement,
            e.callFilters("stateBuildState", i, arguments)
        },
        goMix: function(t, e) {
            var i = this
              , n = null;
            return i.callActions("beforeGoMix", arguments),
            i.config.animation.duration && i.config.animation.effects && h.isVisible(i.dom.container) || (t = !1),
            e.toShow.length || e.toHide.length || e.willSort || e.willChangeLayout || (t = !1),
            e.startState.show.length || e.show.length || (t = !1),
            f.events.fire("mixStart", i.dom.container, {
                state: e.startState,
                futureState: e.newState,
                instance: i
            }, i.dom.document),
            "function" == typeof i.config.callbacks.onMixStart && i.config.callbacks.onMixStart.call(i.dom.container, e.startState, e.newState, i),
            h.removeClass(i.dom.container, h.getClassname(i.config.classNames, "container", i.config.classNames.modifierFailed)),
            n = i.userDeferred ? i.userDeferred : i.userDeferred = h.defer(f.libraries),
            i.isBusy = !0,
            t && f.features.has.transitions ? (p.pageYOffset !== e.docState.scrollTop && p.scrollTo(e.docState.scrollLeft, e.docState.scrollTop),
            i.config.animation.applyPerspective && (i.dom.parent.style[f.features.perspectiveProp] = i.config.animation.perspectiveDistance,
            i.dom.parent.style[f.features.perspectiveOriginProp] = i.config.animation.perspectiveOrigin),
            i.config.animation.animateResizeContainer && e.startHeight !== e.newHeight && e.viewportDeltaY !== e.startHeight - e.newHeight && (i.dom.parent.style.height = e.startHeight + "px"),
            i.config.animation.animateResizeContainer && e.startWidth !== e.newWidth && e.viewportDeltaX !== e.startWidth - e.newWidth && (i.dom.parent.style.width = e.startWidth + "px"),
            e.startHeight === e.newHeight && (i.dom.parent.style.height = e.startHeight + "px"),
            e.startWidth === e.newWidth && (i.dom.parent.style.width = e.startWidth + "px"),
            e.startHeight === e.newHeight && e.startWidth === e.newWidth && (i.dom.parent.style.overflow = "hidden"),
            requestAnimationFrame(function() {
                i.moveTargets(e)
            })) : i.config.debug.fauxAsync ? setTimeout(function() {
                i.cleanUp(e)
            }, i.config.animation.duration) : i.cleanUp(e),
            i.callFilters("promiseGoMix", n.promise, arguments)
        },
        getStartMixData: function(t) {
            var e = this
              , i = p.getComputedStyle(e.dom.parent)
              , n = e.dom.parent.getBoundingClientRect()
              , o = null
              , a = {}
              , s = -1
              , r = i[f.features.boxSizingProp];
            for (e.incPadding = "border-box" === r,
            e.callActions("beforeGetStartMixData", arguments),
            s = 0; o = t.show[s]; s++)
                a = o.getPosData(),
                t.showPosData[s] = {
                    startPosData: a
                };
            for (s = 0; o = t.toHide[s]; s++)
                a = o.getPosData(),
                t.toHidePosData[s] = {
                    startPosData: a
                };
            t.startX = n.left,
            t.startY = n.top,
            t.startHeight = e.incPadding ? n.height : n.height - parseFloat(i.paddingTop) - parseFloat(i.paddingBottom) - parseFloat(i.borderTop) - parseFloat(i.borderBottom),
            t.startWidth = e.incPadding ? n.width : n.width - parseFloat(i.paddingLeft) - parseFloat(i.paddingRight) - parseFloat(i.borderLeft) - parseFloat(i.borderRight),
            e.callActions("afterGetStartMixData", arguments)
        },
        setInter: function(t) {
            var e = this
              , i = null
              , n = -1;
            for (e.callActions("beforeSetInter", arguments),
            e.config.animation.clampHeight && (e.dom.parent.style.height = t.startHeight + "px",
            e.dom.parent.style.overflow = "hidden"),
            e.config.animation.clampWidth && (e.dom.parent.style.width = t.startWidth + "px",
            e.dom.parent.style.overflow = "hidden"),
            n = 0; i = t.toShow[n]; n++)
                i.show();
            t.willChangeLayout && (h.removeClass(e.dom.container, t.startContainerClassName),
            h.addClass(e.dom.container, t.newContainerClassName)),
            e.callActions("afterSetInter", arguments)
        },
        getInterMixData: function(t) {
            var e = null
              , i = -1;
            for (this.callActions("beforeGetInterMixData", arguments),
            i = 0; e = t.show[i]; i++)
                t.showPosData[i].interPosData = e.getPosData();
            for (i = 0; e = t.toHide[i]; i++)
                t.toHidePosData[i].interPosData = e.getPosData();
            this.callActions("afterGetInterMixData", arguments)
        },
        setFinal: function(t) {
            var e = null
              , i = -1;
            for (this.callActions("beforeSetFinal", arguments),
            t.willSort && this.printSort(!1, t),
            i = 0; e = t.toHide[i]; i++)
                e.hide();
            this.callActions("afterSetFinal", arguments)
        },
        getFinalMixData: function(t) {
            var e, i = this, n = null, o = null, a = -1;
            for (i.callActions("beforeGetFinalMixData", arguments),
            a = 0; o = t.show[a]; a++)
                t.showPosData[a].finalPosData = o.getPosData();
            for (a = 0; o = t.toHide[a]; a++)
                t.toHidePosData[a].finalPosData = o.getPosData();
            for ((i.config.animation.clampHeight || i.config.animation.clampWidth) && (i.dom.parent.style.height = i.dom.parent.style.width = i.dom.parent.style.overflow = ""),
            i.incPadding || (n = p.getComputedStyle(i.dom.parent)),
            e = i.dom.parent.getBoundingClientRect(),
            t.newX = e.left,
            t.newY = e.top,
            t.newHeight = i.incPadding ? e.height : e.height - parseFloat(n.paddingTop) - parseFloat(n.paddingBottom) - parseFloat(n.borderTop) - parseFloat(n.borderBottom),
            t.newWidth = i.incPadding ? e.width : e.width - parseFloat(n.paddingLeft) - parseFloat(n.paddingRight) - parseFloat(n.borderLeft) - parseFloat(n.borderRight),
            t.viewportDeltaX = t.docState.viewportWidth - this.dom.document.documentElement.clientWidth,
            t.viewportDeltaY = t.docState.viewportHeight - this.dom.document.documentElement.clientHeight,
            t.willSort && i.printSort(!0, t),
            a = 0; o = t.toShow[a]; a++)
                o.hide();
            for (a = 0; o = t.toHide[a]; a++)
                o.show();
            t.willChangeLayout && (h.removeClass(i.dom.container, t.newContainerClassName),
            h.addClass(i.dom.container, i.config.layout.containerClassName)),
            i.callActions("afterGetFinalMixData", arguments)
        },
        getTweenData: function(t) {
            var e = this
              , i = null
              , n = null
              , o = Object.getOwnPropertyNames(e.effectsIn)
              , a = ""
              , s = null
              , r = -1
              , l = -1
              , c = -1
              , u = -1;
            for (e.callActions("beforeGetTweenData", arguments),
            c = 0; i = t.show[c]; c++)
                for ((n = t.showPosData[c]).posIn = new f.StyleData,
                n.posOut = new f.StyleData,
                n.tweenData = new f.StyleData,
                i.isShown ? (n.posIn.x = n.startPosData.x - n.interPosData.x,
                n.posIn.y = n.startPosData.y - n.interPosData.y) : n.posIn.x = n.posIn.y = 0,
                n.posOut.x = n.finalPosData.x - n.interPosData.x,
                n.posOut.y = n.finalPosData.y - n.interPosData.y,
                n.posIn.opacity = i.isShown ? 1 : e.effectsIn.opacity,
                n.posOut.opacity = 1,
                n.tweenData.opacity = n.posOut.opacity - n.posIn.opacity,
                i.isShown || e.config.animation.nudge || (n.posIn.x = n.posOut.x,
                n.posIn.y = n.posOut.y),
                n.tweenData.x = n.posOut.x - n.posIn.x,
                n.tweenData.y = n.posOut.y - n.posIn.y,
                e.config.animation.animateResizeTargets && (n.posIn.width = n.startPosData.width,
                n.posIn.height = n.startPosData.height,
                r = (n.startPosData.width || n.finalPosData.width) - n.interPosData.width,
                n.posIn.marginRight = n.startPosData.marginRight - r,
                l = (n.startPosData.height || n.finalPosData.height) - n.interPosData.height,
                n.posIn.marginBottom = n.startPosData.marginBottom - l,
                n.posOut.width = n.finalPosData.width,
                n.posOut.height = n.finalPosData.height,
                r = (n.finalPosData.width || n.startPosData.width) - n.interPosData.width,
                n.posOut.marginRight = n.finalPosData.marginRight - r,
                l = (n.finalPosData.height || n.startPosData.height) - n.interPosData.height,
                n.posOut.marginBottom = n.finalPosData.marginBottom - l,
                n.tweenData.width = n.posOut.width - n.posIn.width,
                n.tweenData.height = n.posOut.height - n.posIn.height,
                n.tweenData.marginRight = n.posOut.marginRight - n.posIn.marginRight,
                n.tweenData.marginBottom = n.posOut.marginBottom - n.posIn.marginBottom),
                u = 0; a = o[u]; u++)
                    (s = e.effectsIn[a])instanceof f.TransformData && s.value && (n.posIn[a].value = s.value,
                    n.posOut[a].value = 0,
                    n.tweenData[a].value = n.posOut[a].value - n.posIn[a].value,
                    n.posIn[a].unit = n.posOut[a].unit = n.tweenData[a].unit = s.unit);
            for (c = 0; i = t.toHide[c]; c++)
                for ((n = t.toHidePosData[c]).posIn = new f.StyleData,
                n.posOut = new f.StyleData,
                n.tweenData = new f.StyleData,
                n.posIn.x = i.isShown ? n.startPosData.x - n.interPosData.x : 0,
                n.posIn.y = i.isShown ? n.startPosData.y - n.interPosData.y : 0,
                n.posOut.x = e.config.animation.nudge ? 0 : n.posIn.x,
                n.posOut.y = e.config.animation.nudge ? 0 : n.posIn.y,
                n.tweenData.x = n.posOut.x - n.posIn.x,
                n.tweenData.y = n.posOut.y - n.posIn.y,
                e.config.animation.animateResizeTargets && (n.posIn.width = n.startPosData.width,
                n.posIn.height = n.startPosData.height,
                r = n.startPosData.width - n.interPosData.width,
                n.posIn.marginRight = n.startPosData.marginRight - r,
                l = n.startPosData.height - n.interPosData.height,
                n.posIn.marginBottom = n.startPosData.marginBottom - l),
                n.posIn.opacity = 1,
                n.posOut.opacity = e.effectsOut.opacity,
                n.tweenData.opacity = n.posOut.opacity - n.posIn.opacity,
                u = 0; a = o[u]; u++)
                    (s = e.effectsOut[a])instanceof f.TransformData && s.value && (n.posIn[a].value = 0,
                    n.posOut[a].value = s.value,
                    n.tweenData[a].value = n.posOut[a].value - n.posIn[a].value,
                    n.posIn[a].unit = n.posOut[a].unit = n.tweenData[a].unit = s.unit);
            e.callActions("afterGetTweenData", arguments)
        },
        moveTargets: function(t) {
            var e = this
              , i = null
              , n = null
              , o = null
              , a = ""
              , s = !1
              , r = -1
              , l = -1
              , c = e.checkProgress.bind(e);
            for (e.callActions("beforeMoveTargets", arguments),
            l = 0; i = t.show[l]; l++)
                n = new f.IMoveData,
                o = t.showPosData[l],
                a = i.isShown ? "none" : "show",
                (s = e.willTransition(a, t.hasEffect, o.posIn, o.posOut)) && r++,
                i.show(),
                n.posIn = o.posIn,
                n.posOut = o.posOut,
                n.statusChange = a,
                n.staggerIndex = r,
                n.operation = t,
                n.callback = s ? c : null,
                i.move(n);
            for (l = 0; i = t.toHide[l]; l++)
                o = t.toHidePosData[l],
                n = new f.IMoveData,
                a = "hide",
                s = e.willTransition(a, o.posIn, o.posOut),
                n.posIn = o.posIn,
                n.posOut = o.posOut,
                n.statusChange = a,
                n.staggerIndex = l,
                n.operation = t,
                n.callback = s ? c : null,
                i.move(n);
            e.config.animation.animateResizeContainer && (e.dom.parent.style[f.features.transitionProp] = "height " + e.config.animation.duration + "ms ease, width " + e.config.animation.duration + "ms ease ",
            requestAnimationFrame(function() {
                t.startHeight !== t.newHeight && t.viewportDeltaY !== t.startHeight - t.newHeight && (e.dom.parent.style.height = t.newHeight + "px"),
                t.startWidth !== t.newWidth && t.viewportDeltaX !== t.startWidth - t.newWidth && (e.dom.parent.style.width = t.newWidth + "px")
            })),
            t.willChangeLayout && (h.removeClass(e.dom.container, e.config.layout.ContainerClassName),
            h.addClass(e.dom.container, t.newContainerClassName)),
            e.callActions("afterMoveTargets", arguments)
        },
        hasEffect: function() {
            var t = ["scale", "translateX", "translateY", "translateZ", "rotateX", "rotateY", "rotateZ"]
              , e = ""
              , i = null
              , n = !1
              , o = -1;
            if (1 !== this.effectsIn.opacity)
                return this.callFilters("resultHasEffect", !0, arguments);
            for (o = 0; e = t[o]; o++)
                if (0 !== ("undefined" !== (i = this.effectsIn[e]).value ? i.value : i)) {
                    n = !0;
                    break
                }
            return this.callFilters("resultHasEffect", n, arguments)
        },
        willTransition: function(t, e, i, n) {
            var o = !1;
            return o = !!h.isVisible(this.dom.container) && (!!("none" !== t && e || i.x !== n.x || i.y !== n.y) || !!this.config.animation.animateResizeTargets && (i.width !== n.width || i.height !== n.height || i.marginRight !== n.marginRight || i.marginTop !== n.marginTop)),
            this.callFilters("resultWillTransition", o, arguments)
        },
        checkProgress: function(t) {
            this.targetsDone++,
            this.targetsBound === this.targetsDone && this.cleanUp(t)
        },
        cleanUp: function(t) {
            var e = this
              , i = null
              , n = null
              , o = null
              , a = null
              , s = -1;
            for (e.callActions("beforeCleanUp", arguments),
            e.targetsMoved = e.targetsImmovable = e.targetsBound = e.targetsDone = 0,
            s = 0; i = t.show[s]; s++)
                i.cleanUp(),
                i.show();
            for (s = 0; i = t.toHide[s]; s++)
                i.cleanUp(),
                i.hide();
            if (t.willSort && e.printSort(!1, t),
            e.dom.parent.style[f.features.transitionProp] = e.dom.parent.style.height = e.dom.parent.style.width = e.dom.parent.style.overflow = e.dom.parent.style[f.features.perspectiveProp] = e.dom.parent.style[f.features.perspectiveOriginProp] = "",
            t.willChangeLayout && (h.removeClass(e.dom.container, t.startContainerClassName),
            h.addClass(e.dom.container, t.newContainerClassName)),
            t.toRemove.length) {
                for (s = 0; i = e.targets[s]; s++)
                    -1 < t.toRemove.indexOf(i) && ((n = i.dom.el.previousSibling) && "#text" === n.nodeName && (o = i.dom.el.nextSibling) && "#text" === o.nodeName && h.removeWhitespace(n),
                    t.willSort || e.dom.parent.removeChild(i.dom.el),
                    e.targets.splice(s, 1),
                    i.isInDom = !1,
                    s--);
                e.origOrder = e.targets
            }
            t.willSort && (e.targets = t.newOrder),
            e.state = t.newState,
            e.lastOperation = t,
            e.dom.targets = e.state.targets,
            f.events.fire("mixEnd", e.dom.container, {
                state: e.state,
                instance: e
            }, e.dom.document),
            "function" == typeof e.config.callbacks.onMixEnd && e.config.callbacks.onMixEnd.call(e.dom.container, e.state, e),
            t.hasFailed && (f.events.fire("mixFail", e.dom.container, {
                state: e.state,
                instance: e
            }, e.dom.document),
            "function" == typeof e.config.callbacks.onMixFail && e.config.callbacks.onMixFail.call(e.dom.container, e.state, e),
            h.addClass(e.dom.container, h.getClassname(e.config.classNames, "container", e.config.classNames.modifierFailed))),
            "function" == typeof e.userCallback && e.userCallback.call(e.dom.container, e.state, e),
            "function" == typeof e.userDeferred.resolve && e.userDeferred.resolve(e.state),
            e.userCallback = null,
            e.userDeferred = null,
            e.lastClicked = null,
            e.isToggling = !1,
            e.isBusy = !1,
            e.queue.length && (e.callActions("beforeReadQueueCleanUp", arguments),
            a = e.queue.shift(),
            e.userDeferred = a.deferred,
            e.isToggling = a.isToggling,
            e.lastClicked = a.triggerElement,
            a.instruction.command instanceof f.CommandMultimix ? e.multimix.apply(e, a.args) : e.dataset.apply(e, a.args)),
            e.callActions("afterCleanUp", arguments)
        },
        parseMultimixArgs: function(t) {
            var e = this
              , i = new f.UserInstruction
              , n = null
              , o = -1;
            for (i.animate = e.config.animation.enable,
            i.command = new f.CommandMultimix,
            o = 0; o < t.length; o++)
                null !== (n = t[o]) && ("object" == typeof n ? h.extend(i.command, n) : "boolean" == typeof n ? i.animate = n : "function" == typeof n && (i.callback = n));
            return !i.command.insert || i.command.insert instanceof f.CommandInsert || (i.command.insert = e.parseInsertArgs([i.command.insert]).command),
            !i.command.remove || i.command.remove instanceof f.CommandRemove || (i.command.remove = e.parseRemoveArgs([i.command.remove]).command),
            !i.command.filter || i.command.filter instanceof f.CommandFilter || (i.command.filter = e.parseFilterArgs([i.command.filter]).command),
            !i.command.sort || i.command.sort instanceof f.CommandSort || (i.command.sort = e.parseSortArgs([i.command.sort]).command),
            !i.command.changeLayout || i.command.changeLayout instanceof f.CommandChangeLayout || (i.command.changeLayout = e.parseChangeLayoutArgs([i.command.changeLayout]).command),
            i = e.callFilters("instructionParseMultimixArgs", i, arguments),
            h.freeze(i),
            i
        },
        parseFilterArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandFilter,
            n = 0; n < t.length; n++)
                "string" == typeof (i = t[n]) ? e.command.selector = i : null === i ? e.command.collection = [] : "object" == typeof i && h.isElement(i, this.dom.document) ? e.command.collection = [i] : "object" == typeof i && void 0 !== i.length ? e.command.collection = h.arrayFromList(i) : "object" == typeof i ? h.extend(e.command, i) : "boolean" == typeof i ? e.animate = i : "function" == typeof i && (e.callback = i);
            if (e.command.selector && e.command.collection)
                throw new Error(f.messages.errorFilterInvalidArguments());
            return e = this.callFilters("instructionParseFilterArgs", e, arguments),
            h.freeze(e),
            e
        },
        parseSortArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = ""
              , o = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandSort,
            o = 0; o < t.length; o++)
                if (null !== (i = t[o]))
                    switch (typeof i) {
                    case "string":
                        n = i;
                        break;
                    case "object":
                        i.length && (e.command.collection = h.arrayFromList(i));
                        break;
                    case "boolean":
                        e.animate = i;
                        break;
                    case "function":
                        e.callback = i
                    }
            return n && (e.command = this.parseSortString(n, e.command)),
            e = this.callFilters("instructionParseSortArgs", e, arguments),
            h.freeze(e),
            e
        },
        parseInsertArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandInsert,
            n = 0; n < t.length; n++)
                null !== (i = t[n]) && ("number" == typeof i ? e.command.index = i : "string" == typeof i && -1 < ["before", "after"].indexOf(i) ? e.command.position = i : "string" == typeof i ? e.command.collection = h.arrayFromList(h.createElement(i).childNodes) : "object" == typeof i && h.isElement(i, this.dom.document) ? e.command.collection.length ? e.command.sibling = i : e.command.collection = [i] : "object" == typeof i && i.length ? e.command.collection.length ? e.command.sibling = i[0] : e.command.collection = i : "object" == typeof i && i.childNodes && i.childNodes.length ? e.command.collection.length ? e.command.sibling = i.childNodes[0] : e.command.collection = h.arrayFromList(i.childNodes) : "object" == typeof i ? h.extend(e.command, i) : "boolean" == typeof i ? e.animate = i : "function" == typeof i && (e.callback = i));
            if (e.command.index && e.command.sibling)
                throw new Error(f.messages.errorInsertInvalidArguments());
            return !e.command.collection.length && this.config.debug.showWarnings && console.warn(f.messages.warningInsertNoElements()),
            e = this.callFilters("instructionParseInsertArgs", e, arguments),
            h.freeze(e),
            e
        },
        parseRemoveArgs: function(t) {
            var e = this
              , i = new f.UserInstruction
              , n = null
              , o = null
              , a = -1;
            for (i.animate = e.config.animation.enable,
            i.command = new f.CommandRemove,
            a = 0; a < t.length; a++)
                if (null !== (o = t[a]))
                    switch (typeof o) {
                    case "number":
                        e.targets[o] && (i.command.targets[0] = e.targets[o]);
                        break;
                    case "string":
                        i.command.collection = h.arrayFromList(e.dom.parent.querySelectorAll(o));
                        break;
                    case "object":
                        o && o.length ? i.command.collection = o : h.isElement(o, e.dom.document) ? i.command.collection = [o] : h.extend(i.command, o);
                        break;
                    case "boolean":
                        i.animate = o;
                        break;
                    case "function":
                        i.callback = o
                    }
            if (i.command.collection.length)
                for (a = 0; n = e.targets[a]; a++)
                    -1 < i.command.collection.indexOf(n.dom.el) && i.command.targets.push(n);
            return !i.command.targets.length && e.config.debug.showWarnings && console.warn(f.messages.warningRemoveNoElements()),
            h.freeze(i),
            i
        },
        parseDatasetArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandDataset,
            n = 0; n < t.length; n++)
                if (null !== (i = t[n]))
                    switch (typeof i) {
                    case "object":
                        Array.isArray(i) || "number" == typeof i.length ? e.command.dataset = i : h.extend(e.command, i);
                        break;
                    case "boolean":
                        e.animate = i;
                        break;
                    case "function":
                        e.callback = i
                    }
            return h.freeze(e),
            e
        },
        parseChangeLayoutArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandChangeLayout,
            n = 0; n < t.length; n++)
                if (null !== (i = t[n]))
                    switch (typeof i) {
                    case "string":
                        e.command.containerClassName = i;
                        break;
                    case "object":
                        h.extend(e.command, i);
                        break;
                    case "boolean":
                        e.animate = i;
                        break;
                    case "function":
                        e.callback = i
                    }
            return h.freeze(e),
            e
        },
        queueMix: function(t) {
            var e = this
              , i = null
              , n = "";
            return e.callActions("beforeQueueMix", arguments),
            i = h.defer(f.libraries),
            e.config.animation.queue && e.queue.length < e.config.animation.queueLimit ? (t.deferred = i,
            e.queue.push(t),
            e.config.controls.enable && (e.isToggling ? (e.buildToggleArray(t.instruction.command),
            n = e.getToggleSelector(),
            e.updateControls({
                filter: {
                    selector: n
                }
            })) : e.updateControls(t.instruction.command))) : (e.config.debug.showWarnings && console.warn(f.messages.warningMultimixInstanceQueueFull()),
            i.resolve(e.state),
            f.events.fire("mixBusy", e.dom.container, {
                state: e.state,
                instance: e
            }, e.dom.document),
            "function" == typeof e.config.callbacks.onMixBusy && e.config.callbacks.onMixBusy.call(e.dom.container, e.state, e)),
            e.callFilters("promiseQueueMix", i.promise, arguments)
        },
        getDataOperation: function(t) {
            var e = this
              , i = new f.Operation
              , n = [];
            if (i = e.callFilters("operationUnmappedGetDataOperation", i, arguments),
            e.dom.targets.length && !(n = e.state.activeDataset || []).length)
                throw new Error(f.messages.errorDatasetNotSet());
            return i.id = h.randomHex(),
            i.startState = e.state,
            i.startDataset = n,
            i.newDataset = t.slice(),
            e.diffDatasets(i),
            i.startOrder = e.targets,
            i.newOrder = i.show,
            e.config.animation.enable && (e.getStartMixData(i),
            e.setInter(i),
            i.docState = h.getDocumentState(e.dom.document),
            e.getInterMixData(i),
            e.setFinal(i),
            e.getFinalMixData(i),
            e.parseEffects(),
            i.hasEffect = e.hasEffect(),
            e.getTweenData(i)),
            e.targets = i.show.slice(),
            i.newState = e.buildState(i),
            Array.prototype.push.apply(e.targets, i.toRemove),
            i = e.callFilters("operationMappedGetDataOperation", i, arguments)
        },
        diffDatasets: function(t) {
            var e = this
              , i = []
              , n = []
              , o = []
              , a = null
              , s = null
              , r = null
              , l = null
              , c = null
              , u = {}
              , d = ""
              , p = -1;
            for (e.callActions("beforeDiffDatasets", arguments),
            p = 0; a = t.newDataset[p]; p++) {
                if (void 0 === (d = a[e.config.data.uidKey]) || d.toString().length < 1)
                    throw new TypeError(f.messages.errorDatasetInvalidUidKey({
                        uidKey: e.config.data.uidKey
                    }));
                if (u[d])
                    throw new Error(f.messages.errorDatasetDuplicateUid({
                        uid: d
                    }));
                u[d] = !0,
                (s = e.cache[d])instanceof f.Target ? (e.config.data.dirtyCheck && !h.deepEquals(a, s.data) && (r = s.render(a),
                s.data = a,
                r !== s.dom.el && (s.isInDom && (s.unbindEvents(),
                e.dom.parent.replaceChild(r, s.dom.el)),
                s.isShown || (r.style.display = "none"),
                s.dom.el = r,
                s.isInDom && s.bindEvents())),
                r = s.dom.el) : ((s = new f.Target).init(null, e, a),
                s.hide()),
                s.isInDom ? (c = s.dom.el.nextElementSibling,
                n.push(d),
                l && (l.lastElementChild && l.appendChild(e.dom.document.createTextNode(" ")),
                e.insertDatasetFrag(l, s.dom.el, o),
                l = null)) : ((l = l || e.dom.document.createDocumentFragment()).lastElementChild && l.appendChild(e.dom.document.createTextNode(" ")),
                l.appendChild(s.dom.el),
                s.isInDom = !0,
                s.unbindEvents(),
                s.bindEvents(),
                s.hide(),
                t.toShow.push(s),
                o.push(s)),
                t.show.push(s)
            }
            for (l && ((c = c || e.config.layout.siblingAfter) && l.appendChild(e.dom.document.createTextNode(" ")),
            e.insertDatasetFrag(l, c, o)),
            p = 0; a = t.startDataset[p]; p++)
                d = a[e.config.data.uidKey],
                s = e.cache[d],
                t.show.indexOf(s) < 0 ? (t.hide.push(s),
                t.toHide.push(s),
                t.toRemove.push(s)) : i.push(d);
            h.isEqualArray(i, n) || (t.willSort = !0),
            e.callActions("afterDiffDatasets", arguments)
        },
        insertDatasetFrag: function(t, e, i) {
            var n = e ? h.arrayFromList(this.dom.parent.children).indexOf(e) : this.targets.length;
            for (this.dom.parent.insertBefore(t, e); i.length; )
                this.targets.splice(n, 0, i.shift()),
                n++
        },
        willSort: function(t, e) {
            var i = !1;
            return i = !!(this.config.behavior.liveSort || "random" === t.order || t.attribute !== e.attribute || t.order !== e.order || t.collection !== e.collection || null === t.next && e.next || t.next && null === e.next) || !(!t.next || !e.next) && this.willSort(t.next, e.next),
            this.callFilters("resultWillSort", i, arguments)
        },
        show: function() {
            return this.filter("all")
        },
        hide: function() {
            return this.filter("none")
        },
        isMixing: function() {
            return this.isBusy
        },
        filter: function() {
            var t = this.parseFilterArgs(arguments);
            return this.multimix({
                filter: t.command
            }, t.animate, t.callback)
        },
        toggleOn: function() {
            var t, e = this, i = e.parseFilterArgs(arguments), n = i.command.selector;
            return e.isToggling = !0,
            e.toggleArray.indexOf(n) < 0 && e.toggleArray.push(n),
            t = e.getToggleSelector(),
            e.multimix({
                filter: t
            }, i.animate, i.callback)
        },
        toggleOff: function() {
            var t, e = this, i = e.parseFilterArgs(arguments), n = i.command.selector, o = e.toggleArray.indexOf(n);
            return e.isToggling = !0,
            -1 < o && e.toggleArray.splice(o, 1),
            t = e.getToggleSelector(),
            e.multimix({
                filter: t
            }, i.animate, i.callback)
        },
        sort: function() {
            var t = this.parseSortArgs(arguments);
            return this.multimix({
                sort: t.command
            }, t.animate, t.callback)
        },
        changeLayout: function() {
            var t = this.parseChangeLayoutArgs(arguments);
            return this.multimix({
                changeLayout: t.command
            }, t.animate, t.callback)
        },
        dataset: function() {
            var t = this
              , e = t.parseDatasetArgs(arguments)
              , i = null
              , n = null
              , o = !1;
            return t.callActions("beforeDataset", arguments),
            t.isBusy ? ((n = new f.QueueItem).args = arguments,
            n.instruction = e,
            t.queueMix(n)) : (e.callback && (t.userCallback = e.callback),
            o = e.animate ^ t.config.animation.enable ? e.animate : t.config.animation.enable,
            i = t.getDataOperation(e.command.dataset),
            t.goMix(o, i))
        },
        multimix: function() {
            var t = this
              , e = null
              , i = !1
              , n = null
              , o = t.parseMultimixArgs(arguments);
            return t.callActions("beforeMultimix", arguments),
            t.isBusy ? ((n = new f.QueueItem).args = arguments,
            n.instruction = o,
            n.triggerElement = t.lastClicked,
            n.isToggling = t.isToggling,
            t.queueMix(n)) : (e = t.getOperation(o.command),
            t.config.controls.enable && (o.command.filter && !t.isToggling && (t.toggleArray.length = 0,
            t.buildToggleArray(e.command)),
            t.queue.length < 1 && t.updateControls(e.command)),
            o.callback && (t.userCallback = o.callback),
            i = o.animate ^ t.config.animation.enable ? o.animate : t.config.animation.enable,
            t.callFilters("operationMultimix", e, arguments),
            t.goMix(i, e))
        },
        getOperation: function(t) {
            var e = this
              , i = t.sort
              , n = t.filter
              , o = t.changeLayout
              , a = t.remove
              , s = t.insert
              , r = new f.Operation;
            return (r = e.callFilters("operationUnmappedGetOperation", r, arguments)).id = h.randomHex(),
            r.command = t,
            r.startState = e.state,
            r.triggerElement = e.lastClicked,
            e.isBusy ? (e.config.debug.showWarnings && console.warn(f.messages.warningGetOperationInstanceBusy()),
            null) : (s && e.insertTargets(s, r),
            a && (r.toRemove = a.targets),
            r.startSort = r.newSort = r.startState.activeSort,
            r.startOrder = r.newOrder = e.targets,
            i && (r.startSort = r.startState.activeSort,
            r.newSort = i,
            r.willSort = e.willSort(i, r.startState.activeSort),
            r.willSort && e.sortOperation(r)),
            r.startFilter = r.startState.activeFilter,
            r.newFilter = n || h.extend(new f.CommandFilter, r.startFilter),
            "all" === r.newFilter.selector ? r.newFilter.selector = e.config.selectors.target : "none" === r.newFilter.selector && (r.newFilter.selector = ""),
            e.filterOperation(r),
            r.startContainerClassName = r.startState.activeContainerClassName,
            o ? (r.newContainerClassName = o.containerClassName,
            r.newContainerClassName !== r.startContainerClassName && (r.willChangeLayout = !0)) : r.newContainerClassName = r.startContainerClassName,
            e.config.animation.enable && (e.getStartMixData(r),
            e.setInter(r),
            r.docState = h.getDocumentState(e.dom.document),
            e.getInterMixData(r),
            e.setFinal(r),
            e.getFinalMixData(r),
            e.parseEffects(),
            r.hasEffect = e.hasEffect(),
            e.getTweenData(r)),
            r.willSort && (e.targets = r.newOrder),
            r.newState = e.buildState(r),
            e.callFilters("operationMappedGetOperation", r, arguments))
        },
        tween: function(t, e) {
            var i = null
              , n = null
              , o = -1
              , a = -1;
            for (e = Math.min(e, 1),
            e = Math.max(e, 0),
            a = 0; i = t.show[a]; a++)
                n = t.showPosData[a],
                i.applyTween(n, e);
            for (a = 0; i = t.hide[a]; a++)
                i.isShown && i.hide(),
                -1 < (o = t.toHide.indexOf(i)) && (n = t.toHidePosData[o],
                i.isShown || i.show(),
                i.applyTween(n, e))
        },
        insert: function() {
            var t = this.parseInsertArgs(arguments);
            return this.multimix({
                insert: t.command
            }, t.animate, t.callback)
        },
        insertBefore: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(t.command.collection, "before", t.command.sibling, t.animate, t.callback)
        },
        insertAfter: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(t.command.collection, "after", t.command.sibling, t.animate, t.callback)
        },
        prepend: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(0, t.command.collection, t.animate, t.callback)
        },
        append: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(this.state.totalTargets, t.command.collection, t.animate, t.callback)
        },
        remove: function() {
            var t = this.parseRemoveArgs(arguments);
            return this.multimix({
                remove: t.command
            }, t.animate, t.callback)
        },
        getConfig: function(t) {
            var e = null;
            return e = t ? h.getProperty(this.config, t) : this.config,
            this.callFilters("valueGetConfig", e, arguments)
        },
        configure: function(t) {
            this.callActions("beforeConfigure", arguments),
            h.extend(this.config, t, !0, !0),
            this.callActions("afterConfigure", arguments)
        },
        getState: function() {
            var t;
            return t = new f.State,
            h.extend(t, this.state),
            h.freeze(t),
            this.callFilters("stateGetState", t, arguments)
        },
        forceRefresh: function() {
            this.indexTargets()
        },
        forceRender: function() {
            var t = this
              , e = null
              , i = null
              , n = "";
            for (n in t.cache)
                (i = (e = t.cache[n]).render(e.data)) !== e.dom.el && (e.isInDom && (e.unbindEvents(),
                t.dom.parent.replaceChild(i, e.dom.el)),
                e.isShown || (i.style.display = "none"),
                e.dom.el = i,
                e.isInDom && e.bindEvents());
            t.state = t.buildState(t.lastOperation)
        },
        destroy: function(t) {
            var e = this
              , i = null
              , n = null
              , o = 0;
            for (e.callActions("beforeDestroy", arguments),
            o = 0; i = e.controls[o]; o++)
                i.removeBinding(e);
            for (o = 0; n = e.targets[o]; o++)
                t && n.show(),
                n.unbindEvents();
            e.dom.container.id.match(/^MixItUp/) && e.dom.container.removeAttribute("id"),
            delete f.instances[e.id],
            e.callActions("afterDestroy", arguments)
        }
    }),
    f.IMoveData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.posIn = null,
        this.posOut = null,
        this.operation = null,
        this.callback = null,
        this.statusChange = "",
        this.duration = -1,
        this.staggerIndex = -1,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.IMoveData),
    f.IMoveData.prototype = Object.create(f.Base.prototype),
    f.IMoveData.prototype.constructor = f.IMoveData,
    f.TargetDom = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.el = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.TargetDom),
    f.TargetDom.prototype = Object.create(f.Base.prototype),
    f.TargetDom.prototype.constructor = f.TargetDom,
    f.Target = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.id = "",
        this.sortString = "",
        this.mixer = null,
        this.callback = null,
        this.isShown = !1,
        this.isBound = !1,
        this.isExcluded = !1,
        this.isInDom = !1,
        this.handler = null,
        this.operation = null,
        this.data = null,
        this.dom = new f.TargetDom,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Target),
    f.Target.prototype = Object.create(f.Base.prototype),
    h.extend(f.Target.prototype, {
        constructor: f.Target,
        init: function(t, e, i) {
            var n = this
              , o = "";
            if (n.callActions("beforeInit", arguments),
            n.mixer = e,
            t = t || n.render(i),
            n.cacheDom(t),
            n.bindEvents(),
            "none" !== n.dom.el.style.display && (n.isShown = !0),
            i && e.config.data.uidKey) {
                if (void 0 === (o = i[e.config.data.uidKey]) || o.toString().length < 1)
                    throw new TypeError(f.messages.errorDatasetInvalidUidKey({
                        uidKey: e.config.data.uidKey
                    }));
                n.id = o,
                n.data = i,
                e.cache[o] = n
            }
            n.callActions("afterInit", arguments)
        },
        render: function(t) {
            var e, i = null, n = null, o = null;
            if (this.callActions("beforeRender", arguments),
            "function" != typeof (i = this.callFilters("renderRender", this.mixer.config.render.target, arguments)))
                throw new TypeError(f.messages.errorDatasetRendererNotSet());
            return (e = i(t)) && "object" == typeof e && h.isElement(e) ? n = e : "string" == typeof e && ((o = document.createElement("div")).innerHTML = e,
            n = o.firstElementChild),
            this.callFilters("elRender", n, arguments)
        },
        cacheDom: function(t) {
            this.callActions("beforeCacheDom", arguments),
            this.dom.el = t,
            this.callActions("afterCacheDom", arguments)
        },
        getSortString: function(t) {
            var e = this.dom.el.getAttribute("data-" + t) || "";
            this.callActions("beforeGetSortString", arguments),
            e = isNaN(1 * e) ? e.toLowerCase() : 1 * e,
            this.sortString = e,
            this.callActions("afterGetSortString", arguments)
        },
        show: function() {
            var t = this;
            t.callActions("beforeShow", arguments),
            t.isShown || (t.dom.el.style.display = "",
            t.isShown = !0),
            t.callActions("afterShow", arguments)
        },
        hide: function() {
            var t = this;
            t.callActions("beforeHide", arguments),
            t.isShown && (t.dom.el.style.display = "none",
            t.isShown = !1),
            t.callActions("afterHide", arguments)
        },
        move: function(t) {
            var e = this;
            e.callActions("beforeMove", arguments),
            e.isExcluded || e.mixer.targetsMoved++,
            e.applyStylesIn(t),
            requestAnimationFrame(function() {
                e.applyStylesOut(t)
            }),
            e.callActions("afterMove", arguments)
        },
        applyTween: function(t, e) {
            var i = this
              , n = ""
              , o = null
              , a = t.posIn
              , s = []
              , r = new f.StyleData
              , l = -1;
            for (i.callActions("beforeApplyTween", arguments),
            r.x = a.x,
            r.y = a.y,
            0 === e ? i.hide() : i.isShown || i.show(),
            l = 0; n = f.features.TWEENABLE[l]; l++)
                if (o = t.tweenData[n],
                "x" === n) {
                    if (!o)
                        continue;
                    r.x = a.x + o * e
                } else if ("y" === n) {
                    if (!o)
                        continue;
                    r.y = a.y + o * e
                } else if (o instanceof f.TransformData) {
                    if (!o.value)
                        continue;
                    r[n].value = a[n].value + o.value * e,
                    r[n].unit = o.unit,
                    s.push(n + "(" + r[n].value + o.unit + ")")
                } else {
                    if (!o)
                        continue;
                    r[n] = a[n] + o * e,
                    i.dom.el.style[n] = r[n]
                }
            (r.x || r.y) && s.unshift("translate(" + r.x + "px, " + r.y + "px)"),
            s.length && (i.dom.el.style[f.features.transformProp] = s.join(" ")),
            i.callActions("afterApplyTween", arguments)
        },
        applyStylesIn: function(t) {
            var e = this
              , i = t.posIn
              , n = 1 !== e.mixer.effectsIn.opacity
              , o = [];
            e.callActions("beforeApplyStylesIn", arguments),
            o.push("translate(" + i.x + "px, " + i.y + "px)"),
            e.mixer.config.animation.animateResizeTargets && ("show" !== t.statusChange && (e.dom.el.style.width = i.width + "px",
            e.dom.el.style.height = i.height + "px"),
            e.dom.el.style.marginRight = i.marginRight + "px",
            e.dom.el.style.marginBottom = i.marginBottom + "px"),
            n && (e.dom.el.style.opacity = i.opacity),
            "show" === t.statusChange && (o = o.concat(e.mixer.transformIn)),
            e.dom.el.style[f.features.transformProp] = o.join(" "),
            e.callActions("afterApplyStylesIn", arguments)
        },
        applyStylesOut: function(t) {
            var e = this
              , i = []
              , n = []
              , o = e.mixer.config.animation.animateResizeTargets
              , a = void 0 !== e.mixer.effectsIn.opacity;
            if (e.callActions("beforeApplyStylesOut", arguments),
            i.push(e.writeTransitionRule(f.features.transformRule, t.staggerIndex)),
            "none" !== t.statusChange && i.push(e.writeTransitionRule("opacity", t.staggerIndex, t.duration)),
            o && (i.push(e.writeTransitionRule("width", t.staggerIndex, t.duration)),
            i.push(e.writeTransitionRule("height", t.staggerIndex, t.duration)),
            i.push(e.writeTransitionRule("margin", t.staggerIndex, t.duration))),
            !t.callback)
                return e.mixer.targetsImmovable++,
                void (e.mixer.targetsMoved === e.mixer.targetsImmovable && e.mixer.cleanUp(t.operation));
            switch (e.operation = t.operation,
            e.callback = t.callback,
            e.isExcluded || e.mixer.targetsBound++,
            e.isBound = !0,
            e.applyTransition(i),
            o && 0 < t.posOut.width && 0 < t.posOut.height && (e.dom.el.style.width = t.posOut.width + "px",
            e.dom.el.style.height = t.posOut.height + "px",
            e.dom.el.style.marginRight = t.posOut.marginRight + "px",
            e.dom.el.style.marginBottom = t.posOut.marginBottom + "px"),
            e.mixer.config.animation.nudge || "hide" !== t.statusChange || n.push("translate(" + t.posOut.x + "px, " + t.posOut.y + "px)"),
            t.statusChange) {
            case "hide":
                a && (e.dom.el.style.opacity = e.mixer.effectsOut.opacity),
                n = n.concat(e.mixer.transformOut);
                break;
            case "show":
                a && (e.dom.el.style.opacity = 1)
            }
            (e.mixer.config.animation.nudge || !e.mixer.config.animation.nudge && "hide" !== t.statusChange) && n.push("translate(" + t.posOut.x + "px, " + t.posOut.y + "px)"),
            e.dom.el.style[f.features.transformProp] = n.join(" "),
            e.callActions("afterApplyStylesOut", arguments)
        },
        writeTransitionRule: function(t, e, i) {
            var n, o = this.getDelay(e);
            return n = t + " " + (0 < i ? i : this.mixer.config.animation.duration) + "ms " + o + "ms " + ("opacity" === t ? "linear" : this.mixer.config.animation.easing),
            this.callFilters("ruleWriteTransitionRule", n, arguments)
        },
        getDelay: function(t) {
            var e, i = this;
            return "function" == typeof i.mixer.config.animation.staggerSequence && (t = i.mixer.config.animation.staggerSequence.call(i, t, i.state)),
            e = i.mixer.staggerDuration ? t * i.mixer.staggerDuration : 0,
            i.callFilters("delayGetDelay", e, arguments)
        },
        applyTransition: function(t) {
            var e = t.join(", ");
            this.callActions("beforeApplyTransition", arguments),
            this.dom.el.style[f.features.transitionProp] = e,
            this.callActions("afterApplyTransition", arguments)
        },
        handleTransitionEnd: function(t) {
            var e = this
              , i = t.propertyName
              , n = e.mixer.config.animation.animateResizeTargets;
            e.callActions("beforeHandleTransitionEnd", arguments),
            e.isBound && t.target.matches(e.mixer.config.selectors.target) && (-1 < i.indexOf("transform") || -1 < i.indexOf("opacity") || n && -1 < i.indexOf("height") || n && -1 < i.indexOf("width") || n && -1 < i.indexOf("margin")) && (e.callback.call(e, e.operation),
            e.isBound = !1,
            e.callback = null,
            e.operation = null),
            e.callActions("afterHandleTransitionEnd", arguments)
        },
        eventBus: function(t) {
            switch (this.callActions("beforeEventBus", arguments),
            t.type) {
            case "webkitTransitionEnd":
            case "transitionend":
                this.handleTransitionEnd(t)
            }
            this.callActions("afterEventBus", arguments)
        },
        unbindEvents: function() {
            var t = this;
            t.callActions("beforeUnbindEvents", arguments),
            h.off(t.dom.el, "webkitTransitionEnd", t.handler),
            h.off(t.dom.el, "transitionend", t.handler),
            t.callActions("afterUnbindEvents", arguments)
        },
        bindEvents: function() {
            var t, e = this;
            e.callActions("beforeBindEvents", arguments),
            t = "webkit" === f.features.transitionPrefix ? "webkitTransitionEnd" : "transitionend",
            e.handler = function(t) {
                return e.eventBus(t)
            }
            ,
            h.on(e.dom.el, t, e.handler),
            e.callActions("afterBindEvents", arguments)
        },
        getPosData: function(t) {
            var e = this
              , i = {}
              , n = null
              , o = new f.StyleData;
            return e.callActions("beforeGetPosData", arguments),
            o.x = e.dom.el.offsetLeft,
            o.y = e.dom.el.offsetTop,
            (e.mixer.config.animation.animateResizeTargets || t) && (n = e.dom.el.getBoundingClientRect(),
            o.top = n.top,
            o.right = n.right,
            o.bottom = n.bottom,
            o.left = n.left,
            o.width = n.width,
            o.height = n.height),
            e.mixer.config.animation.animateResizeTargets && (i = p.getComputedStyle(e.dom.el),
            o.marginBottom = parseFloat(i.marginBottom),
            o.marginRight = parseFloat(i.marginRight)),
            e.callFilters("posDataGetPosData", o, arguments)
        },
        cleanUp: function() {
            var t = this;
            t.callActions("beforeCleanUp", arguments),
            t.dom.el.style[f.features.transformProp] = "",
            t.dom.el.style[f.features.transitionProp] = "",
            t.dom.el.style.opacity = "",
            t.mixer.config.animation.animateResizeTargets && (t.dom.el.style.width = "",
            t.dom.el.style.height = "",
            t.dom.el.style.marginRight = "",
            t.dom.el.style.marginBottom = ""),
            t.callActions("afterCleanUp", arguments)
        }
    }),
    f.Collection = function(t) {
        var e = null
          , i = -1;
        for (this.callActions("beforeConstruct"),
        i = 0; e = t[i]; i++)
            this[i] = e;
        this.length = t.length,
        this.callActions("afterConstruct"),
        h.freeze(this)
    }
    ,
    f.BaseStatic.call(f.Collection),
    f.Collection.prototype = Object.create(f.Base.prototype),
    h.extend(f.Collection.prototype, {
        constructor: f.Collection,
        mixitup: function(t) {
            var e = null
              , i = Array.prototype.slice.call(arguments)
              , n = []
              , o = -1;
            for (this.callActions("beforeMixitup"),
            i.shift(),
            o = 0; e = this[o]; o++)
                n.push(e[t].apply(e, i));
            return this.callFilters("promiseMixitup", h.all(n, f.libraries), arguments)
        }
    }),
    f.Operation = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.id = "",
        this.args = [],
        this.command = null,
        this.showPosData = [],
        this.toHidePosData = [],
        this.startState = null,
        this.newState = null,
        this.docState = null,
        this.willSort = !1,
        this.willChangeLayout = !1,
        this.hasEffect = !1,
        this.hasFailed = !1,
        this.triggerElement = null,
        this.show = [],
        this.hide = [],
        this.matching = [],
        this.toShow = [],
        this.toHide = [],
        this.toMove = [],
        this.toRemove = [],
        this.startOrder = [],
        this.newOrder = [],
        this.startSort = null,
        this.newSort = null,
        this.startFilter = null,
        this.newFilter = null,
        this.startDataset = null,
        this.newDataset = null,
        this.viewportDeltaX = 0,
        this.viewportDeltaY = 0,
        this.startX = 0,
        this.startY = 0,
        this.startHeight = 0,
        this.startWidth = 0,
        this.newX = 0,
        this.newY = 0,
        this.newHeight = 0,
        this.newWidth = 0,
        this.startContainerClassName = "",
        this.startDisplay = "",
        this.newContainerClassName = "",
        this.newDisplay = "",
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Operation),
    f.Operation.prototype = Object.create(f.Base.prototype),
    f.Operation.prototype.constructor = f.Operation,
    f.State = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.id = "",
        this.activeFilter = null,
        this.activeSort = null,
        this.activeContainerClassName = "",
        this.container = null,
        this.targets = [],
        this.hide = [],
        this.show = [],
        this.matching = [],
        this.totalTargets = -1,
        this.totalShow = -1,
        this.totalHide = -1,
        this.totalMatching = -1,
        this.hasFailed = !1,
        this.triggerElement = null,
        this.activeDataset = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.State),
    f.State.prototype = Object.create(f.Base.prototype),
    f.State.prototype.constructor = f.State,
    f.UserInstruction = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.command = {},
        this.animate = !1,
        this.callback = null,
        this.callActions("afterConstruct"),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.UserInstruction),
    f.UserInstruction.prototype = Object.create(f.Base.prototype),
    f.UserInstruction.prototype.constructor = f.UserInstruction,
    f.Messages = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function",
        this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element",
        this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`",
        this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`",
        this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}',
        this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?',
        this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`",
        this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items',
        this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.',
        this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both",
        this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container",
        this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both",
        this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`",
        this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets",
        this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`",
        this.ERROR_SORT_NON_EXISTENT_ELEMENT = "[MixItUp] An element to be sorted does not already exist in the container",
        this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.",
        this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`",
        this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`",
        this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.",
        this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.",
        this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.",
        this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output',
        this.callActions("afterConstruct"),
        this.compileTemplates(),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Messages),
    f.Messages.prototype = Object.create(f.Base.prototype),
    f.Messages.prototype.constructor = f.Messages,
    f.Messages.prototype.compileTemplates = function() {
        var t = ""
          , e = "";
        for (t in this)
            "string" == typeof (e = this[t]) && (this[h.camelCase(t)] = h.template(e))
    }
    ,
    f.messages = new f.Messages,
    f.Facade = function(t) {
        f.Base.call(this),
        this.callActions("beforeConstruct", arguments),
        this.configure = t.configure.bind(t),
        this.show = t.show.bind(t),
        this.hide = t.hide.bind(t),
        this.filter = t.filter.bind(t),
        this.toggleOn = t.toggleOn.bind(t),
        this.toggleOff = t.toggleOff.bind(t),
        this.sort = t.sort.bind(t),
        this.changeLayout = t.changeLayout.bind(t),
        this.multimix = t.multimix.bind(t),
        this.dataset = t.dataset.bind(t),
        this.tween = t.tween.bind(t),
        this.insert = t.insert.bind(t),
        this.insertBefore = t.insertBefore.bind(t),
        this.insertAfter = t.insertAfter.bind(t),
        this.prepend = t.prepend.bind(t),
        this.append = t.append.bind(t),
        this.remove = t.remove.bind(t),
        this.destroy = t.destroy.bind(t),
        this.forceRefresh = t.forceRefresh.bind(t),
        this.forceRender = t.forceRender.bind(t),
        this.isMixing = t.isMixing.bind(t),
        this.getOperation = t.getOperation.bind(t),
        this.getConfig = t.getConfig.bind(t),
        this.getState = t.getState.bind(t),
        this.callActions("afterConstruct", arguments),
        h.freeze(this),
        h.seal(this)
    }
    ,
    f.BaseStatic.call(f.Facade),
    f.Facade.prototype = Object.create(f.Base.prototype),
    f.Facade.prototype.constructor = f.Facade,
    "object" == typeof exports && "object" == typeof module ? module.exports = f : "function" == typeof define && define.amd ? define(function() {
        return f
    }) : void 0 !== p.mixitup && "function" == typeof p.mixitup || (p.mixitup = f),
    f.BaseStatic.call(f.constructor),
    f.NAME = "mixitup",
    f.CORE_VERSION = "3.3.1"
}(window),
function() {
    function e(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    var i, t, s, r, o, a;
    function n() {
        this.update = e(this.update, this)
    }
    function l(t) {
        this.propertyArray = e(this.propertyArray, this),
        this.update = e(this.update, this),
        this.update(t)
    }
    n.prototype.update = function(o) {
        var a, t, e;
        for (t in o)
            e = o[t],
            "items" !== t && (this[t] = e);
        return this.items = function() {
            var t, e, i, n;
            for (n = [],
            t = 0,
            e = (i = o.items).length; t < e; t++)
                a = i[t],
                n.push(new r(a));
            return n
        }()
    }
    ,
    t = n,
    l.prototype.update = function(t) {
        var e, i;
        for (e in t)
            i = t[e],
            "properties" !== e && (this[e] = i);
        return this.properties = s.Utils.extend({}, t.properties)
    }
    ,
    l.prototype.propertyArray = function() {
        var t, e, i, n;
        for (t in n = [],
        i = this.properties)
            e = i[t],
            n.push({
                name: t,
                value: e
            });
        return n
    }
    ,
    r = l,
    s = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new t,
        init: function(t, e) {
            return null == e && (e = {}),
            s.configure(e),
            s.Utils.log("Initialising CartJS."),
            s.cart.update(t),
            s.settings.dataAPI && (s.Utils.log('"dataAPI" setting is true, initialising Data API.'),
            s.Data.init()),
            s.settings.requestBodyClass && (s.Utils.log('"requestBodyClass" set, adding event listeners.'),
            jQuery(document).on("cart.requestStarted", function() {
                return jQuery("body").addClass(s.settings.requestBodyClass)
            }),
            jQuery(document).on("cart.requestComplete", function() {
                return jQuery("body").removeClass(s.settings.requestBodyClass)
            })),
            s.Rivets.init(),
            jQuery(document).trigger("cart.ready", [s.cart])
        },
        configure: function(t) {
            return null == t && (t = {}),
            s.Utils.extend(s.settings, t)
        }
    },
    null == window.console && (window.console = {},
    window.console.log = function() {}
    ),
    s.Utils = {
        log: function() {
            return s.Utils.console(console.log, arguments)
        },
        error: function() {
            return s.Utils.console(console.error, arguments)
        },
        console: function(t, e) {
            if (s.settings.debug && "undefined" != typeof console && null !== console)
                return (e = Array.prototype.slice.call(e)).unshift("[CartJS]:"),
                t.apply(console, e)
        },
        wrapKeys: function(t, e, i) {
            var n, o, a;
            for (n in null == e && (e = "properties"),
            a = {},
            t)
                o = t[n],
                a[e + "[" + n + "]"] = null != i ? i : o;
            return a
        },
        unwrapKeys: function(t, e, i) {
            var n, o, a;
            for (n in null == e && (e = "properties"),
            o = {},
            t)
                a = t[n],
                o[n.replace(e + "[", "").replace("]", "")] = null != i ? i : a;
            return o
        },
        extend: function(t, e) {
            var i, n;
            for (i in e)
                n = e[i],
                t[i] = n;
            return t
        },
        clone: function(t) {
            var e, i;
            if (null == t || "object" != typeof t)
                return t;
            for (e in i = new t.constructor,
            t)
                i[e] = clone(t[e]);
            return i
        },
        isArray: Array.isArray || function(t) {
            return "[object Array]" === {}.toString.call(t)
        }
        ,
        ensureArray: function(t) {
            return s.Utils.isArray(t) ? t : null != t ? [t] : []
        },
        formatMoney: function(t, e, i, n) {
            var o, a;
            return null == n && (n = ""),
            n = n || s.settings.currency,
            null != window.Currency && n !== s.settings.currency && (t = Currency.convert(t, s.settings.currency, n),
            null != (null != (o = window.Currency) ? o.moneyFormats : void 0) && n in window.Currency.moneyFormats && (e = window.Currency.moneyFormats[n][i])),
            null != (null != (a = window.Shopify) ? a.formatMoney : void 0) ? Shopify.formatMoney(t, e) : t
        },
        getSizedImageUrl: function(t, e) {
            var i, n;
            return null != (null != (i = window.Shopify) && null != (n = i.Image) ? n.getSizedImageUrl : void 0) ? t ? Shopify.Image.getSizedImageUrl(t, e) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", e).replace("-_", "-") : t || "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    },
    o = !(a = []),
    s.Queue = {
        add: function(t, e, i) {
            var n;
            if (null == i && (i = {}),
            n = {
                url: t,
                data: e,
                type: i.type || "POST",
                dataType: i.dataType || "json",
                success: s.Utils.ensureArray(i.success),
                error: s.Utils.ensureArray(i.error),
                complete: s.Utils.ensureArray(i.complete)
            },
            i.updateCart && n.success.push(s.cart.update),
            a.push(n),
            !o)
                return jQuery(document).trigger("cart.requestStarted", [s.cart]),
                s.Queue.process()
        },
        process: function() {
            var t;
            return a.length ? (o = !0,
            (t = a.shift()).complete = s.Queue.process,
            jQuery.ajax(t)) : (o = !1,
            void jQuery(document).trigger("cart.requestComplete", [s.cart]))
        }
    },
    s.Core = {
        getCart: function(t) {
            return null == t && (t = {}),
            t.type = "GET",
            t.updateCart = !0,
            s.Queue.add("/cart.js", {}, t)
        },
        addItem: function(t, e, i, n) {
            var o;
            return null == e && (e = 1),
            null == i && (i = {}),
            null == n && (n = {}),
            (o = s.Utils.wrapKeys(i)).id = t,
            o.quantity = e,
            s.Queue.add("/cart/add.js", o, n),
            s.Core.getCart()
        },
        updateItem: function(t, e, i, n) {
            var o;
            return null == i && (i = {}),
            null == n && (n = {}),
            (o = s.Utils.wrapKeys(i)).line = t,
            null != e && (o.quantity = e),
            n.updateCart = !0,
            s.Queue.add("/cart/change.js", o, n)
        },
        removeItem: function(t, e) {
            return null == e && (e = {}),
            s.Core.updateItem(t, 0, {}, e)
        },
        updateItemById: function(t, e, i, n) {
            var o;
            return null == i && (i = {}),
            null == n && (n = {}),
            (o = s.Utils.wrapKeys(i)).id = t,
            null != e && (o.quantity = e),
            n.updateCart = !0,
            s.Queue.add("/cart/change.js", o, n)
        },
        updateItemQuantitiesById: function(t, e) {
            return null == t && (t = {}),
            null == e && (e = {}),
            e.updateCart = !0,
            s.Queue.add("/cart/update.js", {
                updates: t
            }, e)
        },
        removeItemById: function(t, e) {
            var i;
            return null == e && (e = {}),
            i = {
                id: t,
                quantity: 0
            },
            e.updateCart = !0,
            s.Queue.add("/cart/change.js", i, e)
        },
        clear: function(t) {
            return null == t && (t = {}),
            t.updateCart = !0,
            s.Queue.add("/cart/clear.js", {}, t)
        },
        getAttribute: function(t, e) {
            return t in s.cart.attributes ? s.cart.attributes[t] : e
        },
        setAttribute: function(t, e, i) {
            var n;
            return null == i && (i = {}),
            (n = {})[t] = e,
            s.Core.setAttributes(n, i)
        },
        getAttributes: function() {
            return s.cart.attributes
        },
        setAttributes: function(t, e) {
            return null == t && (t = {}),
            null == e && (e = {}),
            e.updateCart = !0,
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(t, "attributes"), e)
        },
        clearAttributes: function(t) {
            return null == t && (t = {}),
            t.updateCart = !0,
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(s.Core.getAttributes(), "attributes", ""), t)
        },
        getNote: function() {
            return s.cart.note
        },
        setNote: function(t, e) {
            return null == e && (e = {}),
            e.updateCart = !0,
            s.Queue.add("/cart/update.js", {
                note: t
            }, e)
        }
    },
    i = null,
    s.Data = {
        init: function() {
            return i = jQuery(document),
            s.Data.setEventListeners("on"),
            s.Data.render(null, s.cart)
        },
        destroy: function() {
            return s.Data.setEventListeners("off")
        },
        setEventListeners: function(t) {
            return i[t]("click", "[data-cart-add]", s.Data.add),
            i[t]("click", "[data-cart-remove]", s.Data.remove),
            i[t]("click", "[data-cart-remove-id]", s.Data.removeById),
            i[t]("click", "[data-cart-update]", s.Data.update),
            i[t]("click", "[data-cart-update-id]", s.Data.updateById),
            i[t]("click", "[data-cart-clear]", s.Data.clear),
            i[t]("change", "[data-cart-toggle]", s.Data.toggle),
            i[t]("change", "[data-cart-toggle-attribute]", s.Data.toggleAttribute),
            i[t]("submit", "[data-cart-submit]", s.Data.submit),
            i[t]("cart.requestComplete", s.Data.render)
        },
        add: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.addItem(e.attr("data-cart-add"), e.attr("data-cart-quantity"))
        },
        remove: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.removeItem(e.attr("data-cart-remove"))
        },
        removeById: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.removeItemById(e.attr("data-cart-remove-id"))
        },
        update: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.updateItem(e.attr("data-cart-update"), e.attr("data-cart-quantity"))
        },
        updateById: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.updateItemById(e.attr("data-cart-update-id"), e.attr("data-cart-quantity"))
        },
        clear: function(t) {
            return t.preventDefault(),
            s.Core.clear()
        },
        toggle: function(t) {
            var e, i;
            return i = (e = jQuery(this)).attr("data-cart-toggle"),
            e.is(":checked") ? s.Core.addItem(i) : s.Core.removeItemById(i)
        },
        toggleAttribute: function(t) {
            var e, i;
            return i = (e = jQuery(this)).attr("data-cart-toggle-attribute"),
            s.Core.setAttribute(i, e.is(":checked") ? "Yes" : "")
        },
        submit: function(t) {
            var e, i, n, o;
            return t.preventDefault(),
            e = jQuery(this).serializeArray(),
            o = i = void 0,
            n = {},
            jQuery.each(e, function(t, e) {
                return "id" === e.name ? i = e.value : "quantity" === e.name ? o = e.value : n[e.name] = e.value
            }),
            s.Core.addItem(i, o, s.Utils.unwrapKeys(n))
        },
        render: function(t, e) {
            var i;
            return i = {
                item_count: e.item_count,
                total_price: e.total_price,
                total_price_money: s.Utils.formatMoney(e.total_price, s.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: s.Utils.formatMoney(e.total_price, s.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            },
            jQuery("[data-cart-render]").each(function() {
                var t;
                return (t = jQuery(this)).html(i[t.attr("data-cart-render")])
            })
        }
    },
    "rivets"in window ? (s.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return s.Rivets.bindViews()
        },
        destroy: function() {
            return s.Rivets.unbindViews()
        },
        bindViews: function() {
            return s.Utils.log("Rivets.js is present, binding views."),
            s.Rivets.unbindViews(),
            s.Rivets.model = s.Utils.extend({
                cart: s.cart
            }, s.settings.rivetsModels),
            null != window.Currency && (s.Rivets.model.Currency = window.Currency),
            jQuery("[data-cart-view]").each(function() {
                var t;
                return t = rivets.bind(jQuery(this), s.Rivets.model),
                s.Rivets.boundViews.push(t)
            })
        },
        unbindViews: function() {
            var t, e, i;
            for (t = 0,
            e = (i = s.Rivets.boundViews).length; t < e; t++)
                i[t].unbind();
            return s.Rivets.boundViews = []
        }
    },
    rivets.formatters.eq = function(t, e) {
        return t === e
    }
    ,
    rivets.formatters.includes = function(t, e) {
        return 0 <= t.indexOf(e)
    }
    ,
    rivets.formatters.match = function(t, e, i) {
        return t.match(new RegExp(e,i))
    }
    ,
    rivets.formatters.lt = function(t, e) {
        return t < e
    }
    ,
    rivets.formatters.gt = function(t, e) {
        return e < t
    }
    ,
    rivets.formatters.not = function(t) {
        return !t
    }
    ,
    rivets.formatters.empty = function(t) {
        return !t.length
    }
    ,
    rivets.formatters.plus = function(t, e) {
        return parseInt(t) + parseInt(e)
    }
    ,
    rivets.formatters.minus = function(t, e) {
        return parseInt(t) - parseInt(e)
    }
    ,
    rivets.formatters.prepend = function(t, e) {
        return e + t
    }
    ,
    rivets.formatters.append = function(t, e) {
        return t + e
    }
    ,
    rivets.formatters.slice = function(t, e, i) {
        return t.slice(e, i)
    }
    ,
    rivets.formatters.pluralize = function(t, e, i) {
        return null == i && (i = e + "s"),
        s.Utils.isArray(t) && (t = t.length),
        1 === t ? e : i
    }
    ,
    rivets.formatters.array_element = function(t, e) {
        return t[e]
    }
    ,
    rivets.formatters.array_first = function(t) {
        return t[0]
    }
    ,
    rivets.formatters.array_last = function(t) {
        return t[t.length - 1]
    }
    ,
    rivets.formatters.money = function(t, e) {
        return s.Utils.formatMoney(t, s.settings.moneyFormat, "money_format", e)
    }
    ,
    rivets.formatters.money_with_currency = function(t, e) {
        return s.Utils.formatMoney(t, s.settings.moneyWithCurrencyFormat, "money_with_currency_format", e)
    }
    ,
    rivets.formatters.weight = function(t) {
        switch (s.settings.weightUnit) {
        case "kg":
            return (t / 1e3).toFixed(s.settings.weightPrecision);
        case "oz":
            return (.035274 * t).toFixed(s.settings.weightPrecision);
        case "lb":
            return (.00220462 * t).toFixed(s.settings.weightPrecision);
        default:
            return t.toFixed(s.settings.weightPrecision)
        }
    }
    ,
    rivets.formatters.weight_with_unit = function(t) {
        return rivets.formatters.weight(t) + s.settings.weightUnit
    }
    ,
    rivets.formatters.product_image_size = function(t, e) {
        return s.Utils.getSizedImageUrl(t, e)
    }
    ,
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency,
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit,
    rivets.formatters.productImageSize = rivets.formatters.product_image_size) : s.Rivets = {
        init: function() {},
        destroy: function() {}
    },
    s.factory = function(t) {
        return t.init = s.init,
        t.configure = s.configure,
        t.cart = s.cart,
        t.settings = s.settings,
        t.getCart = s.Core.getCart,
        t.addItem = s.Core.addItem,
        t.updateItem = s.Core.updateItem,
        t.updateItemById = s.Core.updateItemById,
        t.updateItemQuantitiesById = s.Core.updateItemQuantitiesById,
        t.removeItem = s.Core.removeItem,
        t.removeItemById = s.Core.removeItemById,
        t.clear = s.Core.clear,
        t.getAttribute = s.Core.getAttribute,
        t.setAttribute = s.Core.setAttribute,
        t.getAttributes = s.Core.getAttributes,
        t.setAttributes = s.Core.setAttributes,
        t.clearAttributes = s.Core.clearAttributes,
        t.getNote = s.Core.getNote,
        t.setNote = s.Core.setNote,
        t.render = s.Data.render
    }
    ,
    "object" == typeof exports ? s.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(t) {
        return s.factory(this.CartJS = t),
        t
    }) : s.factory(this.CartJS = {})
}
.call(this),
function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Cleave = e() : t.Cleave = e()
}(this, function() {
    return o = {},
    i.m = n = [function(e, t, i) {
        (function(t) {
            "use strict";
            var r = function(t, e) {
                var i = this
                  , n = !1;
                if ("string" == typeof t ? (i.element = document.querySelector(t),
                n = 1 < document.querySelectorAll(t).length) : void 0 !== t.length && 0 < t.length ? (i.element = t[0],
                n = 1 < t.length) : i.element = t,
                !i.element)
                    throw new Error("[cleave.js] Please check the element");
                if (n)
                    try {
                        console.warn("[cleave.js] Multiple input fields matched, cleave.js will only take the first one.")
                    } catch (t) {}
                e.initValue = i.element.value,
                i.properties = r.DefaultProperties.assign({}, e),
                i.init()
            };
            r.prototype = {
                init: function() {
                    var t = this
                      , e = t.properties;
                    return e.numeral || e.phone || e.creditCard || e.time || e.date || 0 !== e.blocksLength || e.prefix ? (e.maxLength = r.Util.getMaxLength(e.blocks),
                    t.isAndroid = r.Util.isAndroid(),
                    t.lastInputValue = "",
                    t.onChangeListener = t.onChange.bind(t),
                    t.onKeyDownListener = t.onKeyDown.bind(t),
                    t.onFocusListener = t.onFocus.bind(t),
                    t.onCutListener = t.onCut.bind(t),
                    t.onCopyListener = t.onCopy.bind(t),
                    t.element.addEventListener("input", t.onChangeListener),
                    t.element.addEventListener("keydown", t.onKeyDownListener),
                    t.element.addEventListener("focus", t.onFocusListener),
                    t.element.addEventListener("cut", t.onCutListener),
                    t.element.addEventListener("copy", t.onCopyListener),
                    t.initPhoneFormatter(),
                    t.initDateFormatter(),
                    t.initTimeFormatter(),
                    t.initNumeralFormatter(),
                    void ((e.initValue || e.prefix && !e.noImmediatePrefix) && t.onInput(e.initValue))) : void t.onInput(e.initValue)
                },
                initNumeralFormatter: function() {
                    var t = this.properties;
                    t.numeral && (t.numeralFormatter = new r.NumeralFormatter(t.numeralDecimalMark,t.numeralIntegerScale,t.numeralDecimalScale,t.numeralThousandsGroupStyle,t.numeralPositiveOnly,t.stripLeadingZeroes,t.prefix,t.signBeforePrefix,t.delimiter))
                },
                initTimeFormatter: function() {
                    var t = this.properties;
                    t.time && (t.timeFormatter = new r.TimeFormatter(t.timePattern,t.timeFormat),
                    t.blocks = t.timeFormatter.getBlocks(),
                    t.blocksLength = t.blocks.length,
                    t.maxLength = r.Util.getMaxLength(t.blocks))
                },
                initDateFormatter: function() {
                    var t = this.properties;
                    t.date && (t.dateFormatter = new r.DateFormatter(t.datePattern,t.dateMin,t.dateMax),
                    t.blocks = t.dateFormatter.getBlocks(),
                    t.blocksLength = t.blocks.length,
                    t.maxLength = r.Util.getMaxLength(t.blocks))
                },
                initPhoneFormatter: function() {
                    var t = this.properties;
                    if (t.phone)
                        try {
                            t.phoneFormatter = new r.PhoneFormatter(new t.root.Cleave.AsYouTypeFormatter(t.phoneRegionCode),t.delimiter)
                        } catch (t) {
                            throw new Error("[cleave.js] Please include phone-type-formatter.{country}.js lib")
                        }
                },
                onKeyDown: function(t) {
                    var e = this
                      , i = e.properties
                      , n = t.which || t.keyCode
                      , o = r.Util
                      , a = e.element.value;
                    e.hasBackspaceSupport = e.hasBackspaceSupport || 8 === n,
                    !e.hasBackspaceSupport && o.isAndroidBackspaceKeydown(e.lastInputValue, a) && (n = 8),
                    e.lastInputValue = a;
                    var s = o.getPostDelimiter(a, i.delimiter, i.delimiters);
                    i.postDelimiterBackspace = !(8 !== n || !s) && s
                },
                onChange: function() {
                    this.onInput(this.element.value)
                },
                onFocus: function() {
                    var t = this.properties;
                    r.Util.fixPrefixCursor(this.element, t.prefix, t.delimiter, t.delimiters)
                },
                onCut: function(t) {
                    r.Util.checkFullSelection(this.element.value) && (this.copyClipboardData(t),
                    this.onInput(""))
                },
                onCopy: function(t) {
                    r.Util.checkFullSelection(this.element.value) && this.copyClipboardData(t)
                },
                copyClipboardData: function(t) {
                    var e, i = this.properties, n = r.Util, o = this.element.value;
                    e = i.copyDelimiter ? o : n.stripDelimiters(o, i.delimiter, i.delimiters);
                    try {
                        t.clipboardData ? t.clipboardData.setData("Text", e) : window.clipboardData.setData("Text", e),
                        t.preventDefault()
                    } catch (t) {}
                },
                onInput: function(t) {
                    var e = this
                      , i = e.properties
                      , n = r.Util
                      , o = n.getPostDelimiter(t, i.delimiter, i.delimiters);
                    return i.numeral || !i.postDelimiterBackspace || o || (t = n.headStr(t, t.length - i.postDelimiterBackspace.length)),
                    i.phone ? !i.prefix || i.noImmediatePrefix && !t.length ? i.result = i.phoneFormatter.format(t) : i.result = i.prefix + i.phoneFormatter.format(t).slice(i.prefix.length) : i.numeral ? i.prefix && i.noImmediatePrefix && 0 === t.length ? i.result = "" : i.result = i.numeralFormatter.format(t) : (i.date && (t = i.dateFormatter.getValidatedDate(t)),
                    i.time && (t = i.timeFormatter.getValidatedTime(t)),
                    t = n.stripDelimiters(t, i.delimiter, i.delimiters),
                    t = n.getPrefixStrippedValue(t, i.prefix, i.prefixLength, i.result, i.delimiter, i.delimiters, i.noImmediatePrefix),
                    t = i.numericOnly ? n.strip(t, /[^\d]/g) : t,
                    t = i.uppercase ? t.toUpperCase() : t,
                    t = i.lowercase ? t.toLowerCase() : t,
                    !i.prefix || i.noImmediatePrefix && !t.length || (t = i.prefix + t,
                    0 !== i.blocksLength) ? (i.creditCard && e.updateCreditCardPropsByValue(t),
                    t = n.headStr(t, i.maxLength),
                    i.result = n.getFormattedValue(t, i.blocks, i.blocksLength, i.delimiter, i.delimiters, i.delimiterLazyShow)) : i.result = t),
                    void e.updateValueState()
                },
                updateCreditCardPropsByValue: function(t) {
                    var e, i = this.properties, n = r.Util;
                    n.headStr(i.result, 4) !== n.headStr(t, 4) && (e = r.CreditCardDetector.getInfo(t, i.creditCardStrictMode),
                    i.blocks = e.blocks,
                    i.blocksLength = i.blocks.length,
                    i.maxLength = n.getMaxLength(i.blocks),
                    i.creditCardType !== e.type && (i.creditCardType = e.type,
                    i.onCreditCardTypeChanged.call(this, i.creditCardType)))
                },
                updateValueState: function() {
                    var t = this
                      , e = r.Util
                      , i = t.properties;
                    if (t.element) {
                        var n = t.element.selectionEnd
                          , o = t.element.value
                          , a = i.result;
                        if (n = e.getNextCursorPosition(n, o, a, i.delimiter, i.delimiters),
                        t.isAndroid)
                            return void window.setTimeout(function() {
                                t.element.value = a,
                                e.setSelection(t.element, n, i.document, !1),
                                t.callOnValueChanged()
                            }, 1);
                        t.element.value = a,
                        e.setSelection(t.element, n, i.document, !1),
                        t.callOnValueChanged()
                    }
                },
                callOnValueChanged: function() {
                    var t = this.properties;
                    t.onValueChanged.call(this, {
                        target: {
                            value: t.result,
                            rawValue: this.getRawValue()
                        }
                    })
                },
                setPhoneRegionCode: function(t) {
                    this.properties.phoneRegionCode = t,
                    this.initPhoneFormatter(),
                    this.onChange()
                },
                setRawValue: function(t) {
                    var e = this.properties;
                    t = null != t ? t.toString() : "",
                    e.numeral && (t = t.replace(".", e.numeralDecimalMark)),
                    e.postDelimiterBackspace = !1,
                    this.element.value = t,
                    this.onInput(t)
                },
                getRawValue: function() {
                    var t = this.properties
                      , e = r.Util
                      , i = this.element.value;
                    return t.rawValueTrimPrefix && (i = e.getPrefixStrippedValue(i, t.prefix, t.prefixLength, t.result, t.delimiter, t.delimiters)),
                    t.numeral ? t.numeralFormatter.getRawValue(i) : e.stripDelimiters(i, t.delimiter, t.delimiters)
                },
                getISOFormatDate: function() {
                    var t = this.properties;
                    return t.date ? t.dateFormatter.getISOFormatDate() : ""
                },
                getISOFormatTime: function() {
                    var t = this.properties;
                    return t.time ? t.timeFormatter.getISOFormatTime() : ""
                },
                getFormattedValue: function() {
                    return this.element.value
                },
                destroy: function() {
                    var t = this;
                    t.element.removeEventListener("input", t.onChangeListener),
                    t.element.removeEventListener("keydown", t.onKeyDownListener),
                    t.element.removeEventListener("focus", t.onFocusListener),
                    t.element.removeEventListener("cut", t.onCutListener),
                    t.element.removeEventListener("copy", t.onCopyListener)
                },
                toString: function() {
                    return "[Cleave Object]"
                }
            },
            r.NumeralFormatter = i(1),
            r.DateFormatter = i(2),
            r.TimeFormatter = i(3),
            r.PhoneFormatter = i(4),
            r.CreditCardDetector = i(5),
            r.Util = i(6),
            r.DefaultProperties = i(7),
            ("object" == typeof t && t ? t : window).Cleave = r,
            e.exports = r
        }
        ).call(t, function() {
            return this
        }())
    }
    , function(t, e) {
        "use strict";
        var u = function(t, e, i, n, o, a, s, r, l) {
            var c = this;
            c.numeralDecimalMark = t || ".",
            c.numeralIntegerScale = 0 < e ? e : 0,
            c.numeralDecimalScale = 0 <= i ? i : 2,
            c.numeralThousandsGroupStyle = n || u.groupStyle.thousand,
            c.numeralPositiveOnly = !!o,
            c.stripLeadingZeroes = !1 !== a,
            c.prefix = s || "" === s ? s : "",
            c.signBeforePrefix = !!r,
            c.delimiter = l || "" === l ? l : ",",
            c.delimiterRE = l ? new RegExp("\\" + l,"g") : ""
        };
        u.groupStyle = {
            thousand: "thousand",
            lakh: "lakh",
            wan: "wan",
            none: "none"
        },
        u.prototype = {
            getRawValue: function(t) {
                return t.replace(this.delimiterRE, "").replace(this.numeralDecimalMark, ".")
            },
            format: function(t) {
                var e, i, n, o, a = this, s = "";
                switch (t = t.replace(/[A-Za-z]/g, "").replace(a.numeralDecimalMark, "M").replace(/[^\dM-]/g, "").replace(/^\-/, "N").replace(/\-/g, "").replace("N", a.numeralPositiveOnly ? "" : "-").replace("M", a.numeralDecimalMark),
                a.stripLeadingZeroes && (t = t.replace(/^(-)?0+(?=\d)/, "$1")),
                i = "-" === t.slice(0, 1) ? "-" : "",
                n = void 0 !== a.prefix ? a.signBeforePrefix ? i + a.prefix : a.prefix + i : i,
                0 <= (o = t).indexOf(a.numeralDecimalMark) && (o = (e = t.split(a.numeralDecimalMark))[0],
                s = a.numeralDecimalMark + e[1].slice(0, a.numeralDecimalScale)),
                "-" == i && (o = o.slice(1)),
                0 < a.numeralIntegerScale && (o = o.slice(0, a.numeralIntegerScale)),
                a.numeralThousandsGroupStyle) {
                case u.groupStyle.lakh:
                    o = o.replace(/(\d)(?=(\d\d)+\d$)/g, "$1" + a.delimiter);
                    break;
                case u.groupStyle.wan:
                    o = o.replace(/(\d)(?=(\d{4})+$)/g, "$1" + a.delimiter);
                    break;
                case u.groupStyle.thousand:
                    o = o.replace(/(\d)(?=(\d{3})+$)/g, "$1" + a.delimiter)
                }
                return n + o.toString() + (0 < a.numeralDecimalScale ? s.toString() : "")
            }
        },
        t.exports = u
    }
    , function(t, e) {
        "use strict";
        function i(t, e, i) {
            var n = this;
            n.date = [],
            n.blocks = [],
            n.datePattern = t,
            n.dateMin = e.split("-").reverse().map(function(t) {
                return parseInt(t, 10)
            }),
            2 === n.dateMin.length && n.dateMin.unshift(0),
            n.dateMax = i.split("-").reverse().map(function(t) {
                return parseInt(t, 10)
            }),
            2 === n.dateMax.length && n.dateMax.unshift(0),
            n.initBlocks()
        }
        i.prototype = {
            initBlocks: function() {
                var e = this;
                e.datePattern.forEach(function(t) {
                    "Y" === t ? e.blocks.push(4) : e.blocks.push(2)
                })
            },
            getISOFormatDate: function() {
                var t = this.date;
                return t[2] ? t[2] + "-" + this.addLeadingZero(t[1]) + "-" + this.addLeadingZero(t[0]) : ""
            },
            getBlocks: function() {
                return this.blocks
            },
            getValidatedDate: function(a) {
                var s = this
                  , r = "";
                return a = a.replace(/[^\d]/g, ""),
                s.blocks.forEach(function(t, e) {
                    if (0 < a.length) {
                        var i = a.slice(0, t)
                          , n = i.slice(0, 1)
                          , o = a.slice(t);
                        switch (s.datePattern[e]) {
                        case "d":
                            "00" === i ? i = "01" : 3 < parseInt(n, 10) ? i = "0" + n : 31 < parseInt(i, 10) && (i = "31");
                            break;
                        case "m":
                            "00" === i ? i = "01" : 1 < parseInt(n, 10) ? i = "0" + n : 12 < parseInt(i, 10) && (i = "12")
                        }
                        r += i,
                        a = o
                    }
                }),
                this.getFixedDateString(r)
            },
            getFixedDateString: function(t) {
                var e, i, n, o = this, a = o.datePattern, s = [], r = 0, l = 0, c = 0, u = 0, d = 0, p = 0, f = !1;
                return 4 === t.length && "y" !== a[0].toLowerCase() && "y" !== a[1].toLowerCase() && (d = 2 - (u = "d" === a[0] ? 0 : 2),
                e = parseInt(t.slice(u, u + 2), 10),
                i = parseInt(t.slice(d, d + 2), 10),
                s = this.getFixedDate(e, i, 0)),
                8 === t.length && (a.forEach(function(t, e) {
                    switch (t) {
                    case "d":
                        r = e;
                        break;
                    case "m":
                        l = e;
                        break;
                    default:
                        c = e
                    }
                }),
                p = 2 * c,
                u = r <= c ? 2 * r : 2 * r + 2,
                d = l <= c ? 2 * l : 2 * l + 2,
                e = parseInt(t.slice(u, u + 2), 10),
                i = parseInt(t.slice(d, d + 2), 10),
                n = parseInt(t.slice(p, p + 4), 10),
                f = 4 === t.slice(p, p + 4).length,
                s = this.getFixedDate(e, i, n)),
                4 !== t.length || "y" !== a[0] && "y" !== a[1] || (p = 2 - (d = "m" === a[0] ? 0 : 2),
                i = parseInt(t.slice(d, d + 2), 10),
                n = parseInt(t.slice(p, p + 2), 10),
                f = 2 === t.slice(p, p + 2).length,
                s = [0, i, n]),
                6 !== t.length || "Y" !== a[0] && "Y" !== a[1] || (p = 2 - .5 * (d = "m" === a[0] ? 0 : 4),
                i = parseInt(t.slice(d, d + 2), 10),
                n = parseInt(t.slice(p, p + 4), 10),
                f = 4 === t.slice(p, p + 4).length,
                s = [0, i, n]),
                s = o.getRangeFixedDate(s),
                0 === (o.date = s).length ? t : a.reduce(function(t, e) {
                    switch (e) {
                    case "d":
                        return t + (0 === s[0] ? "" : o.addLeadingZero(s[0]));
                    case "m":
                        return t + (0 === s[1] ? "" : o.addLeadingZero(s[1]));
                    case "y":
                        return t + (f ? o.addLeadingZeroForYear(s[2], !1) : "");
                    case "Y":
                        return t + (f ? o.addLeadingZeroForYear(s[2], !0) : "")
                    }
                }, "")
            },
            getRangeFixedDate: function(t) {
                var e = this.datePattern
                  , i = this.dateMin || []
                  , n = this.dateMax || [];
                return !t.length || i.length < 3 && n.length < 3 ? t : e.find(function(t) {
                    return "y" === t.toLowerCase()
                }) && 0 === t[2] ? t : n.length && (n[2] < t[2] || n[2] === t[2] && (n[1] < t[1] || n[1] === t[1] && n[0] < t[0])) ? n : i.length && (i[2] > t[2] || i[2] === t[2] && (i[1] > t[1] || i[1] === t[1] && i[0] > t[0])) ? i : t
            },
            getFixedDate: function(t, e, i) {
                return t = Math.min(t, 31),
                e = Math.min(e, 12),
                i = parseInt(i || 0, 10),
                (e < 7 && e % 2 == 0 || 8 < e && e % 2 == 1) && (t = Math.min(t, 2 === e ? this.isLeapYear(i) ? 29 : 28 : 30)),
                [t, e, i]
            },
            isLeapYear: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
            },
            addLeadingZero: function(t) {
                return (t < 10 ? "0" : "") + t
            },
            addLeadingZeroForYear: function(t, e) {
                return e ? (t < 10 ? "000" : t < 100 ? "00" : t < 1e3 ? "0" : "") + t : (t < 10 ? "0" : "") + t
            }
        },
        t.exports = i
    }
    , function(t, e) {
        "use strict";
        function i(t, e) {
            var i = this;
            i.time = [],
            i.blocks = [],
            i.timePattern = t,
            i.timeFormat = e,
            i.initBlocks()
        }
        i.prototype = {
            initBlocks: function() {
                var t = this;
                t.timePattern.forEach(function() {
                    t.blocks.push(2)
                })
            },
            getISOFormatTime: function() {
                var t = this.time;
                return t[2] ? this.addLeadingZero(t[0]) + ":" + this.addLeadingZero(t[1]) + ":" + this.addLeadingZero(t[2]) : ""
            },
            getBlocks: function() {
                return this.blocks
            },
            getTimeFormatOptions: function() {
                return "12" === String(this.timeFormat) ? {
                    maxHourFirstDigit: 1,
                    maxHours: 12,
                    maxMinutesFirstDigit: 5,
                    maxMinutes: 60
                } : {
                    maxHourFirstDigit: 2,
                    maxHours: 23,
                    maxMinutesFirstDigit: 5,
                    maxMinutes: 60
                }
            },
            getValidatedTime: function(a) {
                var s = this
                  , r = "";
                a = a.replace(/[^\d]/g, "");
                var l = s.getTimeFormatOptions();
                return s.blocks.forEach(function(t, e) {
                    if (0 < a.length) {
                        var i = a.slice(0, t)
                          , n = i.slice(0, 1)
                          , o = a.slice(t);
                        switch (s.timePattern[e]) {
                        case "h":
                            parseInt(n, 10) > l.maxHourFirstDigit ? i = "0" + n : parseInt(i, 10) > l.maxHours && (i = l.maxHours + "");
                            break;
                        case "m":
                        case "s":
                            parseInt(n, 10) > l.maxMinutesFirstDigit ? i = "0" + n : parseInt(i, 10) > l.maxMinutes && (i = l.maxMinutes + "")
                        }
                        r += i,
                        a = o
                    }
                }),
                this.getFixedTimeString(r)
            },
            getFixedTimeString: function(t) {
                var e, i, n, o = this, a = o.timePattern, s = [], r = 0, l = 0, c = 0, u = 0, d = 0, p = 0;
                return 6 === t.length && (a.forEach(function(t, e) {
                    switch (t) {
                    case "s":
                        r = 2 * e;
                        break;
                    case "m":
                        l = 2 * e;
                        break;
                    case "h":
                        c = 2 * e
                    }
                }),
                p = c,
                d = l,
                u = r,
                e = parseInt(t.slice(u, u + 2), 10),
                i = parseInt(t.slice(d, d + 2), 10),
                n = parseInt(t.slice(p, p + 2), 10),
                s = this.getFixedTime(n, i, e)),
                4 === t.length && o.timePattern.indexOf("s") < 0 && (a.forEach(function(t, e) {
                    switch (t) {
                    case "m":
                        l = 2 * e;
                        break;
                    case "h":
                        c = 2 * e
                    }
                }),
                p = c,
                d = l,
                e = 0,
                i = parseInt(t.slice(d, d + 2), 10),
                n = parseInt(t.slice(p, p + 2), 10),
                s = this.getFixedTime(n, i, e)),
                0 === (o.time = s).length ? t : a.reduce(function(t, e) {
                    switch (e) {
                    case "s":
                        return t + o.addLeadingZero(s[2]);
                    case "m":
                        return t + o.addLeadingZero(s[1]);
                    case "h":
                        return t + o.addLeadingZero(s[0])
                    }
                }, "")
            },
            getFixedTime: function(t, e, i) {
                return i = Math.min(parseInt(i || 0, 10), 60),
                e = Math.min(e, 60),
                [t = Math.min(t, 60), e, i]
            },
            addLeadingZero: function(t) {
                return (t < 10 ? "0" : "") + t
            }
        },
        t.exports = i
    }
    , function(t, e) {
        "use strict";
        function i(t, e) {
            this.delimiter = e || "" === e ? e : " ",
            this.delimiterRE = e ? new RegExp("\\" + e,"g") : "",
            this.formatter = t
        }
        i.prototype = {
            setFormatter: function(t) {
                this.formatter = t
            },
            format: function(t) {
                this.formatter.clear();
                for (var e, i = "", n = !1, o = 0, a = (t = (t = (t = t.replace(/[^\d+]/g, "")).replace(/^\+/, "B").replace(/\+/g, "").replace("B", "+")).replace(this.delimiterRE, "")).length; o < a; o++)
                    e = this.formatter.inputDigit(t.charAt(o)),
                    /[\s()-]/g.test(e) ? (i = e,
                    n = !0) : n || (i = e);
                return (i = i.replace(/[()]/g, "")).replace(/[\s-]/g, this.delimiter)
            }
        },
        t.exports = i
    }
    , function(t, e) {
        "use strict";
        var s = {
            blocks: {
                uatp: [4, 5, 6],
                amex: [4, 6, 5],
                diners: [4, 6, 4],
                discover: [4, 4, 4, 4],
                mastercard: [4, 4, 4, 4],
                dankort: [4, 4, 4, 4],
                instapayment: [4, 4, 4, 4],
                jcb15: [4, 6, 5],
                jcb: [4, 4, 4, 4],
                maestro: [4, 4, 4, 4],
                visa: [4, 4, 4, 4],
                mir: [4, 4, 4, 4],
                unionPay: [4, 4, 4, 4],
                general: [4, 4, 4, 4]
            },
            re: {
                uatp: /^(?!1800)1\d{0,14}/,
                amex: /^3[47]\d{0,13}/,
                discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
                diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
                mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
                dankort: /^(5019|4175|4571)\d{0,12}/,
                instapayment: /^63[7-9]\d{0,13}/,
                jcb15: /^(?:2131|1800)\d{0,11}/,
                jcb: /^(?:35\d{0,2})\d{0,12}/,
                maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
                mir: /^220[0-4]\d{0,12}/,
                visa: /^4\d{0,15}/,
                unionPay: /^62\d{0,14}/
            },
            getStrictBlocks: function(t) {
                var e = t.reduce(function(t, e) {
                    return t + e
                }, 0);
                return t.concat(19 - e)
            },
            getInfo: function(t, e) {
                var i = s.blocks
                  , n = s.re;
                for (var o in e = !!e,
                n)
                    if (n[o].test(t)) {
                        var a = i[o];
                        return {
                            type: o,
                            blocks: e ? this.getStrictBlocks(a) : a
                        }
                    }
                return {
                    type: "unknown",
                    blocks: e ? this.getStrictBlocks(i.general) : i.general
                }
            }
        };
        t.exports = s
    }
    , function(t, e) {
        "use strict";
        var i = {
            noop: function() {},
            strip: function(t, e) {
                return t.replace(e, "")
            },
            getPostDelimiter: function(e, t, i) {
                if (0 === i.length)
                    return e.slice(-t.length) === t ? t : "";
                var n = "";
                return i.forEach(function(t) {
                    e.slice(-t.length) === t && (n = t)
                }),
                n
            },
            getDelimiterREByDelimiter: function(t) {
                return new RegExp(t.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"),"g")
            },
            getNextCursorPosition: function(t, e, i, n, o) {
                return e.length === t ? i.length : t + this.getPositionOffset(t, e, i, n, o)
            },
            getPositionOffset: function(t, e, i, n, o) {
                var a, s, r;
                return a = this.stripDelimiters(e.slice(0, t), n, o),
                s = this.stripDelimiters(i.slice(0, t), n, o),
                0 != (r = a.length - s.length) ? r / Math.abs(r) : 0
            },
            stripDelimiters: function(e, t, i) {
                var n = this;
                if (0 !== i.length)
                    return i.forEach(function(t) {
                        t.split("").forEach(function(t) {
                            e = e.replace(n.getDelimiterREByDelimiter(t), "")
                        })
                    }),
                    e;
                var o = t ? n.getDelimiterREByDelimiter(t) : "";
                return e.replace(o, "")
            },
            headStr: function(t, e) {
                return t.slice(0, e)
            },
            getMaxLength: function(t) {
                return t.reduce(function(t, e) {
                    return t + e
                }, 0)
            },
            getPrefixStrippedValue: function(t, e, i, n, o, a, s) {
                if (0 === i)
                    return t;
                if (n.slice(0, i) !== e)
                    return s && !n && t ? t : "";
                var r = this.stripDelimiters(n, o, a);
                return t.slice(0, i) !== e ? r.slice(i) : t.slice(i)
            },
            getFirstDiffIndex: function(t, e) {
                for (var i = 0; t.charAt(i) === e.charAt(i); )
                    if ("" === t.charAt(i++))
                        return -1;
                return i
            },
            getFormattedValue: function(o, t, a, s, r, l) {
                var c, u = "", d = 0 < r.length;
                return 0 === a ? o : (t.forEach(function(t, e) {
                    if (0 < o.length) {
                        var i = o.slice(0, t)
                          , n = o.slice(t);
                        c = d ? r[l ? e - 1 : e] || c : s,
                        l ? (0 < e && (u += c),
                        u += i) : (u += i,
                        i.length === t && e < a - 1 && (u += c)),
                        o = n
                    }
                }),
                u)
            },
            fixPrefixCursor: function(t, e, i, n) {
                if (t) {
                    var o = t.value
                      , a = i || n[0] || " ";
                    if (t.setSelectionRange && e && !(e.length + a.length < o.length)) {
                        var s = 2 * o.length;
                        setTimeout(function() {
                            t.setSelectionRange(s, s)
                        }, 1)
                    }
                }
            },
            checkFullSelection: function(t) {
                try {
                    return (window.getSelection() || document.getSelection() || {}).toString().length === t.length
                } catch (t) {}
                return !1
            },
            setSelection: function(t, e, i) {
                if (t === this.getActiveElement(i) && !(t && t.value.length <= e))
                    if (t.createTextRange) {
                        var n = t.createTextRange();
                        n.move("character", e),
                        n.select()
                    } else
                        try {
                            t.setSelectionRange(e, e)
                        } catch (t) {
                            console.warn("The input element type does not support selection")
                        }
            },
            getActiveElement: function(t) {
                var e = t.activeElement;
                return e && e.shadowRoot ? this.getActiveElement(e.shadowRoot) : e
            },
            isAndroid: function() {
                return navigator && /android/i.test(navigator.userAgent)
            },
            isAndroidBackspaceKeydown: function(t, e) {
                return !!(this.isAndroid() && t && e) && e === t.slice(0, -1)
            }
        };
        t.exports = i
    }
    , function(e, t) {
        (function(i) {
            "use strict";
            var t = {
                assign: function(t, e) {
                    return (t = t || {}).creditCard = !!(e = e || {}).creditCard,
                    t.creditCardStrictMode = !!e.creditCardStrictMode,
                    t.creditCardType = "",
                    t.onCreditCardTypeChanged = e.onCreditCardTypeChanged || function() {}
                    ,
                    t.phone = !!e.phone,
                    t.phoneRegionCode = e.phoneRegionCode || "AU",
                    t.phoneFormatter = {},
                    t.time = !!e.time,
                    t.timePattern = e.timePattern || ["h", "m", "s"],
                    t.timeFormat = e.timeFormat || "24",
                    t.timeFormatter = {},
                    t.date = !!e.date,
                    t.datePattern = e.datePattern || ["d", "m", "Y"],
                    t.dateMin = e.dateMin || "",
                    t.dateMax = e.dateMax || "",
                    t.dateFormatter = {},
                    t.numeral = !!e.numeral,
                    t.numeralIntegerScale = 0 < e.numeralIntegerScale ? e.numeralIntegerScale : 0,
                    t.numeralDecimalScale = 0 <= e.numeralDecimalScale ? e.numeralDecimalScale : 2,
                    t.numeralDecimalMark = e.numeralDecimalMark || ".",
                    t.numeralThousandsGroupStyle = e.numeralThousandsGroupStyle || "thousand",
                    t.numeralPositiveOnly = !!e.numeralPositiveOnly,
                    t.stripLeadingZeroes = !1 !== e.stripLeadingZeroes,
                    t.signBeforePrefix = !!e.signBeforePrefix,
                    t.numericOnly = t.creditCard || t.date || !!e.numericOnly,
                    t.uppercase = !!e.uppercase,
                    t.lowercase = !!e.lowercase,
                    t.prefix = t.creditCard || t.date ? "" : e.prefix || "",
                    t.noImmediatePrefix = !!e.noImmediatePrefix,
                    t.prefixLength = t.prefix.length,
                    t.rawValueTrimPrefix = !!e.rawValueTrimPrefix,
                    t.copyDelimiter = !!e.copyDelimiter,
                    t.initValue = void 0 !== e.initValue && null !== e.initValue ? e.initValue.toString() : "",
                    t.delimiter = e.delimiter || "" === e.delimiter ? e.delimiter : e.date ? "/" : e.time ? ":" : e.numeral ? "," : (e.phone,
                    " "),
                    t.delimiterLength = t.delimiter.length,
                    t.delimiterLazyShow = !!e.delimiterLazyShow,
                    t.delimiters = e.delimiters || [],
                    t.blocks = e.blocks || [],
                    t.blocksLength = t.blocks.length,
                    t.root = "object" == typeof i && i ? i : window,
                    t.document = e.document || t.root.document,
                    t.maxLength = 0,
                    t.backspace = !1,
                    t.result = "",
                    t.onValueChanged = e.onValueChanged || function() {}
                    ,
                    t
                }
            };
            e.exports = t
        }
        ).call(t, function() {
            return this
        }())
    }
    ],
    i.c = o,
    i.p = "",
    i(0);
    function i(t) {
        if (o[t])
            return o[t].exports;
        var e = o[t] = {
            exports: {},
            id: t,
            loaded: !1
        };
        return n[t].call(e.exports, e, e.exports, i),
        e.loaded = !0,
        e.exports
    }
    var n, o
}),
$.scrollLock = function() {
    "use strict";
    var n = $("html")
      , e = !1
      , i = {
        scrollLeft: $(window).scrollLeft(),
        scrollTop: $(window).scrollTop()
    }
      , o = {}
      , a = {
        "overflow-y": "scroll",
        position: "fixed",
        width: "100%"
    };
    function s() {
        var t, e = n.attr("style"), i = {};
        e && (t = e.split(/;\s/),
        $.each(t, function(t) {
            if (t) {
                var e = t.split(/\s:\s/);
                e.length < 2 || (i[e[0]] = e[1])
            }
        }),
        $.extend(o, i))
    }
    function r() {
        var t = {};
        e || (i = {
            scrollLeft: $(window).scrollLeft(),
            scrollTop: $(window).scrollTop()
        },
        s(),
        $.extend(t, a, {
            left: -i.scrollLeft + "px",
            top: -i.scrollTop + "px"
        }),
        n.css(t),
        $(window).scrollLeft(0).scrollTop(0),
        e = !0)
    }
    function l() {
        e && (n.attr("style", $("<x>").css(o).attr("style") || ""),
        $(window).scrollLeft(i.scrollLeft).scrollTop(i.scrollTop),
        e = !1)
    }
    return s(),
    function(t) {
        arguments.length ? t ? r() : l() : e ? l() : r()
    }
}(),
function(t) {
    var e = !1;
    if ("function" == typeof define && define.amd && (define(t),
    e = !0),
    "object" == typeof exports && (module.exports = t(),
    e = !0),
    !e) {
        var i = window.Cookies
          , n = window.Cookies = t();
        n.noConflict = function() {
            return window.Cookies = i,
            n
        }
    }
}(function() {
    function g() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i)
                e[n] = i[n]
        }
        return e
    }
    return function t(f) {
        function h(t, e, i) {
            var n;
            if ("undefined" != typeof document) {
                if (1 < arguments.length) {
                    if ("number" == typeof (i = g({
                        path: "/"
                    }, h.defaults, i)).expires) {
                        var o = new Date;
                        o.setMilliseconds(o.getMilliseconds() + 864e5 * i.expires),
                        i.expires = o
                    }
                    i.expires = i.expires ? i.expires.toUTCString() : "";
                    try {
                        n = JSON.stringify(e),
                        /^[\{\[]/.test(n) && (e = n)
                    } catch (t) {}
                    e = f.write ? f.write(e, t) : encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent),
                    t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                    var a = "";
                    for (var s in i)
                        i[s] && (a += "; " + s,
                        !0 !== i[s] && (a += "=" + i[s]));
                    return document.cookie = t + "=" + e + a
                }
                t || (n = {});
                for (var r = document.cookie ? document.cookie.split("; ") : [], l = /(%[0-9A-Z]{2})+/g, c = 0; c < r.length; c++) {
                    var u = r[c].split("=")
                      , d = u.slice(1).join("=");
                    '"' === d.charAt(0) && (d = d.slice(1, -1));
                    try {
                        var p = u[0].replace(l, decodeURIComponent);
                        if (d = f.read ? f.read(d, p) : f(d, p) || d.replace(l, decodeURIComponent),
                        this.json)
                            try {
                                d = JSON.parse(d)
                            } catch (t) {}
                        if (t === p) {
                            n = d;
                            break
                        }
                        t || (n[p] = d)
                    } catch (t) {}
                }
                return n
            }
        }
        return (h.set = h).get = function(t) {
            return h.call(h, t)
        }
        ,
        h.getJSON = function() {
            return h.apply({
                json: !0
            }, [].slice.call(arguments))
        }
        ,
        h.defaults = {},
        h.remove = function(t, e) {
            h(t, "", g(e, {
                expires: -1
            }))
        }
        ,
        h.withConverter = t,
        h
    }(function() {})
});
var _extends = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];
        for (var n in i)
            Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
    }
    return t
}
  , _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
    return typeof t
}
: function(t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
}
;
!function(t, e) {
    "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.LazyLoad = e()
}(this, function() {
    "use strict";
    function r(t, e) {
        return t.getAttribute("data-" + e)
    }
    function o(t) {
        return t.filter(function(t) {
            return !r(t, "was-processed")
        })
    }
    function a(t, e) {
        var i = new t(e)
          , n = new CustomEvent("LazyLoad::Initialized",{
            detail: {
                instance: i
            }
        });
        window.dispatchEvent(n)
    }
    function i(t, e) {
        var i = e.data_src
          , n = e.data_srcset
          , o = t.tagName
          , a = r(t, i);
        if ("IMG" === o) {
            !function(t, e) {
                var i = e.data_srcset
                  , n = t.parentElement;
                if ("PICTURE" === n.tagName)
                    for (var o, a = 0; o = n.children[a]; a += 1)
                        if ("SOURCE" === o.tagName) {
                            var s = r(o, i);
                            s && o.setAttribute("srcset", s)
                        }
            }(t, e);
            var s = r(t, n);
            return s && t.setAttribute("srcset", s),
            void (a && t.setAttribute("src", a))
        }
        "IFRAME" !== o ? a && (t.style.backgroundImage = 'url("' + a + '")') : a && t.setAttribute("src", a)
    }
    function s(t, e) {
        d ? t.classList.add(e) : t.className += (t.className ? " " : "") + e
    }
    function l(t, e) {
        t && t(e)
    }
    function c(t, e, i) {
        t.removeEventListener("load", e),
        t.removeEventListener("error", i)
    }
    function u(t, e) {
        -1 < ["IMG", "IFRAME"].indexOf(t.tagName) && (function(i, n) {
            function o(t) {
                p(t, !0, n),
                c(i, o, e)
            }
            var e = function t(e) {
                p(e, !1, n),
                c(i, o, t)
            };
            i.addEventListener("load", o),
            i.addEventListener("error", e)
        }(t, e),
        s(t, e.class_loading)),
        i(t, e),
        function(t, e, i) {
            t.setAttribute("data-" + e, i)
        }(t, "was-processed", !0),
        l(e.callback_set, t)
    }
    function t(t, e) {
        this._settings = _extends({}, n, t),
        this._setObserver(),
        this.update(e)
    }
    var n = {
        elements_selector: "img",
        container: document,
        threshold: 300,
        data_src: "src",
        data_srcset: "srcset",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        callback_load: null,
        callback_error: null,
        callback_set: null
    }
      , d = "classList"in document.createElement("p")
      , p = function(t, e, i) {
        var n = t.target;
        !function(t, e) {
            d ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\s+)" + e + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "")
        }(n, i.class_loading),
        s(n, e ? i.class_loaded : i.class_error),
        l(e ? i.callback_load : i.callback_error, n)
    };
    t.prototype = {
        _setObserver: function() {
            var i = this;
            if ("IntersectionObserver"in window) {
                var n = this._settings;
                this._observer = new IntersectionObserver(function(t) {
                    t.forEach(function(t) {
                        if (0 < t.intersectionRatio) {
                            var e = t.target;
                            u(e, n),
                            i._observer.unobserve(e)
                        }
                    }),
                    i._elements = o(i._elements)
                }
                ,{
                    root: n.container === document ? null : n.container,
                    rootMargin: n.threshold + "px"
                })
            }
        },
        update: function(t) {
            var e = this
              , i = this._settings
              , n = t || i.container.querySelectorAll(i.elements_selector);
            this._elements = o(Array.prototype.slice.call(n)),
            this._observer ? this._elements.forEach(function(t) {
                e._observer.observe(t)
            }) : (this._elements.forEach(function(t) {
                u(t, i)
            }),
            this._elements = o(this._elements))
        },
        destroy: function() {
            var e = this;
            this._observer && (o(this._elements).forEach(function(t) {
                e._observer.unobserve(t)
            }),
            this._observer = null),
            this._elements = null,
            this._settings = null
        }
    };
    var e = window.lazyLoadOptions;
    return e && function(t, e) {
        if (e.length)
            for (var i, n = 0; i = e[n]; n += 1)
                a(t, i);
        else
            a(t, e)
    }(t, e),
    t
}),
function(t) {
    "use strict";
    var e = function(a) {
        var r, l = a.h;
        if (r = [["A", /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g], ["AA", /[\uA732]/g], ["AE", /[\u00C6\u01FC\u01E2]/g], ["AO", /[\uA734]/g], ["AU", /[\uA736]/g], ["AV", /[\uA738\uA73A]/g], ["AY", /[\uA73C]/g], ["B", /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g], ["C", /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g], ["D", /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g], ["DZ", /[\u01F1\u01C4]/g], ["Dz", /[\u01F2\u01C5]/g], ["E", /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g], ["F", /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g], ["G", /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g], ["H", /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g], ["I", /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g], ["J", /[\u004A\u24BF\uFF2A\u0134\u0248]/g], ["K", /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g], ["L", /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g], ["LJ", /[\u01C7]/g], ["Lj", /[\u01C8]/g], ["M", /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g], ["N", /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g], ["NJ", /[\u01CA]/g], ["Nj", /[\u01CB]/g], ["O", /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g], ["OI", /[\u01A2]/g], ["OO", /[\uA74E]/g], ["OU", /[\u0222]/g], ["P", /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g], ["Q", /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g], ["R", /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g], ["S", /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g], ["T", /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g], ["TZ", /[\uA728]/g], ["U", /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g], ["V", /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g], ["VY", /[\uA760]/g], ["W", /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g], ["X", /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g], ["Y", /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g], ["Z", /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g], ["a", /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g], ["aa", /[\uA733]/g], ["ae", /[\u00E6\u01FD\u01E3]/g], ["ao", /[\uA735]/g], ["au", /[\uA737]/g], ["av", /[\uA739\uA73B]/g], ["ay", /[\uA73D]/g], ["b", /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g], ["c", /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g], ["d", /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g], ["dz", /[\u01F3\u01C6]/g], ["e", /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g], ["f", /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g], ["g", /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g], ["h", /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g], ["hv", /[\u0195]/g], ["i", /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g], ["j", /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g], ["k", /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g], ["l", /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g], ["lj", /[\u01C9]/g], ["m", /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g], ["n", /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g], ["nj", /[\u01CC]/g], ["o", /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g], ["oi", /[\u01A3]/g], ["ou", /[\u0223]/g], ["oo", /[\uA74F]/g], ["p", /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g], ["q", /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g], ["r", /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g], ["s", /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g], ["t", /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g], ["tz", /[\uA729]/g], ["u", /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g], ["v", /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g], ["vy", /[\uA761]/g], ["w", /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g], ["x", /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g], ["y", /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g], ["z", /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g]],
        !a.CORE_VERSION || !l.compareVersions(e.REQUIRE_CORE_VERSION, a.CORE_VERSION))
            throw new Error("[MixItUp Multifilter] MixItUp Multifilter v" + e.EXTENSION_VERSION + " requires at least MixItUp v" + e.REQUIRE_CORE_VERSION);
        a.ConfigCallbacks.registerAction("afterConstruct", "multifilter", function() {
            this.onParseFilterGroups = null
        }),
        a.ConfigMultifilter = function() {
            this.enable = !1,
            this.logicWithinGroup = "or",
            this.logicBetweenGroups = "and",
            this.minSearchLength = 3,
            this.parseOn = "change",
            this.keyupThrottleDuration = 350,
            l.seal(this)
        }
        ,
        a.Config.registerAction("beforeConstruct", "multifilter", function() {
            this.multifilter = new a.ConfigMultifilter
        }),
        a.MultifilterFormEventTracker = function() {
            this.form = null,
            this.totalBound = 0,
            this.totalHandled = 0,
            l.seal(this)
        }
        ,
        a.FilterGroupDom = function() {
            this.el = null,
            this.form = null,
            l.seal(this)
        }
        ,
        a.FilterGroup = function() {
            this.name = "",
            this.dom = new a.FilterGroupDom,
            this.activeSelectors = [],
            this.activeFilters = [],
            this.activeToggles = [],
            this.handler = null,
            this.mixer = null,
            this.logic = "or",
            this.parseOn = "change",
            this.keyupTimeout = -1,
            l.seal(this)
        }
        ,
        l.extend(a.FilterGroup.prototype, {
            init: function(t, e) {
                var i = this
                  , n = t.getAttribute("data-logic");
                i.dom.el = t,
                this.name = i.dom.el.getAttribute("data-filter-group") || "",
                i.cacheDom(),
                i.dom.form && i.enableButtons(),
                i.mixer = e,
                (n && "and" === n.toLowerCase() || "and" === e.config.multifilter.logicWithinGroup) && (i.logic = "and"),
                i.bindEvents()
            },
            cacheDom: function() {
                this.dom.form = l.closestParent(this.dom.el, "form", !0)
            },
            enableButtons: function() {
                var t = this.dom.form.querySelectorAll('button[type="submit"]:disabled')
                  , e = null
                  , i = -1;
                for (i = 0; e = t[i]; i++)
                    e.disabled && (e.disabled = !1)
            },
            bindEvents: function() {
                var e = this;
                e.handler = function(t) {
                    switch (t.type) {
                    case "reset":
                    case "submit":
                        e.handleFormEvent(t);
                        break;
                    default:
                        e["handle" + l.pascalCase(t.type)](t)
                    }
                }
                ,
                l.on(e.dom.el, "click", e.handler),
                l.on(e.dom.el, "change", e.handler),
                l.on(e.dom.el, "keyup", e.handler),
                e.dom.form && (l.on(e.dom.form, "reset", e.handler),
                l.on(e.dom.form, "submit", e.handler))
            },
            unbindEvents: function() {
                var t = this;
                l.off(t.dom.el, "click", t.handler),
                l.off(t.dom.el, "change", t.handler),
                l.off(t.dom.el, "keyup", t.handler),
                t.dom.form && (l.off(t.dom.form, "reset", t.handler),
                l.off(t.dom.form, "submit", t.handler)),
                t.handler = null
            },
            handleClick: function(t) {
                var e, i = this, n = i.mixer, o = l.closestParent(t.target, "[data-filter], [data-toggle]", !0), a = -1, s = "";
                o && ((e = i.mixer.config.selectors.control) && !o.matches(e) || (t.stopPropagation(),
                n.lastClicked || (n.lastClicked = o),
                "function" == typeof n.config.callbacks.onMixClick && !1 === n.config.callbacks.onMixClick.call(n.lastClicked, n.state, t, i) || (o.matches("[data-filter]") ? (s = o.getAttribute("data-filter"),
                i.activeToggles = [],
                i.activeSelectors = i.activeFilters = [s]) : o.matches("[data-toggle]") && (s = o.getAttribute("data-toggle"),
                i.activeFilters = [],
                -1 < (a = i.activeToggles.indexOf(s)) ? i.activeToggles.splice(a, 1) : i.activeToggles.push(s),
                "and" === i.logic ? i.activeSelectors = [i.activeToggles] : i.activeSelectors = i.activeToggles),
                i.updateControls(),
                "change" === i.mixer.config.multifilter.parseOn && i.mixer.parseFilterGroups())))
            },
            handleChange: function(t) {
                var e = t.target;
                switch (t.stopPropagation(),
                e.type) {
                case "text":
                case "search":
                case "email":
                case "select-one":
                case "radio":
                    this.getSingleValue(e);
                    break;
                case "checkbox":
                case "select-multiple":
                    this.getMultipleValues(e)
                }
                "change" === this.mixer.config.multifilter.parseOn && this.mixer.parseFilterGroups()
            },
            handleKeyup: function(t) {
                var e = this
                  , i = t.target;
                ["text", "search", "email"].indexOf(i.type) < 0 || ("change" === e.mixer.config.multifilter.parseOn ? (clearTimeout(e.keyupTimeout),
                e.keyupTimeout = setTimeout(function() {
                    e.getSingleValue(i),
                    e.mixer.parseFilterGroups()
                }, e.mixer.config.multifilter.keyupThrottleDuration)) : e.mixer.getSingleValue(i))
            },
            handleFormEvent: function(t) {
                var e = this
                  , i = null
                  , n = null
                  , o = -1;
                if ("submit" === t.type && t.preventDefault(),
                "reset" === t.type && (e.activeFilters = e.activeToggles = e.activeSelectors = [],
                e.updateControls()),
                e.mixer.multifilterFormEventTracker)
                    i = e.mixer.multifilterFormEventTracker;
                else
                    for ((i = e.mixer.multifilterFormEventTracker = new a.MultifilterFormEventTracker).form = t.target,
                    o = 0; n = e.mixer.filterGroups[o]; o++)
                        n.dom.form === t.target && i.totalBound++;
                t.target === i.form && (i.totalHandled++,
                i.totalHandled === i.totalBound && (e.mixer.multifilterFormEventTracker = null,
                "submit" !== t.type && "change" !== e.mixer.config.multifilter.parseOn || e.mixer.parseFilterGroups()))
            },
            getSingleValue: function(t) {
                var e = this
                  , i = null
                  , n = ""
                  , o = ""
                  , a = ""
                  , s = -1;
                if (t.type.match(/text|search|email/g)) {
                    if (!(n = t.getAttribute("data-search-attribute")))
                        throw new Error("[MixItUp MultiFilter] A valid `data-search-attribute` must be present on text inputs");
                    if (t.value.length < e.mixer.config.multifilter.minSearchLength)
                        return void (e.activeSelectors = e.activeFilters = e.activeToggles = [""]);
                    for (a = t.value.toLowerCase().trim(),
                    s = 0; i = r[s]; s++)
                        a = a.replace(i[1], i[0]);
                    o = "[" + n + '*="' + (a = a.replace(/\W+/g, " ")) + '"]'
                } else
                    o = t.value;
                "string" == typeof t.value && (e.activeSelectors = e.activeToggles = e.activeFilters = o ? [o] : [])
            },
            getMultipleValues: function(t) {
                var e, i = this, n = [], o = "", a = null, s = -1;
                switch (t.type) {
                case "checkbox":
                    o = 'input[type="checkbox"]';
                    break;
                case "select-multiple":
                    o = "option"
                }
                for (e = i.dom.el.querySelectorAll(o),
                s = 0; a = e[s]; s++)
                    (a.checked || a.selected) && a.value && n.push(a.value);
                i.activeFilters = [],
                i.activeToggles = n,
                "and" === i.logic ? i.activeSelectors = [n] : i.activeSelectors = n
            },
            updateControls: function(t) {
                var e, i, n = null, o = "", a = -1;
                for (i = ["[data-filter]" + (e = this.mixer.config.selectors.control.trim()), "[data-toggle]" + e].join(", "),
                t = t || this.dom.el.querySelectorAll(i),
                a = 0; n = t[a]; a++)
                    o = Boolean(n.getAttribute("data-toggle")) ? "toggle" : "filter",
                    this.updateControl(n, o)
            },
            updateControl: function(t, e) {
                var i, n = t.getAttribute("data-" + e), o = this.activeToggles.concat(this.activeFilters);
                i = l.getClassname(this.mixer.config.classNames, e, this.mixer.config.classNames.modifierActive),
                -1 < o.indexOf(n) ? l.addClass(t, i) : l.removeClass(t, i)
            },
            updateUi: function() {
                var t = this
                  , e = t.dom.el.querySelectorAll("[data-filter], [data-toggle]")
                  , i = t.dom.el.querySelectorAll('input[type="radio"], input[type="checkbox"], option')
                  , n = t.activeToggles.concat(t.activeFilters)
                  , o = !1
                  , a = null
                  , s = -1;
                for (e.length && t.updateControls(e, !0),
                s = 0; a = i[s]; s++)
                    switch (o = -1 < n.indexOf(a.value),
                    a.tagName.toLowerCase()) {
                    case "option":
                        a.selected = o;
                        break;
                    case "input":
                        a.checked = o
                    }
            }
        }),
        a.MixerDom.registerAction("afterConstruct", "multifilter", function() {
            this.filterGroups = []
        }),
        a.Mixer.registerAction("afterConstruct", "multifilter", function() {
            this.filterGroups = [],
            this.filterGroupsHash = {},
            this.multifilterFormEventTracker = null
        }),
        a.Mixer.registerAction("afterCacheDom", "multifilter", function() {
            var t = this
              , e = null;
            if (t.config.multifilter.enable) {
                switch (t.config.controls.scope) {
                case "local":
                    e = t.dom.container;
                    break;
                case "global":
                    e = t.dom.document;
                    break;
                default:
                    throw new Error(a.messages.ERROR_CONFIG_INVALID_CONTROLS_SCOPE)
                }
                t.dom.filterGroups = e.querySelectorAll("[data-filter-group]")
            }
        }),
        a.Mixer.registerAction("beforeInitControls", "multifilter", function() {
            this.config.multifilter.enable && (this.config.controls.live = !0)
        }),
        a.Mixer.registerAction("afterSanitizeConfig", "multifilter", function() {
            this.config.multifilter.logicBetweenGroups = this.config.multifilter.logicBetweenGroups.toLowerCase().trim(),
            this.config.multifilter.logicWithinGroup = this.config.multifilter.logicWithinGroup.toLowerCase().trim()
        }),
        a.Mixer.registerAction("afterAttach", "multifilter", function() {
            this.dom.filterGroups.length && this.indexFilterGroups()
        }),
        a.Mixer.registerAction("afterUpdateControls", "multifilter", function() {
            var t = null
              , e = -1;
            for (e = 0; t = this.filterGroups[e]; e++)
                t.updateControls()
        }),
        a.Mixer.registerAction("beforeDestroy", "multifilter", function() {
            var t = null
              , e = -1;
            for (e = 0; t = this.filterGroups[e]; e++)
                t.unbindEvents()
        }),
        a.Mixer.extend({
            indexFilterGroups: function() {
                var t = this
                  , e = null
                  , i = null
                  , n = -1;
                for (n = 0; i = t.dom.filterGroups[n]; n++)
                    if ((e = new a.FilterGroup).init(i, t),
                    t.filterGroups.push(e),
                    e.name) {
                        if (void 0 !== t.filterGroupsHash[e.name])
                            throw new Error('[MixItUp MultiFilter] A filter group with name "' + e.name + '" already exists');
                        t.filterGroupsHash[e.name] = e
                    }
            },
            parseParseFilterGroupsArgs: function(t) {
                var e = new a.UserInstruction
                  , i = null
                  , n = -1;
                for (e.animate = this.config.animation.enable,
                e.command = new a.CommandFilter,
                n = 0; n < t.length; n++)
                    "boolean" == typeof (i = t[n]) ? e.animate = i : "function" == typeof i && (e.callback = i);
                return l.freeze(e),
                e
            },
            getFilterGroupPaths: function() {
                var i, n = null, t = null, o = [], a = [], s = [], e = -1;
                for (e = 0; e < this.filterGroups.length; e++)
                    (t = this.filterGroups[e].activeSelectors).length && (o.push(t),
                    s.push(0));
                return i = function() {
                    var t = null
                      , e = []
                      , i = -1;
                    for (i = 0; i < o.length; i++)
                        t = o[i][s[i]],
                        Array.isArray(t) && (t = t.join("")),
                        e.push(t);
                    e = l.clean(e),
                    a.push(e)
                }
                ,
                n = function(t) {
                    for (var e = o[t = t || 0]; s[t] < e.length; )
                        t < o.length - 1 ? n(t + 1) : i(),
                        s[t]++;
                    s[t] = 0
                }
                ,
                o.length ? (n(),
                a) : ""
            },
            buildSelectorFromPaths: function(t) {
                var e = []
                  , i = ""
                  , n = ""
                  , o = -1;
                if (!t.length)
                    return "";
                if ("or" === this.config.multifilter.logicBetweenGroups && (n = ", "),
                1 < t.length) {
                    for (o = 0; o < t.length; o++)
                        i = t[o].join(n),
                        e.indexOf(i) < 0 && e.push(i);
                    return e.join(", ")
                }
                return t[0].join(n)
            },
            parseFilterGroups: function() {
                var t = this
                  , e = t.parseFilterArgs(arguments)
                  , i = t.getFilterGroupPaths()
                  , n = t.buildSelectorFromPaths(i)
                  , o = null
                  , a = {};
                return "" === n && (n = t.config.controls.toggleDefault),
                e.command.selector = n,
                a.filter = e.command,
                "function" == typeof (o = t.config.callbacks.onParseFilterGroups) && (a = o(a)),
                t.multimix(a, e.animate, e.callback)
            },
            setFilterGroupSelectors: function(t, e) {
                var i = null;
                if (e = Array.isArray(e) ? e : [e],
                void 0 === (i = this.filterGroupsHash[t]))
                    throw new Error('[MixItUp MultiFilter] No filter group could be found with the name "' + t + '"');
                i.activeToggles = e.slice(),
                "and" === i.logic ? i.activeSelectors = [i.activeToggles] : i.activeSelectors = i.activeToggles,
                i.updateUi(i.activeToggles)
            },
            getFilterGroupSelectors: function(t) {
                var e = null;
                if (void 0 === (e = this.filterGroupsHash[t]))
                    throw new Error('[MixItUp MultiFilter] No filter group could be found with the name "' + t + '"');
                return e.activeSelectors.slice()
            }
        }),
        a.Facade.registerAction("afterConstruct", "multifilter", function(t) {
            this.parseFilterGroups = t.parseFilterGroups.bind(t),
            this.setFilterGroupSelectors = t.setFilterGroupSelectors.bind(t),
            this.getFilterGroupSelectors = t.getFilterGroupSelectors.bind(t)
        })
    };
    if (e.TYPE = "mixitup-extension",
    e.NAME = "mixitup-multifilter",
    e.EXTENSION_VERSION = "3.3.6",
    e.REQUIRE_CORE_VERSION = "^3.1.2",
    "object" == typeof exports && "object" == typeof module)
        module.exports = e;
    else if ("function" == typeof define && define.amd)
        define(function() {
            return e
        });
    else {
        if (!t.mixitup || "function" != typeof t.mixitup)
            throw new Error("[MixItUp MultiFilter] MixItUp core not found");
        e(t.mixitup)
    }
}(window),
function(t) {
    "use strict";
    var e = function(g) {
        var m = g.h;
        if (!g.CORE_VERSION || !m.compareVersions(e.REQUIRE_CORE_VERSION, g.CORE_VERSION))
            throw new Error("[MixItUp Pagination] MixItUp Pagination " + e.EXTENSION_VERSION + " requires at least MixItUp " + e.REQUIRE_CORE_VERSION);
        g.ConfigCallbacks.registerAction("afterConstruct", "pagination", function() {
            this.onPaginateStart = null,
            this.onPaginateEnd = null
        }),
        g.ConfigClassNames.registerAction("afterConstruct", "pagination", function() {
            this.elementPager = "control",
            this.elementPageList = "page-list",
            this.elementPageStats = "page-stats",
            this.modifierFirst = "first",
            this.modifierLast = "last",
            this.modifierPrev = "prev",
            this.modifierNext = "next",
            this.modifierTruncationMarker = "truncation-marker"
        }),
        g.ConfigLoad.registerAction("afterConstruct", "pagination", function() {
            this.page = 1
        }),
        g.ConfigPagination = function() {
            this.generatePageList = !0,
            this.generatePageStats = !0,
            this.maintainActivePage = !0,
            this.loop = !1,
            this.hidePageListIfSinglePage = !1,
            this.hidePageStatsIfSinglePage = !1,
            this.limit = -1,
            this.maxPagers = 5,
            m.seal(this)
        }
        ,
        g.ConfigRender.registerAction("afterConstruct", "pagination", function() {
            this.pager = null,
            this.pageStats = null
        }),
        g.ConfigSelectors.registerAction("afterConstruct", "pagination", function() {
            this.pageList = ".mixitup-page-list",
            this.pageStats = ".mixitup-page-stats"
        }),
        g.ConfigTemplates.registerAction("afterConstruct", "pagination", function() {
            this.pager = '<button type="button" class="${classNames}" data-page="${pageNumber}">${pageNumber}</button>',
            this.pagerPrev = '<button type="button" class="${classNames}" data-page="prev">&laquo;</button>',
            this.pagerNext = '<button type="button" class="${classNames}" data-page="next">&raquo;</button>',
            this.pagerTruncationMarker = '<span class="${classNames}">&hellip;</span>',
            this.pageStats = "${startPageAt} to ${endPageAt} of ${totalTargets}",
            this.pageStatsSingle = "${startPageAt} of ${totalTargets}",
            this.pageStatsFail = "None found"
        }),
        g.Config.registerAction("beforeConstruct", "pagination", function() {
            this.pagination = new g.ConfigPagination
        }),
        g.ModelPager = function() {
            this.pageNumber = -1,
            this.classNames = "",
            this.classList = [],
            this.isDisabled = !1,
            this.isPrev = !1,
            this.isNext = !1,
            this.isPageLink = !1,
            this.isTruncationMarker = !1,
            m.seal(this)
        }
        ,
        g.ModelPageStats = function() {
            this.startPageAt = -1,
            this.endPageAt = -1,
            this.totalTargets = -1,
            m.seal(this)
        }
        ,
        g.UiClassNames.registerAction("afterConstruct", "pagination", function() {
            this.first = "",
            this.last = "",
            this.prev = "",
            this.next = "",
            this.first = "",
            this.last = "",
            this.truncated = "",
            this.truncationMarker = ""
        }),
        g.controlDefinitions.push(new g.ControlDefinition("pager","[data-page]",!0,"pageListEls")),
        g.Control.registerFilter("commandsHandleClick", "pagination", function(t, e) {
            var i = this
              , n = {}
              , o = ""
              , a = null
              , s = null
              , r = -1;
            if (!i.selector || "[data-page]" !== i.selector)
                return t;
            for (s = m.closestParent(e.target, i.selector, !0, i.bound[0].dom.document),
            r = 0; a = i.bound[r]; r++)
                n = t[r],
                !a.config.pagination || a.config.pagination.limit < 0 || a.config.pagination.limit === 1 / 0 ? t[r] = null : !s || m.hasClass(s, a.classNamesPager.active) || m.hasClass(s, a.classNamesPager.disabled) ? t[r] = null : (o = s.getAttribute("data-page"),
                n.paginate = "prev" === o ? "prev" : "next" === o ? "next" : parseInt(o),
                a.lastClicked && (a.lastClicked = s));
            return t
        }),
        g.CommandMultimix.registerAction("afterConstruct", "pagination", function() {
            this.paginate = null
        }),
        g.CommandPaginate = function() {
            this.page = -1,
            this.limit = -1,
            this.action = "",
            this.anchor = null,
            m.seal(this)
        }
        ,
        g.Events.registerAction("afterConstruct", "pagination", function() {
            this.paginateStart = null,
            this.paginateEnd = null
        }),
        g.events = new g.Events,
        g.Operation.registerAction("afterConstruct", "pagination", function() {
            this.startPagination = null,
            this.newPagination = null,
            this.startTotalPages = -1,
            this.newTotalPages = -1
        }),
        g.State.registerAction("afterConstruct", "pagination", function() {
            this.activePagination = null,
            this.totalPages = -1
        }),
        g.MixerDom.registerAction("afterConstruct", "pagination", function() {
            this.pageListEls = [],
            this.pageStatsEls = []
        }),
        g.Mixer.registerAction("afterConstruct", "pagination", function() {
            this.classNamesPager = new g.UiClassNames,
            this.classNamesPageList = new g.UiClassNames,
            this.classNamesPageStats = new g.UiClassNames
        }),
        g.Mixer.registerAction("afterAttach", "pagination", function() {
            var t = this
              , e = null
              , i = -1;
            if (!(t.config.pagination.limit < 0)) {
                if (t.classNamesPager.base = m.getClassname(t.config.classNames, "pager"),
                t.classNamesPager.active = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierActive),
                t.classNamesPager.disabled = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierDisabled),
                t.classNamesPager.first = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierFirst),
                t.classNamesPager.last = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierLast),
                t.classNamesPager.prev = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierPrev),
                t.classNamesPager.next = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierNext),
                t.classNamesPager.truncationMarker = m.getClassname(t.config.classNames, "pager", t.config.classNames.modifierTruncationMarker),
                t.classNamesPageList.base = m.getClassname(t.config.classNames, "page-list"),
                t.classNamesPageList.disabled = m.getClassname(t.config.classNames, "page-list", t.config.classNames.modifierDisabled),
                t.classNamesPageStats.base = m.getClassname(t.config.classNames, "page-stats"),
                t.classNamesPageStats.disabled = m.getClassname(t.config.classNames, "page-stats", t.config.classNames.modifierDisabled),
                t.config.pagination.generatePageList && 0 < t.dom.pageListEls.length)
                    for (i = 0; e = t.dom.pageListEls[i]; i++)
                        t.renderPageListEl(e, t.lastOperation);
                if (t.config.pagination.generatePageStats && 0 < t.dom.pageStatsEls.length)
                    for (i = 0; e = t.dom.pageStatsEls[i]; i++)
                        t.renderPageStatsEl(e, t.lastOperation)
            }
        }),
        g.Mixer.registerAction("afterSanitizeConfig", "pagination", function() {
            var i = this
              , n = i.config.callbacks.onMixStart
              , e = i.config.callbacks.onMixEnd
              , o = i.config.callbacks.onPaginateStart
              , a = i.config.callbacks.onPaginateEnd
              , s = !1;
            i.config.pagination.limit < 0 || (i.classNamesPager = new g.UiClassNames,
            i.classNamesPageList = new g.UiClassNames,
            i.classNamesPageStats = new g.UiClassNames,
            i.config.callbacks.onMixStart = function(t, e) {
                t.activePagination.limit === e.activePagination.limit && t.activePagination.page === e.activePagination.page || (s = !0),
                "function" == typeof n && n.apply(i.dom.container, arguments),
                s && (g.events.fire("paginateStart", i.dom.container, {
                    state: t,
                    futureState: e,
                    instance: i
                }, i.dom.document),
                "function" == typeof o && o.apply(i.dom.container, arguments))
            }
            ,
            i.config.callbacks.onMixEnd = function(t) {
                "function" == typeof e && e.apply(i.dom.container, arguments),
                s && (s = !1,
                g.events.fire("paginateEnd", i.dom.container, {
                    state: t,
                    instance: i
                }, i.dom.document),
                "function" == typeof a && a.apply(i.dom.container, arguments))
            }
            )
        }),
        g.Mixer.registerFilter("operationGetInitialState", "pagination", function(t, e) {
            return this.config.pagination.limit < 0 || (t.newPagination = e.activePagination),
            t
        }),
        g.Mixer.registerFilter("stateGetInitialState", "pagination", function(t) {
            return this.config.pagination.limit < 0 || (t.activePagination = new g.CommandPaginate,
            t.activePagination.page = this.config.load.page,
            t.activePagination.limit = this.config.pagination.limit),
            t
        }),
        g.Mixer.registerAction("afterGetFinalMixData", "pagination", function() {
            this.config.pagination.limit < 0 || "number" == typeof this.config.pagination.maxPagers && (this.config.pagination.maxPagers = Math.max(5, this.config.pagination.maxPagers))
        }),
        g.Mixer.registerAction("afterCacheDom", "pagination", function() {
            var t = this
              , e = null;
            if (!(t.config.pagination.limit < 0) && t.config.pagination.generatePageList) {
                switch (t.config.controls.scope) {
                case "local":
                    e = t.dom.container;
                    break;
                case "global":
                    e = t.dom.document;
                    break;
                default:
                    throw new Error(g.messages.ERROR_CONFIG_INVALID_CONTROLS_SCOPE)
                }
                t.dom.pageListEls = e.querySelectorAll(t.config.selectors.pageList),
                t.dom.pageStatsEls = e.querySelectorAll(t.config.selectors.pageStats)
            }
        }),
        g.Mixer.registerFilter("stateBuildState", "pagination", function(t, e) {
            return this.config.pagination.limit < 0 || (t.activePagination = e.newPagination,
            t.totalPages = e.newTotalPages),
            t
        }),
        g.Mixer.registerFilter("instructionParseMultimixArgs", "pagination", function(t) {
            return this.config.pagination.limit < 0 || !t.command.paginate || t.command.paginate instanceof g.CommandPaginate || (t.command.paginate = this.parsePaginateArgs([t.command.paginate]).command),
            t
        }),
        g.Mixer.registerAction("afterFilterOperation", "pagination", function(t) {
            var e = -1
              , i = -1
              , n = []
              , o = []
              , a = null
              , s = -1
              , r = -1;
            if (!(this.config.pagination.limit < 0)) {
                if (t.newTotalPages = t.newPagination.limit ? Math.max(Math.ceil(t.matching.length / t.newPagination.limit), 1) : 1,
                this.config.pagination.maintainActivePage && (t.newPagination.page = t.newPagination.page > t.newTotalPages ? t.newTotalPages : t.newPagination.page),
                this.config.pagination.limit = t.newPagination.limit,
                t.newPagination.anchor) {
                    for (r = 0; (a = t.matching[r]) && a.dom.el !== t.newPagination.anchor; r++)
                        ;
                    i = (e = r) + t.newPagination.limit - 1
                } else
                    e = t.newPagination.limit * (t.newPagination.page - 1),
                    i = t.newPagination.limit * t.newPagination.page - 1,
                    isNaN(e) && (e = 0);
                if (!(t.newPagination.limit < 0)) {
                    for (r = 0; a = t.show[r]; r++)
                        e <= r && r <= i ? n.push(a) : o.push(a);
                    for (t.show = n,
                    r = 0; a = t.toHide[r]; r++)
                        a.isShown || (t.toHide.splice(r, 1),
                        a.isShown = !1,
                        r--);
                    for (r = 0; a = o[r]; r++)
                        t.hide.push(a),
                        -1 < (s = t.toShow.indexOf(a)) && t.toShow.splice(s, 1),
                        a.isShown && t.toHide.push(a)
                }
            }
        }),
        g.Mixer.registerFilter("operationUnmappedGetOperation", "pagination", function(t, e) {
            var i = this;
            return i.config.pagination.limit < 0 || (t.startState = i.state,
            t.startPagination = i.state.activePagination,
            t.startTotalPages = i.state.totalPages,
            t.newPagination = new g.CommandPaginate,
            t.newPagination.limit = t.startPagination.limit,
            t.newPagination.page = t.startPagination.page,
            e.paginate ? i.parsePaginateCommand(e.paginate, t) : (e.filter || e.sort) && (m.extend(t.newPagination, t.startPagination),
            i.config.pagination.maintainActivePage ? t.newPagination.page = i.state.activePagination.page : t.newPagination.page = 1)),
            t
        }),
        g.Mixer.registerFilter("operationMappedGetOperation", "pagination", function(t, e, i) {
            var n = this
              , o = null
              , a = -1;
            if (n.config.pagination.limit < 0)
                return t;
            if (i)
                return t;
            if (n.config.pagination.generatePageList && 0 < n.dom.pageListEls.length)
                for (a = 0; o = n.dom.pageListEls[a]; a++)
                    n.renderPageListEl(o, t);
            if (n.config.pagination.generatePageStats && 0 < n.dom.pageStatsEls.length)
                for (a = 0; o = n.dom.pageStatsEls[a]; a++)
                    n.renderPageStatsEl(o, t);
            return t
        }),
        g.Mixer.extend({
            parsePaginateCommand: function(t, e) {
                if (-1 < t.page) {
                    if (0 === t.page)
                        throw new Error(g.messages.ERROR_PAGINATE_INDEX_RANGE);
                    e.newPagination.page = Math.max(1, Math.min(1 / 0, t.page))
                } else
                    "next" === t.action ? e.newPagination.page = this.getNextPage() : "prev" === t.action ? e.newPagination.page = this.getPrevPage() : t.anchor && (e.newPagination.anchor = t.anchor);
                -1 < t.limit && (e.newPagination.limit = t.limit),
                e.newPagination.limit !== e.startPagination.limit && (e.newTotalPages = e.newPagination.limit ? Math.max(Math.ceil(e.startState.matching.length / e.newPagination.limit), 1) : 1),
                (e.newPagination.limit <= 0 || e.newPagination.limit === 1 / 0) && (e.newPagination.page = 1)
            },
            getNextPage: function() {
                var t = -1;
                return (t = this.state.activePagination.page + 1) > this.state.totalPages && (t = this.config.pagination.loop ? 1 : this.state.activePagination.page),
                t
            },
            getPrevPage: function() {
                var t = -1;
                return (t = this.state.activePagination.page - 1) < 1 && (t = this.config.pagination.loop ? this.state.totalPages : this.state.activePagination.page),
                t
            },
            renderPageListEl: function(t, e) {
                var i, n, o, a = this, s = "", r = [], l = null, c = null, u = [], d = !1, p = !1, f = null, h = -1;
                if (e.newPagination.limit < 0 || e.newPagination.limit === 1 / 0 || e.newTotalPages < 2 && a.config.pagination.hidePageListIfSinglePage)
                    return t.innerHTML = "",
                    void m.addClass(t, a.classNamesPageList.disabled);
                for (i = e.newPagination.page - 1,
                c = "function" == typeof (c = a.config.render.pager) ? c : null,
                a.config.pagination.maxPagers < 1 / 0 && e.newTotalPages > a.config.pagination.maxPagers && (u = a.getAllowedIndices(e)),
                (l = new g.ModelPager).isPrev = !0,
                l.classList.push(a.classNamesPager.base, a.classNamesPager.prev),
                1 !== e.newPagination.page || a.config.pagination.loop || (l.classList.push(a.classNamesPager.disabled),
                l.isDisabled = !0),
                l.classNames = l.classList.join(" "),
                s = c ? c(l) : m.template(a.config.templates.pagerPrev)(l),
                r.push(s),
                h = 0; h < e.newTotalPages; h++)
                    (s = a.renderPager(h, e, u)) || h < i && d || i < h && p ? s && r.push(s) : ((l = new g.ModelPager).isTruncationMarker = !0,
                    l.classList.push(a.classNamesPager.base, a.classNamesPager.truncationMarker),
                    l.classNames = l.classList.join(" "),
                    s = c ? c(l) : m.template(a.config.templates.pagerTruncationMarker)(l),
                    r.push(s),
                    h < i && (d = !0),
                    i < h && (p = !0));
                for ((l = new g.ModelPager).isNext = !0,
                l.classList.push(a.classNamesPager.base, a.classNamesPager.next),
                e.newPagination.page !== e.newTotalPages || a.config.pagination.loop || l.classList.push(a.classNamesPager.disabled),
                l.classNames = l.classList.join(" "),
                s = c ? c(l) : m.template(a.config.templates.pagerNext)(l),
                r.push(s),
                o = r.join(" "),
                t.innerHTML = o,
                n = t.querySelectorAll("." + a.classNamesPager.disabled),
                h = 0; f = n[h]; h++)
                    "boolean" == typeof f.disabled && (f.disabled = !0);
                d || p ? m.addClass(t, a.classNamesPageList.truncated) : m.removeClass(t, a.classNamesPageList.truncated),
                1 < e.newTotalPages ? m.removeClass(t, a.classNamesPageList.disabled) : m.addClass(t, a.classNamesPageList.disabled)
            },
            getAllowedIndices: function(t) {
                var e, i, n = t.newPagination.page - 1, o = t.newTotalPages - 1, a = [], s = -1, r = -1, l = -1;
                for (a.push(0),
                s = this.config.pagination.maxPagers - 2,
                r = 0,
                (e = n - Math.ceil((s - 1) / 2)) < 1 && (r = 1 - e),
                o - 1 < (i = n + Math.floor((s - 1) / 2)) && (r = o - 1 - i),
                l = e + r; s; )
                    a.push(l),
                    l++,
                    s--;
                return a.push(o),
                a
            },
            renderPager: function(t, e, i) {
                var n = this
                  , o = null
                  , a = e.newPagination.page - 1
                  , s = new g.ModelPager;
                return n.config.pagination.maxPagers < 1 / 0 && i.length && i.indexOf(t) < 0 ? "" : (o = "function" == typeof (o = n.config.render.pager) ? o : null,
                s.isPageLink = !0,
                s.classList.push(n.classNamesPager.base),
                0 === t && s.classList.push(n.classNamesPager.first),
                t === e.newTotalPages - 1 && s.classList.push(n.classNamesPager.last),
                t === a && s.classList.push(n.classNamesPager.active),
                s.classNames = s.classList.join(" "),
                s.pageNumber = t + 1,
                o ? o(s) : m.template(n.config.templates.pager)(s))
            },
            renderPageStatsEl: function(t, e) {
                var i = this
                  , n = new g.ModelPageStats
                  , o = null
                  , a = ""
                  , s = "";
                if (e.newPagination.limit < 0 || e.newPagination.limit === 1 / 0 || e.newTotalPages < 2 && i.config.pagination.hidePageStatsIfSinglePage)
                    return t.innerHTML = "",
                    void m.addClass(t, i.classNamesPageStats.disabled);
                o = "function" == typeof (o = i.config.render.pageStats) ? o : null,
                n.totalTargets = e.matching.length,
                s = n.totalTargets ? 1 === e.newPagination.limit ? i.config.templates.pageStatsSingle : i.config.templates.pageStats : i.config.templates.pageStatsFail,
                n.totalTargets && 0 < e.newPagination.limit ? (n.startPageAt = (e.newPagination.page - 1) * e.newPagination.limit + 1,
                n.endPageAt = Math.min(n.startPageAt + e.newPagination.limit - 1, n.totalTargets)) : n.startPageAt = n.endPageAt = 0,
                a = o ? o(n) : m.template(s)(n),
                t.innerHTML = a,
                n.totalTargets ? m.removeClass(t, i.classNamesPageStats.disabled) : m.addClass(t, i.classNamesPageStats.disabled)
            },
            parsePaginateArgs: function(t) {
                var e = new g.UserInstruction
                  , i = null
                  , n = -1;
                for (e.animate = this.config.animation.enable,
                e.command = new g.CommandPaginate,
                n = 0; n < t.length; n++)
                    null !== (i = t[n]) && ("object" == typeof i && m.isElement(i, this.dom.document) ? e.command.anchor = i : i instanceof g.CommandPaginate || "object" == typeof i ? m.extend(e.command, i) : "number" == typeof i ? e.command.page = i : "string" != typeof i || isNaN(parseInt(i)) ? "string" == typeof i ? e.command.action = i : "boolean" == typeof i ? e.animate = i : "function" == typeof i && (e.callback = i) : e.command.page = parseInt(i));
                return m.freeze(e),
                e
            },
            paginate: function() {
                var t = this.parsePaginateArgs(arguments);
                return this.multimix({
                    paginate: t.command
                }, t.animate, t.callback)
            },
            nextPage: function() {
                var t = this.parsePaginateArgs(arguments);
                return this.multimix({
                    paginate: {
                        action: "next"
                    }
                }, t.animate, t.callback)
            },
            prevPage: function() {
                var t = this.parsePaginateArgs(arguments);
                return this.multimix({
                    paginate: {
                        action: "prev"
                    }
                }, t.animate, t.callback)
            }
        }),
        g.Facade.registerAction("afterConstruct", "pagination", function(t) {
            this.paginate = t.paginate.bind(t),
            this.nextPage = t.nextPage.bind(t),
            this.prevPage = t.prevPage.bind(t)
        })
    };
    if (e.TYPE = "mixitup-extension",
    e.NAME = "mixitup-pagination",
    e.EXTENSION_VERSION = "3.3.0",
    e.REQUIRE_CORE_VERSION = "^3.1.8",
    "object" == typeof exports && "object" == typeof module)
        module.exports = e;
    else if ("function" == typeof define && define.amd)
        define(function() {
            return e
        });
    else {
        if (!t.mixitup || "function" != typeof t.mixitup)
            throw new Error("[MixItUp Pagination] MixItUp core not found");
        e(t.mixitup)
    }
}(window),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(c) {
    "use strict";
    var o, s = window.Slick || {};
    o = 0,
    (s = function(t, e) {
        var i, n = this;
        n.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: c(t),
            appendDots: c(t),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(t, e) {
                return c('<button type="button" data-role="none" role="button" tabindex="0" />').text(e + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        },
        n.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        },
        c.extend(n, n.initials),
        n.activeBreakpoint = null,
        n.animType = null,
        n.animProp = null,
        n.breakpoints = [],
        n.breakpointSettings = [],
        n.cssTransitions = !1,
        n.focussed = !1,
        n.interrupted = !1,
        n.hidden = "hidden",
        n.paused = !0,
        n.positionProp = null,
        n.respondTo = null,
        n.rowCount = 1,
        n.shouldClick = !0,
        n.$slider = c(t),
        n.$slidesCache = null,
        n.transformType = null,
        n.transitionType = null,
        n.visibilityChange = "visibilitychange",
        n.windowWidth = 0,
        n.windowTimer = null,
        i = c(t).data("slick") || {},
        n.options = c.extend({}, n.defaults, e, i),
        n.currentSlide = n.options.initialSlide,
        n.originalSettings = n.options,
        void 0 !== document.mozHidden ? (n.hidden = "mozHidden",
        n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden",
        n.visibilityChange = "webkitvisibilitychange"),
        n.autoPlay = c.proxy(n.autoPlay, n),
        n.autoPlayClear = c.proxy(n.autoPlayClear, n),
        n.autoPlayIterator = c.proxy(n.autoPlayIterator, n),
        n.changeSlide = c.proxy(n.changeSlide, n),
        n.clickHandler = c.proxy(n.clickHandler, n),
        n.selectHandler = c.proxy(n.selectHandler, n),
        n.setPosition = c.proxy(n.setPosition, n),
        n.swipeHandler = c.proxy(n.swipeHandler, n),
        n.dragHandler = c.proxy(n.dragHandler, n),
        n.keyHandler = c.proxy(n.keyHandler, n),
        n.instanceUid = o++,
        n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
        n.registerBreakpoints(),
        n.init(!0)
    }
    ).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }
    ,
    s.prototype.addSlide = s.prototype.slickAdd = function(t, e, i) {
        var n = this;
        if ("boolean" == typeof e)
            i = e,
            e = null;
        else if (e < 0 || e >= n.slideCount)
            return !1;
        n.unload(),
        "number" == typeof e ? 0 === e && 0 === n.$slides.length ? c(t).appendTo(n.$slideTrack) : i ? c(t).insertBefore(n.$slides.eq(e)) : c(t).insertAfter(n.$slides.eq(e)) : !0 === i ? c(t).prependTo(n.$slideTrack) : c(t).appendTo(n.$slideTrack),
        n.$slides = n.$slideTrack.children(this.options.slide),
        n.$slideTrack.children(this.options.slide).detach(),
        n.$slideTrack.append(n.$slides),
        n.$slides.each(function(t, e) {
            c(e).attr("data-slick-index", t)
        }),
        n.$slidesCache = n.$slides,
        n.reinit()
    }
    ,
    s.prototype.animateHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({
                height: e
            }, t.options.speed)
        }
    }
    ,
    s.prototype.animateSlide = function(t, e) {
        var i = {}
          , n = this;
        n.animateHeight(),
        !0 === n.options.rtl && !1 === n.options.vertical && (t = -t),
        !1 === n.transformsEnabled ? !1 === n.options.vertical ? n.$slideTrack.animate({
            left: t
        }, n.options.speed, n.options.easing, e) : n.$slideTrack.animate({
            top: t
        }, n.options.speed, n.options.easing, e) : !1 === n.cssTransitions ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
        c({
            animStart: n.currentLeft
        }).animate({
            animStart: t
        }, {
            duration: n.options.speed,
            easing: n.options.easing,
            step: function(t) {
                t = Math.ceil(t),
                !1 === n.options.vertical ? i[n.animType] = "translate(" + t + "px, 0px)" : i[n.animType] = "translate(0px," + t + "px)",
                n.$slideTrack.css(i)
            },
            complete: function() {
                e && e.call()
            }
        })) : (n.applyTransition(),
        t = Math.ceil(t),
        !1 === n.options.vertical ? i[n.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[n.animType] = "translate3d(0px," + t + "px, 0px)",
        n.$slideTrack.css(i),
        e && setTimeout(function() {
            n.disableTransition(),
            e.call()
        }, n.options.speed))
    }
    ,
    s.prototype.getNavTarget = function() {
        var t = this.options.asNavFor;
        return t && null !== t && (t = c(t).not(this.$slider)),
        t
    }
    ,
    s.prototype.asNavFor = function(e) {
        var t = this.getNavTarget();
        null !== t && "object" == typeof t && t.each(function() {
            var t = c(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }
    ,
    s.prototype.applyTransition = function(t) {
        var e = this
          , i = {};
        !1 === e.options.fade ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
        !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }
    ,
    s.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(),
        t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }
    ,
    s.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }
    ,
    s.prototype.autoPlayIterator = function() {
        var t = this
          , e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll,
        t.currentSlide - 1 == 0 && (t.direction = 1))),
        t.slideHandler(e))
    }
    ,
    s.prototype.buildArrows = function() {
        var t = this;
        !0 === t.options.arrows && (t.$prevArrow = c(t.options.prevArrow).addClass("slick-arrow"),
        t.$nextArrow = c(t.options.nextArrow).addClass("slick-arrow"),
        t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
        t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
        !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }
    ,
    s.prototype.buildDots = function() {
        var t, e, i = this;
        if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
            for (i.$slider.addClass("slick-dotted"),
            e = c("<ul />").addClass(i.options.dotsClass),
            t = 0; t <= i.getDotCount(); t += 1)
                e.append(c("<li />").append(i.options.customPaging.call(this, i, t)));
            i.$dots = e.appendTo(i.options.appendDots),
            i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
        }
    }
    ,
    s.prototype.buildOut = function() {
        var t = this;
        t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        t.slideCount = t.$slides.length,
        t.$slides.each(function(t, e) {
            c(e).attr("data-slick-index", t).data("originalStyling", c(e).attr("style") || "")
        }),
        t.$slider.addClass("slick-slider"),
        t.$slideTrack = 0 === t.slideCount ? c('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(),
        t.$list = t.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
        t.$slideTrack.css("opacity", 0),
        !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1),
        c("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
        t.setupInfinite(),
        t.buildArrows(),
        t.buildDots(),
        t.updateDots(),
        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
        !0 === t.options.draggable && t.$list.addClass("draggable")
    }
    ,
    s.prototype.buildRows = function() {
        var t, e, i, n, o, a, s, r = this;
        if (n = document.createDocumentFragment(),
        a = r.$slider.children(),
        1 < r.options.rows) {
            for (s = r.options.slidesPerRow * r.options.rows,
            o = Math.ceil(a.length / s),
            t = 0; t < o; t++) {
                var l = document.createElement("div");
                for (e = 0; e < r.options.rows; e++) {
                    var c = document.createElement("div");
                    for (i = 0; i < r.options.slidesPerRow; i++) {
                        var u = t * s + (e * r.options.slidesPerRow + i);
                        a.get(u) && c.appendChild(a.get(u))
                    }
                    l.appendChild(c)
                }
                n.appendChild(l)
            }
            r.$slider.empty().append(n),
            r.$slider.children().children().children().css({
                width: 100 / r.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }
    ,
    s.prototype.checkResponsive = function(t, e) {
        var i, n, o, a = this, s = !1, r = a.$slider.width(), l = window.innerWidth || c(window).width();
        if ("window" === a.respondTo ? o = l : "slider" === a.respondTo ? o = r : "min" === a.respondTo && (o = Math.min(l, r)),
        a.options.responsive && a.options.responsive.length && null !== a.options.responsive) {
            for (i in n = null,
            a.breakpoints)
                a.breakpoints.hasOwnProperty(i) && (!1 === a.originalSettings.mobileFirst ? o < a.breakpoints[i] && (n = a.breakpoints[i]) : o > a.breakpoints[i] && (n = a.breakpoints[i]));
            null !== n ? null !== a.activeBreakpoint && n === a.activeBreakpoint && !e || (a.activeBreakpoint = n,
            "unslick" === a.breakpointSettings[n] ? a.unslick(n) : (a.options = c.extend({}, a.originalSettings, a.breakpointSettings[n]),
            !0 === t && (a.currentSlide = a.options.initialSlide),
            a.refresh(t)),
            s = n) : null !== a.activeBreakpoint && (a.activeBreakpoint = null,
            a.options = a.originalSettings,
            !0 === t && (a.currentSlide = a.options.initialSlide),
            a.refresh(t),
            s = n),
            t || !1 === s || a.$slider.trigger("breakpoint", [a, s])
        }
    }
    ,
    s.prototype.changeSlide = function(t, e) {
        var i, n, o = this, a = c(t.currentTarget);
        switch (a.is("a") && t.preventDefault(),
        a.is("li") || (a = a.closest("li")),
        i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll,
        t.data.message) {
        case "previous":
            n = 0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i,
            o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - n, !1, e);
            break;
        case "next":
            n = 0 == i ? o.options.slidesToScroll : i,
            o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + n, !1, e);
            break;
        case "index":
            var s = 0 === t.data.index ? 0 : t.data.index || a.index() * o.options.slidesToScroll;
            o.slideHandler(o.checkNavigable(s), !1, e),
            a.children().trigger("focus");
            break;
        default:
            return
        }
    }
    ,
    s.prototype.checkNavigable = function(t) {
        var e, i;
        if (i = 0,
        t > (e = this.getNavigableIndexes())[e.length - 1])
            t = e[e.length - 1];
        else
            for (var n in e) {
                if (t < e[n]) {
                    t = i;
                    break
                }
                i = e[n]
            }
        return t
    }
    ,
    s.prototype.cleanUpEvents = function() {
        var t = this;
        t.options.dots && null !== t.$dots && c("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", c.proxy(t.interrupt, t, !0)).off("mouseleave.slick", c.proxy(t.interrupt, t, !1)),
        t.$slider.off("focus.slick blur.slick"),
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
        t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
        t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
        t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
        t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
        t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
        t.$list.off("click.slick", t.clickHandler),
        c(document).off(t.visibilityChange, t.visibility),
        t.cleanUpSlideEvents(),
        !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
        !0 === t.options.focusOnSelect && c(t.$slideTrack).children().off("click.slick", t.selectHandler),
        c(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
        c(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
        c("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
        c(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
        c(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition)
    }
    ,
    s.prototype.cleanUpSlideEvents = function() {
        var t = this;
        t.$list.off("mouseenter.slick", c.proxy(t.interrupt, t, !0)),
        t.$list.off("mouseleave.slick", c.proxy(t.interrupt, t, !1))
    }
    ,
    s.prototype.cleanUpRows = function() {
        var t;
        1 < this.options.rows && ((t = this.$slides.children().children()).removeAttr("style"),
        this.$slider.empty().append(t))
    }
    ,
    s.prototype.clickHandler = function(t) {
        !1 === this.shouldClick && (t.stopImmediatePropagation(),
        t.stopPropagation(),
        t.preventDefault())
    }
    ,
    s.prototype.destroy = function(t) {
        var e = this;
        e.autoPlayClear(),
        e.touchObject = {},
        e.cleanUpEvents(),
        c(".slick-cloned", e.$slider).detach(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && e.$prevArrow.length && (e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove()),
        e.$nextArrow && e.$nextArrow.length && (e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove()),
        e.$slides && (e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            c(this).attr("style", c(this).data("originalStyling"))
        }),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slideTrack.detach(),
        e.$list.detach(),
        e.$slider.append(e.$slides)),
        e.cleanUpRows(),
        e.$slider.removeClass("slick-slider"),
        e.$slider.removeClass("slick-initialized"),
        e.$slider.removeClass("slick-dotted"),
        e.unslicked = !0,
        t || e.$slider.trigger("destroy", [e])
    }
    ,
    s.prototype.disableTransition = function(t) {
        var e = {};
        e[this.transitionType] = "",
        !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(t).css(e)
    }
    ,
    s.prototype.fadeSlide = function(t, e) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(t).css({
            zIndex: i.options.zIndex
        }),
        i.$slides.eq(t).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t),
        i.$slides.eq(t).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }),
        e && setTimeout(function() {
            i.disableTransition(t),
            e.call()
        }, i.options.speed))
    }
    ,
    s.prototype.fadeSlideOut = function(t) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(t).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(t),
        e.$slides.eq(t).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }
    ,
    s.prototype.filterSlides = s.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.$slidesCache = e.$slides,
        e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(t).appendTo(e.$slideTrack),
        e.reinit())
    }
    ,
    s.prototype.focusHandler = function() {
        var i = this;
        i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(t) {
            t.stopImmediatePropagation();
            var e = c(this);
            setTimeout(function() {
                i.options.pauseOnFocus && (i.focussed = e.is(":focus"),
                i.autoPlay())
            }, 0)
        })
    }
    ,
    s.prototype.getCurrent = s.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }
    ,
    s.prototype.getDotCount = function() {
        var t = this
          , e = 0
          , i = 0
          , n = 0;
        if (!0 === t.options.infinite)
            for (; e < t.slideCount; )
                ++n,
                e = i + t.options.slidesToScroll,
                i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else if (!0 === t.options.centerMode)
            n = t.slideCount;
        else
            for (; e < t.slideCount; )
                ++n,
                e = i + t.options.slidesToScroll,
                i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        return n - 1
    }
    ,
    s.prototype.getLeft = function(t) {
        var e, i, n, o = this, a = 0;
        return o.slideOffset = 0,
        i = o.$slides.first().outerHeight(!0),
        !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1,
        a = i * o.options.slidesToShow * -1),
        o.slideCount % o.options.slidesToScroll != 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (a = t > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * -1,
        (o.options.slidesToShow - (t - o.slideCount)) * i * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1,
        o.slideCount % o.options.slidesToScroll * i * -1))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth,
        a = (t + o.options.slidesToShow - o.slideCount) * i),
        o.slideCount <= o.options.slidesToShow && (a = o.slideOffset = 0),
        !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0,
        o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)),
        e = !1 === o.options.vertical ? t * o.slideWidth * -1 + o.slideOffset : t * i * -1 + a,
        !0 === o.options.variableWidth && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow),
        e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0,
        !0 === o.options.centerMode && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1),
        e = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0,
        e += (o.$list.width() - n.outerWidth()) / 2)),
        e
    }
    ,
    s.prototype.getOption = s.prototype.slickGetOption = function(t) {
        return this.options[t]
    }
    ,
    s.prototype.getNavigableIndexes = function() {
        var t, e = this, i = 0, n = 0, o = [];
        for (t = !1 === e.options.infinite ? e.slideCount : (i = -1 * e.options.slidesToScroll,
        n = -1 * e.options.slidesToScroll,
        2 * e.slideCount); i < t; )
            o.push(i),
            i = n + e.options.slidesToScroll,
            n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return o
    }
    ,
    s.prototype.getSlick = function() {
        return this
    }
    ,
    s.prototype.getSlideCount = function() {
        var i, n, o = this;
        return n = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0,
        !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(t, e) {
            if (e.offsetLeft - n + c(e).outerWidth() / 2 > -1 * o.swipeLeft)
                return i = e,
                !1
        }),
        Math.abs(c(i).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }
    ,
    s.prototype.goTo = s.prototype.slickGoTo = function(t, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }
    ,
    s.prototype.init = function(t) {
        var e = this;
        c(e.$slider).hasClass("slick-initialized") || (c(e.$slider).addClass("slick-initialized"),
        e.buildRows(),
        e.buildOut(),
        e.setProps(),
        e.startLoad(),
        e.loadSlider(),
        e.initializeEvents(),
        e.updateArrows(),
        e.updateDots(),
        e.checkResponsive(!0),
        e.focusHandler()),
        t && e.$slider.trigger("init", [e]),
        !0 === e.options.accessibility && e.initADA(),
        e.options.autoplay && (e.paused = !1,
        e.autoPlay())
    }
    ,
    s.prototype.initADA = function() {
        var e = this;
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        e.$slideTrack.attr("role", "listbox"),
        e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t) {
            c(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + e.instanceUid + t
            })
        }),
        null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(t) {
            c(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + t,
                id: "slick-slide" + e.instanceUid + t
            })
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"),
        e.activateADA()
    }
    ,
    s.prototype.initArrowEvents = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, t.changeSlide),
        t.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, t.changeSlide))
    }
    ,
    s.prototype.initDotEvents = function() {
        var t = this;
        !0 === t.options.dots && t.slideCount > t.options.slidesToShow && c("li", t.$dots).on("click.slick", {
            message: "index"
        }, t.changeSlide),
        !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && c("li", t.$dots).on("mouseenter.slick", c.proxy(t.interrupt, t, !0)).on("mouseleave.slick", c.proxy(t.interrupt, t, !1))
    }
    ,
    s.prototype.initSlideEvents = function() {
        var t = this;
        t.options.pauseOnHover && (t.$list.on("mouseenter.slick", c.proxy(t.interrupt, t, !0)),
        t.$list.on("mouseleave.slick", c.proxy(t.interrupt, t, !1)))
    }
    ,
    s.prototype.initializeEvents = function() {
        var t = this;
        t.initArrowEvents(),
        t.initDotEvents(),
        t.initSlideEvents(),
        t.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, t.swipeHandler),
        t.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, t.swipeHandler),
        t.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, t.swipeHandler),
        t.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, t.swipeHandler),
        t.$list.on("click.slick", t.clickHandler),
        c(document).on(t.visibilityChange, c.proxy(t.visibility, t)),
        !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
        !0 === t.options.focusOnSelect && c(t.$slideTrack).children().on("click.slick", t.selectHandler),
        c(window).on("orientationchange.slick.slick-" + t.instanceUid, c.proxy(t.orientationChange, t)),
        c(window).on("resize.slick.slick-" + t.instanceUid, c.proxy(t.resize, t)),
        c("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
        c(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
        c(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition)
    }
    ,
    s.prototype.initUI = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(),
        t.$nextArrow.show()),
        !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.show()
    }
    ,
    s.prototype.keyHandler = function(t) {
        var e = this;
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === e.options.accessibility ? e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "next" : "previous"
            }
        }) : 39 === t.keyCode && !0 === e.options.accessibility && e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "previous" : "next"
            }
        }))
    }
    ,
    s.prototype.lazyLoad = function() {
        var t, e, n = this;
        function i(t) {
            c("img[data-lazy]", t).each(function() {
                var t = c(this)
                  , e = c(this).attr("data-lazy")
                  , i = document.createElement("img");
                i.onload = function() {
                    t.animate({
                        opacity: 0
                    }, 100, function() {
                        t.attr("src", e).animate({
                            opacity: 1
                        }, 200, function() {
                            t.removeAttr("data-lazy").removeClass("slick-loading")
                        }),
                        n.$slider.trigger("lazyLoaded", [n, t, e])
                    })
                }
                ,
                i.onerror = function() {
                    t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    n.$slider.trigger("lazyLoadError", [n, t, e])
                }
                ,
                i.src = e
            })
        }
        !0 === n.options.centerMode ? e = !0 === n.options.infinite ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (t = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)),
        n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (t = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide,
        e = Math.ceil(t + n.options.slidesToShow),
        !0 === n.options.fade && (0 < t && t--,
        e <= n.slideCount && e++)),
        i(n.$slider.find(".slick-slide").slice(t, e)),
        n.slideCount <= n.options.slidesToShow ? i(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? i(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && i(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
    }
    ,
    s.prototype.loadSlider = function() {
        var t = this;
        t.setPosition(),
        t.$slideTrack.css({
            opacity: 1
        }),
        t.$slider.removeClass("slick-loading"),
        t.initUI(),
        "progressive" === t.options.lazyLoad && t.progressiveLazyLoad()
    }
    ,
    s.prototype.next = s.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    s.prototype.orientationChange = function() {
        this.checkResponsive(),
        this.setPosition()
    }
    ,
    s.prototype.pause = s.prototype.slickPause = function() {
        this.autoPlayClear(),
        this.paused = !0
    }
    ,
    s.prototype.play = s.prototype.slickPlay = function() {
        var t = this;
        t.autoPlay(),
        t.options.autoplay = !0,
        t.paused = !1,
        t.focussed = !1,
        t.interrupted = !1
    }
    ,
    s.prototype.postSlide = function(t) {
        var e = this;
        e.unslicked || (e.$slider.trigger("afterChange", [e, t]),
        e.animating = !1,
        e.setPosition(),
        e.swipeLeft = null,
        e.options.autoplay && e.autoPlay(),
        !0 === e.options.accessibility && e.initADA())
    }
    ,
    s.prototype.prev = s.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }
    ,
    s.prototype.preventDefault = function(t) {
        t.preventDefault()
    }
    ,
    s.prototype.progressiveLazyLoad = function(t) {
        t = t || 1;
        var e, i, n, o = this, a = c("img[data-lazy]", o.$slider);
        a.length ? (e = a.first(),
        i = e.attr("data-lazy"),
        (n = document.createElement("img")).onload = function() {
            e.attr("src", i).removeAttr("data-lazy").removeClass("slick-loading"),
            !0 === o.options.adaptiveHeight && o.setPosition(),
            o.$slider.trigger("lazyLoaded", [o, e, i]),
            o.progressiveLazyLoad()
        }
        ,
        n.onerror = function() {
            t < 3 ? setTimeout(function() {
                o.progressiveLazyLoad(t + 1)
            }, 500) : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
            o.$slider.trigger("lazyLoadError", [o, e, i]),
            o.progressiveLazyLoad())
        }
        ,
        n.src = i) : o.$slider.trigger("allImagesLoaded", [o])
    }
    ,
    s.prototype.refresh = function(t) {
        var e, i, n = this;
        i = n.slideCount - n.options.slidesToShow,
        !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
        n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
        e = n.currentSlide,
        n.destroy(!0),
        c.extend(n, n.initials, {
            currentSlide: e
        }),
        n.init(),
        t || n.changeSlide({
            data: {
                message: "index",
                index: e
            }
        }, !1)
    }
    ,
    s.prototype.registerBreakpoints = function() {
        var t, e, i, n = this, o = n.options.responsive || null;
        if ("array" === c.type(o) && o.length) {
            for (t in n.respondTo = n.options.respondTo || "window",
            o)
                if (i = n.breakpoints.length - 1,
                e = o[t].breakpoint,
                o.hasOwnProperty(t)) {
                    for (; 0 <= i; )
                        n.breakpoints[i] && n.breakpoints[i] === e && n.breakpoints.splice(i, 1),
                        i--;
                    n.breakpoints.push(e),
                    n.breakpointSettings[e] = o[t].settings
                }
            n.breakpoints.sort(function(t, e) {
                return n.options.mobileFirst ? t - e : e - t
            })
        }
    }
    ,
    s.prototype.reinit = function() {
        var t = this;
        t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"),
        t.slideCount = t.$slides.length,
        t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
        t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
        t.registerBreakpoints(),
        t.setProps(),
        t.setupInfinite(),
        t.buildArrows(),
        t.updateArrows(),
        t.initArrowEvents(),
        t.buildDots(),
        t.updateDots(),
        t.initDotEvents(),
        t.cleanUpSlideEvents(),
        t.initSlideEvents(),
        t.checkResponsive(!1, !0),
        !0 === t.options.focusOnSelect && c(t.$slideTrack).children().on("click.slick", t.selectHandler),
        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
        t.setPosition(),
        t.focusHandler(),
        t.paused = !t.options.autoplay,
        t.autoPlay(),
        t.$slider.trigger("reInit", [t])
    }
    ,
    s.prototype.resize = function() {
        var t = this;
        c(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay),
        t.windowDelay = window.setTimeout(function() {
            t.windowWidth = c(window).width(),
            t.checkResponsive(),
            t.unslicked || t.setPosition()
        }, 50))
    }
    ,
    s.prototype.removeSlide = s.prototype.slickRemove = function(t, e, i) {
        var n = this;
        if (t = "boolean" == typeof t ? !0 === (e = t) ? 0 : n.slideCount - 1 : !0 === e ? --t : t,
        n.slideCount < 1 || t < 0 || t > n.slideCount - 1)
            return !1;
        n.unload(),
        !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(t).remove(),
        n.$slides = n.$slideTrack.children(this.options.slide),
        n.$slideTrack.children(this.options.slide).detach(),
        n.$slideTrack.append(n.$slides),
        n.$slidesCache = n.$slides,
        n.reinit()
    }
    ,
    s.prototype.setCSS = function(t) {
        var e, i, n = this, o = {};
        !0 === n.options.rtl && (t = -t),
        e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px",
        i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px",
        o[n.positionProp] = t,
        !1 === n.transformsEnabled || (!(o = {}) === n.cssTransitions ? o[n.animType] = "translate(" + e + ", " + i + ")" : o[n.animType] = "translate3d(" + e + ", " + i + ", 0px)"),
        n.$slideTrack.css(o)
    }
    ,
    s.prototype.setDimensions = function() {
        var t = this;
        !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
        !0 === t.options.centerMode && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })),
        t.listWidth = t.$list.width(),
        t.listHeight = t.$list.height(),
        !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow),
        t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth),
        t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }
    ,
    s.prototype.setFade = function() {
        var i, n = this;
        n.$slides.each(function(t, e) {
            i = n.slideWidth * t * -1,
            !0 === n.options.rtl ? c(e).css({
                position: "relative",
                right: i,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            }) : c(e).css({
                position: "relative",
                left: i,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            })
        }),
        n.$slides.eq(n.currentSlide).css({
            zIndex: n.options.zIndex - 1,
            opacity: 1
        })
    }
    ,
    s.prototype.setHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.css("height", e)
        }
    }
    ,
    s.prototype.setOption = s.prototype.slickSetOption = function() {
        var t, e, i, n, o, a = this, s = !1;
        if ("object" === c.type(arguments[0]) ? (i = arguments[0],
        s = arguments[1],
        o = "multiple") : "string" === c.type(arguments[0]) && (n = arguments[1],
        s = arguments[2],
        "responsive" === (i = arguments[0]) && "array" === c.type(arguments[1]) ? o = "responsive" : void 0 !== arguments[1] && (o = "single")),
        "single" === o)
            a.options[i] = n;
        else if ("multiple" === o)
            c.each(i, function(t, e) {
                a.options[t] = e
            });
        else if ("responsive" === o)
            for (e in n)
                if ("array" !== c.type(a.options.responsive))
                    a.options.responsive = [n[e]];
                else {
                    for (t = a.options.responsive.length - 1; 0 <= t; )
                        a.options.responsive[t].breakpoint === n[e].breakpoint && a.options.responsive.splice(t, 1),
                        t--;
                    a.options.responsive.push(n[e])
                }
        s && (a.unload(),
        a.reinit())
    }
    ,
    s.prototype.setPosition = function() {
        var t = this;
        t.setDimensions(),
        t.setHeight(),
        !1 === t.options.fade ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(),
        t.$slider.trigger("setPosition", [t])
    }
    ,
    s.prototype.setProps = function() {
        var t = this
          , e = document.body.style;
        t.positionProp = !0 === t.options.vertical ? "top" : "left",
        "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"),
        void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === t.options.useCSS && (t.cssTransitions = !0),
        t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex),
        void 0 !== e.OTransform && (t.animType = "OTransform",
        t.transformType = "-o-transform",
        t.transitionType = "OTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
        void 0 !== e.MozTransform && (t.animType = "MozTransform",
        t.transformType = "-moz-transform",
        t.transitionType = "MozTransition",
        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)),
        void 0 !== e.webkitTransform && (t.animType = "webkitTransform",
        t.transformType = "-webkit-transform",
        t.transitionType = "webkitTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
        void 0 !== e.msTransform && (t.animType = "msTransform",
        t.transformType = "-ms-transform",
        t.transitionType = "msTransition",
        void 0 === e.msTransform && (t.animType = !1)),
        void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform",
        t.transformType = "transform",
        t.transitionType = "transition"),
        t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType
    }
    ,
    s.prototype.setSlideClasses = function(t) {
        var e, i, n, o, a = this;
        i = a.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
        a.$slides.eq(t).addClass("slick-current"),
        !0 === a.options.centerMode ? (e = Math.floor(a.options.slidesToShow / 2),
        !0 === a.options.infinite && (e <= t && t <= a.slideCount - 1 - e ? a.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = a.options.slidesToShow + t,
        i.slice(n - e + 1, n + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
        0 === t ? i.eq(i.length - 1 - a.options.slidesToShow).addClass("slick-center") : t === a.slideCount - 1 && i.eq(a.options.slidesToShow).addClass("slick-center")),
        a.$slides.eq(t).addClass("slick-center")) : 0 <= t && t <= a.slideCount - a.options.slidesToShow ? a.$slides.slice(t, t + a.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= a.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = a.slideCount % a.options.slidesToShow,
        n = !0 === a.options.infinite ? a.options.slidesToShow + t : t,
        a.options.slidesToShow == a.options.slidesToScroll && a.slideCount - t < a.options.slidesToShow ? i.slice(n - (a.options.slidesToShow - o), n + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + a.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
        "ondemand" === a.options.lazyLoad && a.lazyLoad()
    }
    ,
    s.prototype.setupInfinite = function() {
        var t, e, i, n = this;
        if (!0 === n.options.fade && (n.options.centerMode = !1),
        !0 === n.options.infinite && !1 === n.options.fade && (e = null,
        n.slideCount > n.options.slidesToShow)) {
            for (i = !0 === n.options.centerMode ? n.options.slidesToShow + 1 : n.options.slidesToShow,
            t = n.slideCount; t > n.slideCount - i; t -= 1)
                e = t - 1,
                c(n.$slides[e]).clone(!0).attr("id", "").attr("data-slick-index", e - n.slideCount).prependTo(n.$slideTrack).addClass("slick-cloned");
            for (t = 0; t < i; t += 1)
                e = t,
                c(n.$slides[e]).clone(!0).attr("id", "").attr("data-slick-index", e + n.slideCount).appendTo(n.$slideTrack).addClass("slick-cloned");
            n.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                c(this).attr("id", "")
            })
        }
    }
    ,
    s.prototype.interrupt = function(t) {
        t || this.autoPlay(),
        this.interrupted = t
    }
    ,
    s.prototype.selectHandler = function(t) {
        var e = this
          , i = c(t.target).is(".slick-slide") ? c(t.target) : c(t.target).parents(".slick-slide")
          , n = parseInt(i.attr("data-slick-index"));
        if (n = n || 0,
        e.slideCount <= e.options.slidesToShow)
            return e.setSlideClasses(n),
            void e.asNavFor(n);
        e.slideHandler(n)
    }
    ,
    s.prototype.slideHandler = function(t, e, i) {
        var n, o, a, s, r, l, c = this;
        if (e = e || !1,
        (!0 !== c.animating || !0 !== c.options.waitForAnimate) && !(!0 === c.options.fade && c.currentSlide === t || c.slideCount <= c.options.slidesToShow))
            if (!1 === e && c.asNavFor(t),
            n = t,
            r = c.getLeft(n),
            s = c.getLeft(c.currentSlide),
            c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft,
            !1 === c.options.infinite && !1 === c.options.centerMode && (t < 0 || t > c.getDotCount() * c.options.slidesToScroll))
                !1 === c.options.fade && (n = c.currentSlide,
                !0 !== i ? c.animateSlide(s, function() {
                    c.postSlide(n)
                }) : c.postSlide(n));
            else if (!1 === c.options.infinite && !0 === c.options.centerMode && (t < 0 || t > c.slideCount - c.options.slidesToScroll))
                !1 === c.options.fade && (n = c.currentSlide,
                !0 !== i ? c.animateSlide(s, function() {
                    c.postSlide(n)
                }) : c.postSlide(n));
            else {
                if (c.options.autoplay && clearInterval(c.autoPlayTimer),
                o = n < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + n : n >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : n - c.slideCount : n,
                c.animating = !0,
                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                a = c.currentSlide,
                c.currentSlide = o,
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor && (l = (l = c.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(c.currentSlide),
                c.updateDots(),
                c.updateArrows(),
                !0 === c.options.fade)
                    return !0 !== i ? (c.fadeSlideOut(a),
                    c.fadeSlide(o, function() {
                        c.postSlide(o)
                    })) : c.postSlide(o),
                    void c.animateHeight();
                !0 !== i ? c.animateSlide(r, function() {
                    c.postSlide(o)
                }) : c.postSlide(o)
            }
    }
    ,
    s.prototype.startLoad = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(),
        t.$nextArrow.hide()),
        !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(),
        t.$slider.addClass("slick-loading")
    }
    ,
    s.prototype.swipeDirection = function() {
        var t, e, i, n, o = this;
        return t = o.touchObject.startX - o.touchObject.curX,
        e = o.touchObject.startY - o.touchObject.curY,
        i = Math.atan2(e, t),
        (n = Math.round(180 * i / Math.PI)) < 0 && (n = 360 - Math.abs(n)),
        n <= 45 && 0 <= n ? !1 === o.options.rtl ? "left" : "right" : n <= 360 && 315 <= n ? !1 === o.options.rtl ? "left" : "right" : 135 <= n && n <= 225 ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? 35 <= n && n <= 135 ? "down" : "up" : "vertical"
    }
    ,
    s.prototype.swipeEnd = function(t) {
        var e, i, n = this;
        if (n.dragging = !1,
        n.interrupted = !1,
        n.shouldClick = !(10 < n.touchObject.swipeLength),
        void 0 === n.touchObject.curX)
            return !1;
        if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]),
        n.touchObject.swipeLength >= n.touchObject.minSwipe) {
            switch (i = n.swipeDirection()) {
            case "left":
            case "down":
                e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(),
                n.currentDirection = 0;
                break;
            case "right":
            case "up":
                e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(),
                n.currentDirection = 1
            }
            "vertical" != i && (n.slideHandler(e),
            n.touchObject = {},
            n.$slider.trigger("swipe", [n, i]))
        } else
            n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide),
            n.touchObject = {})
    }
    ,
    s.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend"in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse")))
            switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1,
            e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
            !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
            t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
            }
    }
    ,
    s.prototype.swipeMove = function(t) {
        var e, i, n, o, a, s = this;
        return a = void 0 !== t.originalEvent ? t.originalEvent.touches : null,
        !(!s.dragging || a && 1 !== a.length) && (e = s.getLeft(s.currentSlide),
        s.touchObject.curX = void 0 !== a ? a[0].pageX : t.clientX,
        s.touchObject.curY = void 0 !== a ? a[0].pageY : t.clientY,
        s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))),
        !0 === s.options.verticalSwiping && (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2)))),
        "vertical" !== (i = s.swipeDirection()) ? (void 0 !== t.originalEvent && 4 < s.touchObject.swipeLength && t.preventDefault(),
        o = (!1 === s.options.rtl ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1),
        !0 === s.options.verticalSwiping && (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
        n = s.touchObject.swipeLength,
        (s.touchObject.edgeHit = !1) === s.options.infinite && (0 === s.currentSlide && "right" === i || s.currentSlide >= s.getDotCount() && "left" === i) && (n = s.touchObject.swipeLength * s.options.edgeFriction,
        s.touchObject.edgeHit = !0),
        !1 === s.options.vertical ? s.swipeLeft = e + n * o : s.swipeLeft = e + n * (s.$list.height() / s.listWidth) * o,
        !0 === s.options.verticalSwiping && (s.swipeLeft = e + n * o),
        !0 !== s.options.fade && !1 !== s.options.touchMove && (!0 === s.animating ? (s.swipeLeft = null,
        !1) : void s.setCSS(s.swipeLeft))) : void 0)
    }
    ,
    s.prototype.swipeStart = function(t) {
        var e, i = this;
        if (i.interrupted = !0,
        1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow)
            return !(i.touchObject = {});
        void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]),
        i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX,
        i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY,
        i.dragging = !0
    }
    ,
    s.prototype.unfilterSlides = s.prototype.slickUnfilter = function() {
        var t = this;
        null !== t.$slidesCache && (t.unload(),
        t.$slideTrack.children(this.options.slide).detach(),
        t.$slidesCache.appendTo(t.$slideTrack),
        t.reinit())
    }
    ,
    s.prototype.unload = function() {
        var t = this;
        c(".slick-cloned", t.$slider).remove(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
        t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
        t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }
    ,
    s.prototype.unslick = function(t) {
        this.$slider.trigger("unslick", [this, t]),
        this.destroy()
    }
    ,
    s.prototype.updateArrows = function() {
        var t = this;
        Math.floor(t.options.slidesToShow / 2),
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && !t.options.infinite && (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        0 === t.currentSlide ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - t.options.slidesToShow && !1 === t.options.centerMode ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - 1 && !0 === t.options.centerMode && (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }
    ,
    s.prototype.updateDots = function() {
        var t = this;
        null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
        t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }
    ,
    s.prototype.visibility = function() {
        this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
    }
    ,
    c.fn.slick = function() {
        var t, e, i = this, n = arguments[0], o = Array.prototype.slice.call(arguments, 1), a = i.length;
        for (t = 0; t < a; t++)
            if ("object" == typeof n || void 0 === n ? i[t].slick = new s(i[t],n) : e = i[t].slick[n].apply(i[t].slick, o),
            void 0 !== e)
                return e;
        return i
    }
}),
function(ct) {
    "use strict";
    var C, x, k, S, E, A, ut, T, D, P, F, I, O, N, M, dt, B, R, L, $, _, j, U, H, z, G, V, W, q, Y, Q, X, Z, K, J, tt, et, it, nt, ot, at;
    ct.fn.extend({
        venobox: function(t) {
            var b = this
              , w = ct.extend({
                arrowsColor: "#B6B6B6",
                autoplay: !1,
                bgcolor: "#fff",
                border: "0",
                closeBackground: "#161617",
                closeColor: "#d2d2d2",
                framewidth: "",
                frameheight: "",
                gallItems: !1,
                infinigall: !1,
                htmlClose: "&times;",
                htmlNext: "<span>Next</span>",
                htmlPrev: "<span>Prev</span>",
                numeratio: !1,
                numerationBackground: "#161617",
                numerationColor: "#d2d2d2",
                numerationPosition: "top",
                overlayClose: !0,
                overlayColor: "rgba(23,23,23,0.85)",
                spinner: "double-bounce",
                spinColor: "#d2d2d2",
                titleattr: "title",
                titleBackground: "#161617",
                titleColor: "#d2d2d2",
                titlePosition: "top",
                cb_pre_open: function() {
                    return !0
                },
                cb_post_open: function() {},
                cb_pre_close: function() {
                    return !0
                },
                cb_post_close: function() {},
                cb_post_resize: function() {},
                cb_after_nav: function() {},
                cb_init: function() {}
            }, t);
            return w.cb_init(b),
            this.each(function() {
                if ((q = ct(this)).data("venobox"))
                    return !0;
                function e() {
                    _ = q.data("gall"),
                    B = q.data("numeratio"),
                    I = q.data("gallItems"),
                    O = q.data("infinigall"),
                    N = I || ct('.vbox-item[data-gall="' + _ + '"]'),
                    j = N.eq(N.index(q) + 1),
                    U = N.eq(N.index(q) - 1),
                    j.length || !0 !== O || (j = N.eq(0)),
                    1 < N.length ? (Y = N.index(q) + 1,
                    k.html(Y + " / " + N.length)) : Y = 1,
                    !0 === B ? k.show() : k.hide(),
                    "" !== $ ? S.show() : S.hide(),
                    H = j.length || !0 === O ? (ct(".vbox-next").css("display", "block"),
                    !0) : (ct(".vbox-next").css("display", "none"),
                    !1),
                    !0 !== (z = 0 < N.index(q) || !0 === O ? (ct(".vbox-prev").css("display", "block"),
                    !0) : (ct(".vbox-prev").css("display", "none"),
                    !1)) && !0 !== H || (ut.on(u.DOWN, a),
                    ut.on(u.MOVE, s),
                    ut.on(u.UP, r))
                }
                function n(t) {
                    return !(t.length < 1) && (!M && (M = !0,
                    R = t.data("overlay") || t.data("overlaycolor"),
                    P = t.data("framewidth"),
                    F = t.data("frameheight"),
                    E = t.data("border"),
                    x = t.data("bgcolor"),
                    T = t.data("href") || t.attr("href"),
                    C = t.data("autoplay"),
                    $ = t.attr(t.data("titleattr")) || "",
                    t === U && ut.addClass("animated").addClass("swipe-right"),
                    t === j && ut.addClass("animated").addClass("swipe-left"),
                    V.show(),
                    void ut.animate({
                        opacity: 0
                    }, 500, function() {
                        L.css("background", R),
                        ut.removeClass("animated").removeClass("swipe-left").removeClass("swipe-right").css({
                            "margin-left": 0,
                            "margin-right": 0
                        }),
                        "iframe" == t.data("vbtype") ? f() : "inline" == t.data("vbtype") ? g() : "ajax" == t.data("vbtype") ? p() : "video" == t.data("vbtype") ? h(C) : (ut.html('<img src="' + T + '">'),
                        m()),
                        q = t,
                        e(),
                        M = !1,
                        w.cb_after_nav(q, Y, j, U)
                    })))
                }
                function i(t) {
                    27 === t.keyCode && o(),
                    37 == t.keyCode && !0 === z && n(U),
                    39 == t.keyCode && !0 === H && n(j)
                }
                function o() {
                    if (!1 === w.cb_pre_close(q, Y, j, U))
                        return !1;
                    ct("body").off("keydown", i).removeClass("vbox-open"),
                    q.focus(),
                    L.animate({
                        opacity: 0
                    }, 500, function() {
                        L.remove(),
                        M = !1,
                        w.cb_post_close()
                    })
                }
                b.VBclose = function() {
                    o()
                }
                ,
                q.addClass("vbox-item"),
                q.data("framewidth", w.framewidth),
                q.data("frameheight", w.frameheight),
                q.data("border", w.border),
                q.data("bgcolor", w.bgcolor),
                q.data("numeratio", w.numeratio),
                q.data("gallItems", w.gallItems),
                q.data("infinigall", w.infinigall),
                q.data("overlaycolor", w.overlayColor),
                q.data("titleattr", w.titleattr),
                q.data("venobox", !0),
                q.on("click", function(t) {
                    if (t.preventDefault(),
                    q = ct(this),
                    !1 === w.cb_pre_open(q))
                        return !1;
                    switch (b.VBnext = function() {
                        n(j)
                    }
                    ,
                    b.VBprev = function() {
                        n(U)
                    }
                    ,
                    R = q.data("overlay") || q.data("overlaycolor"),
                    P = q.data("framewidth"),
                    F = q.data("frameheight"),
                    C = q.data("autoplay") || w.autoplay,
                    E = q.data("border"),
                    x = q.data("bgcolor"),
                    M = z = H = !1,
                    T = q.data("href") || q.attr("href"),
                    D = q.data("css") || "",
                    $ = q.attr(q.data("titleattr")) || "",
                    G = '<div class="vbox-preloader">',
                    w.spinner) {
                    case "rotating-plane":
                        G += '<div class="sk-rotating-plane"></div>';
                        break;
                    case "double-bounce":
                        G += '<div class="sk-double-bounce"><div class="sk-child sk-double-bounce1"></div><div class="sk-child sk-double-bounce2"></div></div>';
                        break;
                    case "wave":
                        G += '<div class="sk-wave"><div class="sk-rect sk-rect1"></div><div class="sk-rect sk-rect2"></div><div class="sk-rect sk-rect3"></div><div class="sk-rect sk-rect4"></div><div class="sk-rect sk-rect5"></div></div>';
                        break;
                    case "wandering-cubes":
                        G += '<div class="sk-wandering-cubes"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div></div>';
                        break;
                    case "spinner-pulse":
                        G += '<div class="sk-spinner sk-spinner-pulse"></div>';
                        break;
                    case "chasing-dots":
                        G += '<div class="sk-chasing-dots"><div class="sk-child sk-dot1"></div><div class="sk-child sk-dot2"></div></div>';
                        break;
                    case "three-bounce":
                        G += '<div class="sk-three-bounce"><div class="sk-child sk-bounce1"></div><div class="sk-child sk-bounce2"></div><div class="sk-child sk-bounce3"></div></div>';
                        break;
                    case "circle":
                        G += '<div class="sk-circle"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div>';
                        break;
                    case "cube-grid":
                        G += '<div class="sk-cube-grid"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div><div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>';
                        break;
                    case "fading-circle":
                        G += '<div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div>';
                        break;
                    case "folding-cube":
                        G += '<div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div>'
                    }
                    return G += "</div>",
                    W = '<a class="vbox-next">' + w.htmlNext + '</a><a class="vbox-prev">' + w.htmlPrev + "</a>",
                    X = '<div class="vbox-title"></div><div class="vbox-num">0/0</div><div class="vbox-close">' + w.htmlClose + "</div>",
                    A = '<div class="vbox-overlay ' + D + '" style="background:' + R + '">' + G + '<div class="vbox-container"><div class="vbox-content"></div></div>' + X + W + "</div>",
                    ct("body").append(A).addClass("vbox-open"),
                    ct(".vbox-preloader div:not(.sk-circle) .sk-child, .vbox-preloader .sk-rotating-plane, .vbox-preloader .sk-rect, .vbox-preloader div:not(.sk-folding-cube) .sk-cube, .vbox-preloader .sk-spinner-pulse").css("background-color", w.spinColor),
                    L = ct(".vbox-overlay"),
                    ct(".vbox-container"),
                    ut = ct(".vbox-content"),
                    k = ct(".vbox-num"),
                    S = ct(".vbox-title"),
                    (V = ct(".vbox-preloader")).show(),
                    S.css(w.titlePosition, "-1px"),
                    S.css({
                        color: w.titleColor,
                        "background-color": w.titleBackground
                    }),
                    ct(".vbox-close").css({
                        color: w.closeColor,
                        "background-color": w.closeBackground
                    }),
                    ct(".vbox-num").css(w.numerationPosition, "-1px"),
                    ct(".vbox-num").css({
                        color: w.numerationColor,
                        "background-color": w.numerationBackground
                    }),
                    ct(".vbox-next span, .vbox-prev span").css({
                        "border-top-color": w.arrowsColor,
                        "border-right-color": w.arrowsColor
                    }),
                    ut.html(""),
                    ut.css("opacity", "0"),
                    L.css("opacity", "0"),
                    e(),
                    L.animate({
                        opacity: 1
                    }, 250, function() {
                        "iframe" == q.data("vbtype") ? f() : "inline" == q.data("vbtype") ? g() : "ajax" == q.data("vbtype") ? p() : "video" == q.data("vbtype") ? h(C) : (ut.html('<img src="' + T + '">'),
                        m()),
                        w.cb_post_open(q, Y, j, U)
                    }),
                    ct("body").keydown(i),
                    ct(".vbox-prev").on("click", function() {
                        n(U)
                    }),
                    ct(".vbox-next").on("click", function() {
                        n(j)
                    }),
                    !1
                });
                var t = ".vbox-overlay";
                function a(t) {
                    ut.addClass("animated"),
                    K = tt = t.pageY,
                    J = et = t.pageX,
                    Q = !0
                }
                function s(t) {
                    if (!0 === Q) {
                        et = t.pageX,
                        tt = t.pageY,
                        nt = et - J,
                        ot = tt - K;
                        var e = Math.abs(nt);
                        Math.abs(ot) < e && e <= 100 && (t.preventDefault(),
                        ut.css("margin-left", nt))
                    }
                }
                function r(t) {
                    if (!0 === Q) {
                        var e = q
                          , i = Q = !1;
                        (it = et - J) < 0 && !0 === H && (e = j,
                        i = !0),
                        0 < it && !0 === z && (e = U,
                        i = !0),
                        Math.abs(it) >= at && !0 === i ? n(e) : ut.css({
                            "margin-left": 0,
                            "margin-right": 0
                        })
                    }
                }
                w.overlayClose || (t = ".vbox-close"),
                ct("body").on("click", t, function(t) {
                    (ct(t.target).is(".vbox-overlay") || ct(t.target).is(".vbox-content") || ct(t.target).is(".vbox-close") || ct(t.target).is(".vbox-preloader")) && o()
                }),
                it = et = J = 0,
                Q = !(at = 50);
                function l(t) {
                    var e;
                    switch (t.type) {
                    case "mousedown":
                        e = u.DOWN;
                        break;
                    case "mouseup":
                    case "mouseout":
                        e = u.UP;
                        break;
                    case "mousemove":
                        e = u.MOVE;
                        break;
                    default:
                        return
                    }
                    var i = d(e, t, t.pageX, t.pageY);
                    ct(t.target).trigger(i)
                }
                function c(t) {
                    var e;
                    switch (t.type) {
                    case "touchstart":
                        e = u.DOWN;
                        break;
                    case "touchend":
                        e = u.UP;
                        break;
                    case "touchmove":
                        e = u.MOVE;
                        break;
                    default:
                        return
                    }
                    var i, n = t.originalEvent.touches[0];
                    i = e == u.UP ? d(e, t, null, null) : d(e, t, n.pageX, n.pageY),
                    ct(t.target).trigger(i)
                }
                var u = {
                    DOWN: "touchmousedown",
                    UP: "touchmouseup",
                    MOVE: "touchmousemove"
                }
                  , d = function(t, e, i, n) {
                    return ct.Event(t, {
                        pageX: i,
                        pageY: n,
                        originalEvent: e
                    })
                };
                function p() {
                    ct.ajax({
                        url: T,
                        cache: !1
                    }).done(function(t) {
                        ut.html('<div class="vbox-inline">' + t + "</div>"),
                        m()
                    }).fail(function() {
                        ut.html('<div class="vbox-inline"><p>Error retrieving contents, please retry</div>'),
                        v()
                    })
                }
                function f() {
                    ut.html('<iframe class="venoframe" src="' + T + '"></iframe>'),
                    v()
                }
                function h(t) {
                    var e, i = function(t) {
                        var e;
                        t.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),
                        -1 < RegExp.$3.indexOf("youtu") ? e = "youtube" : -1 < RegExp.$3.indexOf("vimeo") && (e = "vimeo");
                        return {
                            type: e,
                            id: RegExp.$6
                        }
                    }(T), n = (t ? "?rel=0&autoplay=1" : "?rel=0") + function(t) {
                        var e = ""
                          , i = decodeURIComponent(t).split("?");
                        if (void 0 !== i[1]) {
                            var n, o, a = i[1].split("&");
                            for (o = 0; o < a.length; o++)
                                n = a[o].split("="),
                                e = e + "&" + n[0] + "=" + n[1]
                        }
                        return encodeURI(e)
                    }(T);
                    "vimeo" == i.type ? e = "https://player.vimeo.com/video/" : "youtube" == i.type && (e = "https://www.youtube.com/embed/"),
                    ut.html('<iframe class="venoframe vbvid" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" src="' + e + i.id + n + '"></iframe>'),
                    v()
                }
                function g() {
                    ut.html('<div class="vbox-inline">' + ct(T).html() + "</div>"),
                    v()
                }
                function m() {
                    (Z = ut.find("img")).length ? Z.each(function() {
                        ct(this).one("load", function() {
                            v()
                        })
                    }) : v()
                }
                function v() {
                    S.html($),
                    ut.find(">:first-child").addClass("figlio").css({
                        width: P,
                        height: F,
                        padding: E,
                        background: x
                    }),
                    ct("img.figlio").on("dragstart", function(t) {
                        t.preventDefault()
                    }),
                    y(),
                    ut.animate({
                        opacity: "1"
                    }, "slow", function() {
                        V.hide()
                    })
                }
                function y() {
                    var C, x, k, S, E, A, T, D, P, F, I, O, N, M, B, R, L, $, _, j, U, H, z, G, V, W, q, Y, Q, X, Z, K, J, tt, et, it, nt, ot, at, st, rt, lt, t = ut.outerHeight(), e = ct(window).height();
                    dt = t + 60 < e ? (e - t) / 2 : "30px",
                    ut.css("margin-top", dt),
                    (C = jQuery).fn.extend({
                        venobox: function(t) {
                            var b = this
                              , w = C.extend({
                                arrowsColor: "#B6B6B6",
                                autoplay: !1,
                                bgcolor: "#fff",
                                border: "0",
                                closeBackground: "#161617",
                                closeColor: "#d2d2d2",
                                framewidth: "",
                                frameheight: "",
                                gallItems: !1,
                                infinigall: !1,
                                htmlClose: "&times;",
                                htmlNext: "<span>Next</span>",
                                htmlPrev: "<span>Prev</span>",
                                numeratio: !1,
                                numerationBackground: "#161617",
                                numerationColor: "#d2d2d2",
                                numerationPosition: "top",
                                overlayClose: !0,
                                overlayColor: "rgba(23,23,23,0.85)",
                                spinner: "double-bounce",
                                spinColor: "#d2d2d2",
                                titleattr: "title",
                                titleBackground: "#161617",
                                titleColor: "#d2d2d2",
                                titlePosition: "top",
                                cb_pre_open: function() {
                                    return !0
                                },
                                cb_post_open: function() {},
                                cb_pre_close: function() {
                                    return !0
                                },
                                cb_post_close: function() {},
                                cb_post_resize: function() {},
                                cb_after_nav: function() {},
                                cb_init: function() {}
                            }, t);
                            return w.cb_init(b),
                            this.each(function() {
                                if ((X = C(this)).data("venobox"))
                                    return !0;
                                function e() {
                                    H = X.data("gall"),
                                    $ = X.data("numeratio"),
                                    N = X.data("gallItems"),
                                    M = X.data("infinigall"),
                                    B = N || C('.vbox-item[data-gall="' + H + '"]'),
                                    z = B.eq(B.index(X) + 1),
                                    G = B.eq(B.index(X) - 1),
                                    z.length || !0 !== M || (z = B.eq(0)),
                                    1 < B.length ? (Z = B.index(X) + 1,
                                    S.html(Z + " / " + B.length)) : Z = 1,
                                    !0 === $ ? S.show() : S.hide(),
                                    "" !== U ? E.show() : E.hide(),
                                    V = z.length || !0 === M ? (C(".vbox-next").css("display", "block"),
                                    !0) : (C(".vbox-next").css("display", "none"),
                                    !1),
                                    !0 != (W = 0 < B.index(X) || !0 === M ? (C(".vbox-prev").css("display", "block"),
                                    !0) : (C(".vbox-prev").css("display", "none"),
                                    !1)) && !0 !== V || (D.on(u.DOWN, a),
                                    D.on(u.MOVE, s),
                                    D.on(u.UP, r))
                                }
                                function n(t) {
                                    return !(t.length < 1) && !R && (R = !0,
                                    _ = t.data("overlay") || t.data("overlaycolor"),
                                    I = t.data("framewidth"),
                                    O = t.data("frameheight"),
                                    A = t.data("border"),
                                    k = t.data("bgcolor"),
                                    P = t.data("href") || t.attr("href"),
                                    x = t.data("autoplay"),
                                    U = t.attr(t.data("titleattr")) || "",
                                    t === G && D.addClass("animated").addClass("swipe-right"),
                                    t === z && D.addClass("animated").addClass("swipe-left"),
                                    Y.show(),
                                    void D.animate({
                                        opacity: 0
                                    }, 500, function() {
                                        j.css("background", _),
                                        D.removeClass("animated").removeClass("swipe-left").removeClass("swipe-right").css({
                                            "margin-left": 0,
                                            "margin-right": 0
                                        }),
                                        "iframe" == t.data("vbtype") ? f() : "inline" == t.data("vbtype") ? g() : "ajax" == t.data("vbtype") ? p() : "video" == t.data("vbtype") ? h(x) : (D.html('<img src="' + P + '">'),
                                        m()),
                                        X = t,
                                        e(),
                                        R = !1,
                                        w.cb_after_nav(X, Z, z, G)
                                    }))
                                }
                                function i(t) {
                                    27 === t.keyCode && o(),
                                    37 == t.keyCode && !0 === W && n(G),
                                    39 == t.keyCode && !0 === V && n(z)
                                }
                                function o() {
                                    if (!1 === w.cb_pre_close(X, Z, z, G))
                                        return !1;
                                    C("body").off("keydown", i).removeClass("vbox-open"),
                                    X.focus(),
                                    j.animate({
                                        opacity: 0
                                    }, 500, function() {
                                        j.remove(),
                                        R = !1,
                                        w.cb_post_close()
                                    })
                                }
                                b.VBclose = function() {
                                    o()
                                }
                                ,
                                X.addClass("vbox-item"),
                                X.data("framewidth", w.framewidth),
                                X.data("frameheight", w.frameheight),
                                X.data("border", w.border),
                                X.data("bgcolor", w.bgcolor),
                                X.data("numeratio", w.numeratio),
                                X.data("gallItems", w.gallItems),
                                X.data("infinigall", w.infinigall),
                                X.data("overlaycolor", w.overlayColor),
                                X.data("titleattr", w.titleattr),
                                X.data("venobox", !0),
                                X.on("click", function(t) {
                                    if (t.preventDefault(),
                                    X = C(this),
                                    !1 === w.cb_pre_open(X))
                                        return !1;
                                    switch (b.VBnext = function() {
                                        n(z)
                                    }
                                    ,
                                    b.VBprev = function() {
                                        n(G)
                                    }
                                    ,
                                    _ = X.data("overlay") || X.data("overlaycolor"),
                                    I = X.data("framewidth"),
                                    O = X.data("frameheight"),
                                    x = X.data("autoplay") || w.autoplay,
                                    A = X.data("border"),
                                    k = X.data("bgcolor"),
                                    R = W = V = !1,
                                    P = X.data("href") || X.attr("href"),
                                    F = X.data("css") || "",
                                    U = X.attr(X.data("titleattr")) || "",
                                    q = '<div class="vbox-preloader">',
                                    w.spinner) {
                                    case "rotating-plane":
                                        q += '<div class="sk-rotating-plane"></div>';
                                        break;
                                    case "double-bounce":
                                        q += '<div class="sk-double-bounce"><div class="sk-child sk-double-bounce1"></div><div class="sk-child sk-double-bounce2"></div></div>';
                                        break;
                                    case "wave":
                                        q += '<div class="sk-wave"><div class="sk-rect sk-rect1"></div><div class="sk-rect sk-rect2"></div><div class="sk-rect sk-rect3"></div><div class="sk-rect sk-rect4"></div><div class="sk-rect sk-rect5"></div></div>';
                                        break;
                                    case "wandering-cubes":
                                        q += '<div class="sk-wandering-cubes"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div></div>';
                                        break;
                                    case "spinner-pulse":
                                        q += '<div class="sk-spinner sk-spinner-pulse"></div>';
                                        break;
                                    case "chasing-dots":
                                        q += '<div class="sk-chasing-dots"><div class="sk-child sk-dot1"></div><div class="sk-child sk-dot2"></div></div>';
                                        break;
                                    case "three-bounce":
                                        q += '<div class="sk-three-bounce"><div class="sk-child sk-bounce1"></div><div class="sk-child sk-bounce2"></div><div class="sk-child sk-bounce3"></div></div>';
                                        break;
                                    case "circle":
                                        q += '<div class="sk-circle"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div>';
                                        break;
                                    case "cube-grid":
                                        q += '<div class="sk-cube-grid"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div><div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>';
                                        break;
                                    case "fading-circle":
                                        q += '<div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div>';
                                        break;
                                    case "folding-cube":
                                        q += '<div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div>'
                                    }
                                    return q += "</div>",
                                    Q = '<a class="vbox-next">' + w.htmlNext + '</a><a class="vbox-prev">' + w.htmlPrev + "</a>",
                                    J = '<div class="vbox-title"></div><div class="vbox-num">0/0</div><div class="vbox-close">' + w.htmlClose + "</div>",
                                    T = '<div class="vbox-overlay ' + F + '" style="background:' + _ + '">' + q + '<div class="vbox-container"><div class="vbox-content"></div></div>' + J + Q + "</div>",
                                    C("body").append(T).addClass("vbox-open"),
                                    C(".vbox-preloader div:not(.sk-circle) .sk-child, .vbox-preloader .sk-rotating-plane, .vbox-preloader .sk-rect, .vbox-preloader div:not(.sk-folding-cube) .sk-cube, .vbox-preloader .sk-spinner-pulse").css("background-color", w.spinColor),
                                    j = C(".vbox-overlay"),
                                    C(".vbox-container"),
                                    D = C(".vbox-content"),
                                    S = C(".vbox-num"),
                                    E = C(".vbox-title"),
                                    (Y = C(".vbox-preloader")).show(),
                                    E.css(w.titlePosition, "-1px"),
                                    E.css({
                                        color: w.titleColor,
                                        "background-color": w.titleBackground
                                    }),
                                    C(".vbox-close").css({
                                        color: w.closeColor,
                                        "background-color": w.closeBackground
                                    }),
                                    C(".vbox-num").css(w.numerationPosition, "-1px"),
                                    C(".vbox-num").css({
                                        color: w.numerationColor,
                                        "background-color": w.numerationBackground
                                    }),
                                    C(".vbox-next span, .vbox-prev span").css({
                                        "border-top-color": w.arrowsColor,
                                        "border-right-color": w.arrowsColor
                                    }),
                                    D.html(""),
                                    D.css("opacity", "0"),
                                    j.css("opacity", "0"),
                                    e(),
                                    j.animate({
                                        opacity: 1
                                    }, 250, function() {
                                        "iframe" == X.data("vbtype") ? f() : "inline" == X.data("vbtype") ? g() : "ajax" == X.data("vbtype") ? p() : "video" == X.data("vbtype") ? h(x) : (D.html('<img src="' + P + '">'),
                                        m()),
                                        w.cb_post_open(X, Z, z, G)
                                    }),
                                    C("body").keydown(i),
                                    C(".vbox-prev").on("click", function() {
                                        n(G)
                                    }),
                                    C(".vbox-next").on("click", function() {
                                        n(z)
                                    }),
                                    !1
                                });
                                var t = ".vbox-overlay";
                                function a(t) {
                                    D.addClass("animated"),
                                    et = nt = t.pageY,
                                    it = ot = t.pageX,
                                    K = !0
                                }
                                function s(t) {
                                    if (!0 === K) {
                                        ot = t.pageX,
                                        nt = t.pageY,
                                        st = ot - it,
                                        rt = nt - et;
                                        var e = Math.abs(st);
                                        Math.abs(rt) < e && e <= 100 && (t.preventDefault(),
                                        D.css("margin-left", st))
                                    }
                                }
                                function r(t) {
                                    if (!0 === K) {
                                        var e = X
                                          , i = K = !1;
                                        (at = ot - it) < 0 && !0 === V && (e = z,
                                        i = !0),
                                        0 < at && !0 === W && (e = G,
                                        i = !0),
                                        Math.abs(at) >= lt && !0 === i ? n(e) : D.css({
                                            "margin-left": 0,
                                            "margin-right": 0
                                        })
                                    }
                                }
                                function l(t) {
                                    var e;
                                    switch (t.type) {
                                    case "mousedown":
                                        e = u.DOWN;
                                        break;
                                    case "mouseup":
                                    case "mouseout":
                                        e = u.UP;
                                        break;
                                    case "mousemove":
                                        e = u.MOVE;
                                        break;
                                    default:
                                        return
                                    }
                                    var i = d(e, t, t.pageX, t.pageY);
                                    C(t.target).trigger(i)
                                }
                                function c(t) {
                                    var e;
                                    switch (t.type) {
                                    case "touchstart":
                                        e = u.DOWN;
                                        break;
                                    case "touchend":
                                        e = u.UP;
                                        break;
                                    case "touchmove":
                                        e = u.MOVE;
                                        break;
                                    default:
                                        return
                                    }
                                    var i, n = t.originalEvent.touches[0];
                                    i = e == u.UP ? d(e, t, null, null) : d(e, t, n.pageX, n.pageY),
                                    C(t.target).trigger(i)
                                }
                                w.overlayClose || (t = ".vbox-close"),
                                C("body").on("click", t, function(t) {
                                    (C(t.target).is(".vbox-overlay") || C(t.target).is(".vbox-content") || C(t.target).is(".vbox-close") || C(t.target).is(".vbox-preloader")) && o()
                                }),
                                at = ot = it = 0,
                                K = !(lt = 50);
                                var u = {
                                    DOWN: "touchmousedown",
                                    UP: "touchmouseup",
                                    MOVE: "touchmousemove"
                                }
                                  , d = function(t, e, i, n) {
                                    return C.Event(t, {
                                        pageX: i,
                                        pageY: n,
                                        originalEvent: e
                                    })
                                };
                                function p() {
                                    C.ajax({
                                        url: P,
                                        cache: !1
                                    }).done(function(t) {
                                        D.html('<div class="vbox-inline">' + t + "</div>"),
                                        m()
                                    }).fail(function() {
                                        D.html('<div class="vbox-inline"><p>Error retrieving contents, please retry</div>'),
                                        v()
                                    })
                                }
                                function f() {
                                    D.html('<iframe class="venoframe" src="' + P + '"></iframe>'),
                                    v()
                                }
                                function h(t) {
                                    var e, i = function(t) {
                                        var e;
                                        return t.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),
                                        -1 < RegExp.$3.indexOf("youtu") ? e = "youtube" : -1 < RegExp.$3.indexOf("vimeo") && (e = "vimeo"),
                                        {
                                            type: e,
                                            id: RegExp.$6
                                        }
                                    }(P), n = (t ? "?rel=0&autoplay=1" : "?rel=0") + function(t) {
                                        var e = ""
                                          , i = decodeURIComponent(t).split("?");
                                        if (void 0 !== i[1]) {
                                            var n, o, a = i[1].split("&");
                                            for (o = 0; o < a.length; o++)
                                                n = a[o].split("="),
                                                e = e + "&" + n[0] + "=" + n[1]
                                        }
                                        return encodeURI(e)
                                    }(P);
                                    "vimeo" == i.type ? e = "https://player.vimeo.com/video/" : "youtube" == i.type && (e = "https://www.youtube.com/embed/"),
                                    D.html('<iframe class="venoframe vbvid" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" src="' + e + i.id + n + '"></iframe>'),
                                    v()
                                }
                                function g() {
                                    D.html('<div class="vbox-inline">' + C(P).html() + "</div>"),
                                    v()
                                }
                                function m() {
                                    (tt = D.find("img")).length ? tt.each(function() {
                                        C(this).one("load", function() {
                                            v()
                                        })
                                    }) : v()
                                }
                                function v() {
                                    E.html(U),
                                    D.find(">:first-child").addClass("figlio").css({
                                        width: I,
                                        height: O,
                                        padding: A,
                                        background: k
                                    }),
                                    C("img.figlio").on("dragstart", function(t) {
                                        t.preventDefault()
                                    }),
                                    y(),
                                    D.animate({
                                        opacity: "1"
                                    }, "slow", function() {
                                        Y.hide()
                                    })
                                }
                                function y() {
                                    var t = D.outerHeight()
                                      , e = C(window).height();
                                    L = t + 60 < e ? (e - t) / 2 : "30px",
                                    D.css("margin-top", L),
                                    D.css("margin-bottom", L),
                                    w.cb_post_resize()
                                }
                                "ontouchstart"in window ? (C(document).on("touchstart", c),
                                C(document).on("touchmove", c),
                                C(document).on("touchend", c)) : (C(document).on("mousedown", l),
                                C(document).on("mouseup", l),
                                C(document).on("mouseout", l),
                                C(document).on("mousemove", l)),
                                C(window).resize(function() {
                                    C(".vbox-content").length && setTimeout(y(), 800)
                                })
                            })
                        }
                    }),
                    ut.css("margin-bottom", dt),
                    w.cb_post_resize()
                }
                "ontouchstart"in window ? (ct(document).on("touchstart", c),
                ct(document).on("touchmove", c),
                ct(document).on("touchend", c)) : (ct(document).on("mousedown", l),
                ct(document).on("mouseup", l),
                ct(document).on("mouseout", l),
                ct(document).on("mousemove", l)),
                ct(window).resize(function() {
                    ct(".vbox-content").length && setTimeout(y(), 800)
                })
            })
        }
    })
}(jQuery);
}